var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _Gr$default, _templateObject40;
var _excluded = ["mainAxis", "crossAxis", "fallbackPlacements", "fallbackStrategy", "fallbackAxisSideDirection", "flipAlignment"],
  _excluded2 = ["mainAxis", "crossAxis", "limiter"],
  _excluded3 = ["transform"],
  _excluded4 = ["context", "width", "height", "tipRadius", "strokeWidth", "staticOffset", "stroke", "d", "style"],
  _excluded5 = ["a11yTitle"],
  _excluded6 = ["size", "disabled", "onClick", "children", "LeftIcon", "RightIcon", "tabIndex", "fit", "name", "value", "className", "type"],
  _excluded7 = ["as"],
  _excluded8 = ["children"],
  _excluded9 = ["children"],
  _excluded10 = ["children"],
  _excluded11 = ["children"],
  _excluded12 = ["value", "placeholder", "label", "option", "render", "compact", "onChange", "onKeyUp", "onError", "onValid", "onValidation", "autofocus", "alt", "disabled", "validation", "type", "readOnly", "minLength", "maxLength", "max", "min", "step", "validateOnMount", "name", "autocomplete"],
  _excluded13 = ["isPasswordVisible", "onClick", "autocomplete"],
  _excluded14 = ["value", "label", "option", "compact", "autofocus", "className", "resizable"],
  _excluded15 = ["formattedValue", "disabled", "dateSelected", "active", "placeholderText"],
  _excluded16 = ["type"],
  _excluded17 = ["type", "disabled", "minDate", "maxDate", "onChange", "flip", "preventOverflow", "placeholderText", "portalId", "onCalendarVisibilityChange", "freezeStartDate", "label", "startDate", "endDate", "customInput", "popperPlacement", "popperOffset"];
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
(function () {
  "use strict";

  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";.react-datepicker__navigation-icon:before,.react-datepicker__year-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow{border-color:#ccc;border-style:solid;border-width:3px 3px 0 0;content:"";display:block;height:9px;position:absolute;top:6px;width:9px}.react-datepicker-wrapper{display:inline-block;padding:0;border:0}.react-datepicker{font-family:Helvetica Neue,helvetica,arial,sans-serif;font-size:.8rem;background-color:#fff;color:#000;border:1px solid #aeaeae;border-radius:.3rem;display:inline-block;position:relative;line-height:initial}.react-datepicker--time-only .react-datepicker__time-container{border-left:0}.react-datepicker--time-only .react-datepicker__time,.react-datepicker--time-only .react-datepicker__time-box{border-bottom-left-radius:.3rem;border-bottom-right-radius:.3rem}.react-datepicker-popper{z-index:1;line-height:0}.react-datepicker-popper .react-datepicker__triangle{stroke:#aeaeae}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle{fill:#f0f0f0;color:#f0f0f0}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle{fill:#fff;color:#fff}.react-datepicker__header{text-align:center;background-color:#f0f0f0;border-bottom:1px solid #aeaeae;border-top-left-radius:.3rem;padding:8px 0;position:relative}.react-datepicker__header--time{padding-bottom:8px;padding-left:5px;padding-right:5px}.react-datepicker__header--time:not(.react-datepicker__header--time--only){border-top-left-radius:0}.react-datepicker__header:not(.react-datepicker__header--has-time-select){border-top-right-radius:.3rem}.react-datepicker__year-dropdown-container--select,.react-datepicker__month-dropdown-container--select,.react-datepicker__month-year-dropdown-container--select,.react-datepicker__year-dropdown-container--scroll,.react-datepicker__month-dropdown-container--scroll,.react-datepicker__month-year-dropdown-container--scroll{display:inline-block;margin:0 15px}.react-datepicker__current-month,.react-datepicker-time__header,.react-datepicker-year-header{margin-top:0;color:#000;font-weight:700;font-size:.944rem}h2.react-datepicker__current-month{padding:0;margin:0}.react-datepicker-time__header{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.react-datepicker__navigation{align-items:center;background:none;display:flex;justify-content:center;text-align:center;cursor:pointer;position:absolute;top:2px;padding:0;border:none;z-index:1;height:32px;width:32px;text-indent:-999em;overflow:hidden}.react-datepicker__navigation--previous{left:2px}.react-datepicker__navigation--next{right:2px}.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button){right:85px}.react-datepicker__navigation--years{position:relative;top:0;display:block;margin-left:auto;margin-right:auto}.react-datepicker__navigation--years-previous{top:4px}.react-datepicker__navigation--years-upcoming{top:-4px}.react-datepicker__navigation:hover *:before{border-color:#a6a6a6}.react-datepicker__navigation-icon{position:relative;top:-1px;font-size:20px;width:0}.react-datepicker__navigation-icon--next{left:-2px}.react-datepicker__navigation-icon--next:before{transform:rotate(45deg);left:-7px}.react-datepicker__navigation-icon--previous{right:-2px}.react-datepicker__navigation-icon--previous:before{transform:rotate(225deg);right:-7px}.react-datepicker__month-container{float:left}.react-datepicker__year{margin:.4rem;text-align:center}.react-datepicker__year-wrapper{display:flex;flex-wrap:wrap;max-width:180px}.react-datepicker__year .react-datepicker__year-text{display:inline-block;width:4rem;margin:2px}.react-datepicker__month{margin:.4rem;text-align:center}.react-datepicker__month .react-datepicker__month-text,.react-datepicker__month .react-datepicker__quarter-text{display:inline-block;width:4rem;margin:2px}.react-datepicker__input-time-container{clear:both;width:100%;float:left;margin:5px 0 10px 15px;text-align:left}.react-datepicker__input-time-container .react-datepicker-time__caption,.react-datepicker__input-time-container .react-datepicker-time__input-container{display:inline-block}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input{display:inline-block;margin-left:10px}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input{width:auto}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-inner-spin-button,.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]{-moz-appearance:textfield}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter{margin-left:5px;display:inline-block}.react-datepicker__time-container{float:right;border-left:1px solid #aeaeae;width:85px}.react-datepicker__time-container--with-today-button{display:inline;border:1px solid #aeaeae;border-radius:.3rem;position:absolute;right:-87px;top:0}.react-datepicker__time-container .react-datepicker__time{position:relative;background:#fff;border-bottom-right-radius:.3rem}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box{width:85px;overflow-x:hidden;margin:0 auto;text-align:center;border-bottom-right-radius:.3rem}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list{list-style:none;margin:0;height:calc(195px + .85rem);overflow-y:scroll;padding-right:0;padding-left:0;width:100%;box-sizing:content-box}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item{height:30px;padding:5px 10px;white-space:nowrap}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover{cursor:pointer;background-color:#f0f0f0}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected{background-color:#216ba5;color:#fff;font-weight:700}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover{background-color:#216ba5}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled{color:#ccc}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover{cursor:default;background-color:transparent}.react-datepicker__week-number{color:#ccc;display:inline-block;width:1.7rem;line-height:1.7rem;text-align:center;margin:.166rem}.react-datepicker__week-number.react-datepicker__week-number--clickable{cursor:pointer}.react-datepicker__week-number.react-datepicker__week-number--clickable:not(.react-datepicker__week-number--selected):hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__week-number--selected{border-radius:.3rem;background-color:#216ba5;color:#fff}.react-datepicker__week-number--selected:hover{background-color:#1d5d90}.react-datepicker__day-names{white-space:nowrap;margin-bottom:-8px}.react-datepicker__week{white-space:nowrap}.react-datepicker__day-name,.react-datepicker__day,.react-datepicker__time-name{color:#000;display:inline-block;width:1.7rem;line-height:1.7rem;text-align:center;margin:.166rem}.react-datepicker__day,.react-datepicker__month-text,.react-datepicker__quarter-text,.react-datepicker__year-text{cursor:pointer}.react-datepicker__day:not([aria-disabled=true]):hover,.react-datepicker__month-text:not([aria-disabled=true]):hover,.react-datepicker__quarter-text:not([aria-disabled=true]):hover,.react-datepicker__year-text:not([aria-disabled=true]):hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__day--today,.react-datepicker__month-text--today,.react-datepicker__quarter-text--today,.react-datepicker__year-text--today{font-weight:700}.react-datepicker__day--highlighted,.react-datepicker__month-text--highlighted,.react-datepicker__quarter-text--highlighted,.react-datepicker__year-text--highlighted{border-radius:.3rem;background-color:#3dcc4a;color:#fff}.react-datepicker__day--highlighted:not([aria-disabled=true]):hover,.react-datepicker__month-text--highlighted:not([aria-disabled=true]):hover,.react-datepicker__quarter-text--highlighted:not([aria-disabled=true]):hover,.react-datepicker__year-text--highlighted:not([aria-disabled=true]):hover{background-color:#32be3f}.react-datepicker__day--highlighted-custom-1,.react-datepicker__month-text--highlighted-custom-1,.react-datepicker__quarter-text--highlighted-custom-1,.react-datepicker__year-text--highlighted-custom-1{color:#f0f}.react-datepicker__day--highlighted-custom-2,.react-datepicker__month-text--highlighted-custom-2,.react-datepicker__quarter-text--highlighted-custom-2,.react-datepicker__year-text--highlighted-custom-2{color:green}.react-datepicker__day--holidays,.react-datepicker__month-text--holidays,.react-datepicker__quarter-text--holidays,.react-datepicker__year-text--holidays{position:relative;border-radius:.3rem;background-color:#ff6803;color:#fff}.react-datepicker__day--holidays .overlay,.react-datepicker__month-text--holidays .overlay,.react-datepicker__quarter-text--holidays .overlay,.react-datepicker__year-text--holidays .overlay{position:absolute;bottom:100%;left:50%;transform:translate(-50%);background-color:#333;color:#fff;padding:4px;border-radius:4px;white-space:nowrap;visibility:hidden;opacity:0;transition:visibility 0s,opacity .3s ease-in-out}.react-datepicker__day--holidays:not([aria-disabled=true]):hover,.react-datepicker__month-text--holidays:not([aria-disabled=true]):hover,.react-datepicker__quarter-text--holidays:not([aria-disabled=true]):hover,.react-datepicker__year-text--holidays:not([aria-disabled=true]):hover{background-color:#cf5300}.react-datepicker__day--holidays:hover .overlay,.react-datepicker__month-text--holidays:hover .overlay,.react-datepicker__quarter-text--holidays:hover .overlay,.react-datepicker__year-text--holidays:hover .overlay{visibility:visible;opacity:1}.react-datepicker__day--selected,.react-datepicker__day--in-selecting-range,.react-datepicker__day--in-range,.react-datepicker__month-text--selected,.react-datepicker__month-text--in-selecting-range,.react-datepicker__month-text--in-range,.react-datepicker__quarter-text--selected,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__quarter-text--in-range,.react-datepicker__year-text--selected,.react-datepicker__year-text--in-selecting-range,.react-datepicker__year-text--in-range{border-radius:.3rem;background-color:#216ba5;color:#fff}.react-datepicker__day--selected:not([aria-disabled=true]):hover,.react-datepicker__day--in-selecting-range:not([aria-disabled=true]):hover,.react-datepicker__day--in-range:not([aria-disabled=true]):hover,.react-datepicker__month-text--selected:not([aria-disabled=true]):hover,.react-datepicker__month-text--in-selecting-range:not([aria-disabled=true]):hover,.react-datepicker__month-text--in-range:not([aria-disabled=true]):hover,.react-datepicker__quarter-text--selected:not([aria-disabled=true]):hover,.react-datepicker__quarter-text--in-selecting-range:not([aria-disabled=true]):hover,.react-datepicker__quarter-text--in-range:not([aria-disabled=true]):hover,.react-datepicker__year-text--selected:not([aria-disabled=true]):hover,.react-datepicker__year-text--in-selecting-range:not([aria-disabled=true]):hover,.react-datepicker__year-text--in-range:not([aria-disabled=true]):hover{background-color:#1d5d90}.react-datepicker__day--keyboard-selected,.react-datepicker__month-text--keyboard-selected,.react-datepicker__quarter-text--keyboard-selected,.react-datepicker__year-text--keyboard-selected{border-radius:.3rem;background-color:#bad9f1;color:#000}.react-datepicker__day--keyboard-selected:not([aria-disabled=true]):hover,.react-datepicker__month-text--keyboard-selected:not([aria-disabled=true]):hover,.react-datepicker__quarter-text--keyboard-selected:not([aria-disabled=true]):hover,.react-datepicker__year-text--keyboard-selected:not([aria-disabled=true]):hover{background-color:#1d5d90}.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,.react-datepicker__month-text--in-range,.react-datepicker__quarter-text--in-range,.react-datepicker__year-text--in-range),.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range,.react-datepicker__month-text--in-range,.react-datepicker__quarter-text--in-range,.react-datepicker__year-text--in-range),.react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range,.react-datepicker__month-text--in-range,.react-datepicker__quarter-text--in-range,.react-datepicker__year-text--in-range),.react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range,.react-datepicker__month-text--in-range,.react-datepicker__quarter-text--in-range,.react-datepicker__year-text--in-range){background-color:#216ba580}.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range),.react-datepicker__year--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range),.react-datepicker__month--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range),.react-datepicker__year--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range),.react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range),.react-datepicker__year--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range),.react-datepicker__month--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range),.react-datepicker__year--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range){background-color:#f0f0f0;color:#000}.react-datepicker__day--disabled,.react-datepicker__month-text--disabled,.react-datepicker__quarter-text--disabled,.react-datepicker__year-text--disabled{cursor:default;color:#ccc}.react-datepicker__day--disabled .overlay,.react-datepicker__month-text--disabled .overlay,.react-datepicker__quarter-text--disabled .overlay,.react-datepicker__year-text--disabled .overlay{position:absolute;bottom:70%;left:50%;transform:translate(-50%);background-color:#333;color:#fff;padding:4px;border-radius:4px;white-space:nowrap;visibility:hidden;opacity:0;transition:visibility 0s,opacity .3s ease-in-out}.react-datepicker__input-container{position:relative;display:inline-block;width:100%}.react-datepicker__input-container .react-datepicker__calendar-icon{position:absolute;padding:.5rem;box-sizing:content-box}.react-datepicker__view-calendar-icon input{padding:6px 10px 5px 25px}.react-datepicker__year-read-view,.react-datepicker__month-read-view,.react-datepicker__month-year-read-view{border:1px solid transparent;border-radius:.3rem;position:relative}.react-datepicker__year-read-view:hover,.react-datepicker__month-read-view:hover,.react-datepicker__month-year-read-view:hover{cursor:pointer}.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow{border-top-color:#b3b3b3}.react-datepicker__year-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow{transform:rotate(135deg);right:-16px;top:0}.react-datepicker__year-dropdown,.react-datepicker__month-dropdown,.react-datepicker__month-year-dropdown{background-color:#f0f0f0;position:absolute;width:50%;left:25%;top:30px;z-index:1;text-align:center;border-radius:.3rem;border:1px solid #aeaeae}.react-datepicker__year-dropdown:hover,.react-datepicker__month-dropdown:hover,.react-datepicker__month-year-dropdown:hover{cursor:pointer}.react-datepicker__year-dropdown--scrollable,.react-datepicker__month-dropdown--scrollable,.react-datepicker__month-year-dropdown--scrollable{height:150px;overflow-y:scroll}.react-datepicker__year-option,.react-datepicker__month-option,.react-datepicker__month-year-option{line-height:20px;width:100%;display:block;margin-left:auto;margin-right:auto}.react-datepicker__year-option:first-of-type,.react-datepicker__month-option:first-of-type,.react-datepicker__month-year-option:first-of-type{border-top-left-radius:.3rem;border-top-right-radius:.3rem}.react-datepicker__year-option:last-of-type,.react-datepicker__month-option:last-of-type,.react-datepicker__month-year-option:last-of-type{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-bottom-left-radius:.3rem;border-bottom-right-radius:.3rem}.react-datepicker__year-option:hover,.react-datepicker__month-option:hover,.react-datepicker__month-year-option:hover{background-color:#ccc}.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming{border-bottom-color:#b3b3b3}.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous{border-top-color:#b3b3b3}.react-datepicker__year-option--selected,.react-datepicker__month-option--selected,.react-datepicker__month-year-option--selected{position:absolute;left:15px}.react-datepicker__close-icon{cursor:pointer;background-color:transparent;border:0;outline:0;padding:0 6px 0 0;position:absolute;top:0;right:0;height:100%;display:table-cell;vertical-align:middle}.react-datepicker__close-icon:after{cursor:pointer;background-color:#216ba5;color:#fff;border-radius:50%;height:16px;width:16px;padding:2px;font-size:12px;line-height:1;text-align:center;display:table-cell;vertical-align:middle;content:"×"}.react-datepicker__close-icon--disabled{cursor:default}.react-datepicker__close-icon--disabled:after{cursor:default;background-color:#ccc}.react-datepicker__today-button{background:#f0f0f0;border-top:1px solid #aeaeae;cursor:pointer;text-align:center;font-weight:700;padding:5px 0;clear:left}.react-datepicker__portal{position:fixed;width:100vw;height:100vh;background-color:#000c;left:0;top:0;justify-content:center;align-items:center;display:flex;z-index:2147483647}.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__time-name{width:3rem;line-height:3rem}@media (max-width: 400px),(max-height: 550px){.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__time-name{width:2rem;line-height:2rem}}.react-datepicker__portal .react-datepicker__current-month,.react-datepicker__portal .react-datepicker-time__header{font-size:1.44rem}.react-datepicker__children-container{width:13.8rem;margin:.4rem;padding-right:.2rem;padding-left:.2rem;height:auto}.react-datepicker__aria-live{position:absolute;clip-path:circle(0);border:0;height:1px;margin:-1px;overflow:hidden;padding:0;width:1px;white-space:nowrap}.react-datepicker__calendar-icon{width:1em;height:1em;vertical-align:-.125em}')), document.head.appendChild(e);
    }
  } catch (t) {
    console.error("vite-plugin-css-injected-by-js", t);
  }
})();
var ko = Object.defineProperty;
var xo = function xo(n, r, t) {
  return r in n ? ko(n, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : n[r] = t;
};
var C = function C(n, r, t) {
  return xo(n, typeof r != "symbol" ? r + "" : r, t);
};
import { jsxs as pe, jsx as _, Fragment as _o } from "react/jsx-runtime";
import * as Y from "react";
import m, { useLayoutEffect as na, useEffect as Ue, createElement as Mo, cloneElement as ra, Component as oe, createRef as Be, useRef as Fn, useCallback as aa, forwardRef as ce, useState as In } from "react";
import * as Co from "react-dom";
import So from "react-dom";
import { createGlobalStyle as oa, styled as I, css as J } from "styled-components";
var ia = 6048e5,
  Po = 864e5,
  cr = Symbol.for("constructDateFrom");
function Qe(n, r) {
  return typeof n == "function" ? n(r) : n && typeof n == "object" && cr in n ? n[cr](r) : n instanceof Date ? new n.constructor(r) : new Date(r);
}
function ge(n, r) {
  return Qe(r || n, n);
}
var Eo = {};
function gn() {
  return Eo;
}
function ft(n, r) {
  var _ref, _ref2, _ref3, _ref4;
  var s, c, l, u;
  var t = gn(),
    e = (_ref = (_ref2 = (_ref3 = (_ref4 = r == null ? void 0 : r.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : (c = (s = r == null ? void 0 : r.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : t.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (u = (l = t.locale) == null ? void 0 : l.options) == null ? void 0 : u.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0,
    a = ge(n, r == null ? void 0 : r.in),
    o = a.getDay(),
    i = (o < e ? 7 : 0) + o - e;
  return a.setDate(a.getDate() - i), a.setHours(0, 0, 0, 0), a;
}
function Jt(n, r) {
  return ft(n, _objectSpread(_objectSpread({}, r), {}, {
    weekStartsOn: 1
  }));
}
function sa(n, r) {
  var t = ge(n, r == null ? void 0 : r.in),
    e = t.getFullYear(),
    a = Qe(t, 0);
  a.setFullYear(e + 1, 0, 4), a.setHours(0, 0, 0, 0);
  var o = Jt(a),
    i = Qe(t, 0);
  i.setFullYear(e, 0, 4), i.setHours(0, 0, 0, 0);
  var s = Jt(i);
  return t.getTime() >= o.getTime() ? e + 1 : t.getTime() >= s.getTime() ? e : e - 1;
}
function lr(n) {
  var r = ge(n),
    t = new Date(Date.UTC(r.getFullYear(), r.getMonth(), r.getDate(), r.getHours(), r.getMinutes(), r.getSeconds(), r.getMilliseconds()));
  return t.setUTCFullYear(r.getFullYear()), +n - +t;
}
function vn(n) {
  for (var _len = arguments.length, r = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    r[_key - 1] = arguments[_key];
  }
  var t = Qe.bind(null, r.find(function (e) {
    return typeof e == "object";
  }));
  return r.map(t);
}
function en(n, r) {
  var t = ge(n, r == null ? void 0 : r.in);
  return t.setHours(0, 0, 0, 0), t;
}
function ca(n, r, t) {
  var _vn = vn(t == null ? void 0 : t.in, n, r),
    _vn2 = _slicedToArray(_vn, 2),
    e = _vn2[0],
    a = _vn2[1],
    o = en(e),
    i = en(a),
    s = +o - lr(o),
    c = +i - lr(i);
  return Math.round((s - c) / Po);
}
function Oo(n, r) {
  var t = sa(n, r),
    e = Qe(n, 0);
  return e.setFullYear(t, 0, 4), e.setHours(0, 0, 0, 0), Jt(e);
}
function $n(n, r, t) {
  var _vn3 = vn(t == null ? void 0 : t.in, n, r),
    _vn4 = _slicedToArray(_vn3, 2),
    e = _vn4[0],
    a = _vn4[1];
  return +en(e) == +en(a);
}
function To(n) {
  return n instanceof Date || typeof n == "object" && Object.prototype.toString.call(n) === "[object Date]";
}
function No(n) {
  return !(!To(n) && typeof n != "number" || isNaN(+ge(n)));
}
function la(n, r, t) {
  var _vn5 = vn(t == null ? void 0 : t.in, n, r),
    _vn6 = _slicedToArray(_vn5, 2),
    e = _vn6[0],
    a = _vn6[1],
    o = ur(e, a),
    i = Math.abs(ca(e, a));
  e.setDate(e.getDate() - o * i);
  var s = +(ur(e, a) === -o),
    c = o * (i - s);
  return c === 0 ? 0 : c;
}
function ur(n, r) {
  var t = n.getFullYear() - r.getFullYear() || n.getMonth() - r.getMonth() || n.getDate() - r.getDate() || n.getHours() - r.getHours() || n.getMinutes() - r.getMinutes() || n.getSeconds() - r.getSeconds() || n.getMilliseconds() - r.getMilliseconds();
  return t < 0 ? -1 : t > 0 ? 1 : t;
}
function Yo(n, r) {
  var t = ge(n, r == null ? void 0 : r.in);
  return t.setFullYear(t.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function Ro(n, r) {
  var t = r == null ? void 0 : r.weekStartsOn,
    e = ge(n, r == null ? void 0 : r.in),
    a = e.getDay(),
    o = (a < t ? -7 : 0) + 6 - (a - t);
  return e.setDate(e.getDate() + o), e.setHours(23, 59, 59, 999), e;
}
var Lo = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about 1 week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  },
  Fo = function Fo(n, r, t) {
    var e;
    var a = Lo[n];
    return typeof a == "string" ? e = a : r === 1 ? e = a.one : e = a.other.replace("{{count}}", r.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + e : e + " ago" : e;
  };
function Mn(n) {
  return function () {
    var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var t = r.width ? String(r.width) : n.defaultWidth;
    return n.formats[t] || n.formats[n.defaultWidth];
  };
}
var Io = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
  },
  $o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  },
  Wo = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  },
  Ao = {
    date: Mn({
      formats: Io,
      defaultWidth: "full"
    }),
    time: Mn({
      formats: $o,
      defaultWidth: "full"
    }),
    dateTime: Mn({
      formats: Wo,
      defaultWidth: "full"
    })
  },
  Ho = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  },
  Bo = function Bo(n, r, t, e) {
    return Ho[n];
  };
function yt(n) {
  return function (r, t) {
    var e = t != null && t.context ? String(t.context) : "standalone";
    var a;
    if (e === "formatting" && n.formattingValues) {
      var i = n.defaultFormattingWidth || n.defaultWidth,
        s = t != null && t.width ? String(t.width) : i;
      a = n.formattingValues[s] || n.formattingValues[i];
    } else {
      var _i2 = n.defaultWidth,
        _s2 = t != null && t.width ? String(t.width) : n.defaultWidth;
      a = n.values[_s2] || n.values[_i2];
    }
    var o = n.argumentCallback ? n.argumentCallback(r) : r;
    return a[o];
  };
}
var Qo = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"]
  },
  Vo = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
  },
  qo = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  },
  Ko = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  },
  jo = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }
  },
  zo = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    }
  },
  Uo = function Uo(n, r) {
    var t = Number(n),
      e = t % 100;
    if (e > 20 || e < 10) switch (e % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
    return t + "th";
  },
  Xo = {
    ordinalNumber: Uo,
    era: yt({
      values: Qo,
      defaultWidth: "wide"
    }),
    quarter: yt({
      values: Vo,
      defaultWidth: "wide",
      argumentCallback: function argumentCallback(n) {
        return n - 1;
      }
    }),
    month: yt({
      values: qo,
      defaultWidth: "wide"
    }),
    day: yt({
      values: Ko,
      defaultWidth: "wide"
    }),
    dayPeriod: yt({
      values: jo,
      defaultWidth: "wide",
      formattingValues: zo,
      defaultFormattingWidth: "wide"
    })
  };
function Dt(n) {
  return function (r) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var e = t.width,
      a = e && n.matchPatterns[e] || n.matchPatterns[n.defaultMatchWidth],
      o = r.match(a);
    if (!o) return null;
    var i = o[0],
      s = e && n.parsePatterns[e] || n.parsePatterns[n.defaultParseWidth],
      c = Array.isArray(s) ? Zo(s, function (d) {
        return d.test(i);
      }) :
      // [TODO] -- I challenge you to fix the type
      Go(s, function (d) {
        return d.test(i);
      });
    var l;
    l = n.valueCallback ? n.valueCallback(c) : c, l = t.valueCallback ?
    // [TODO] -- I challenge you to fix the type
    t.valueCallback(l) : l;
    var u = r.slice(i.length);
    return {
      value: l,
      rest: u
    };
  };
}
function Go(n, r) {
  for (var t in n) {
    if (Object.prototype.hasOwnProperty.call(n, t) && r(n[t])) return t;
  }
}
function Zo(n, r) {
  for (var t = 0; t < n.length; t++) {
    if (r(n[t])) return t;
  }
}
function Jo(n) {
  return function (r) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var e = r.match(n.matchPattern);
    if (!e) return null;
    var a = e[0],
      o = r.match(n.parsePattern);
    if (!o) return null;
    var i = n.valueCallback ? n.valueCallback(o[0]) : o[0];
    i = t.valueCallback ? t.valueCallback(i) : i;
    var s = r.slice(a.length);
    return {
      value: i,
      rest: s
    };
  };
}
var ei = /^(\d+)(th|st|nd|rd)?/i,
  ti = /\d+/i,
  ni = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  },
  ri = {
    any: [/^b/i, /^(a|c)/i]
  },
  ai = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  },
  oi = {
    any: [/1/i, /2/i, /3/i, /4/i]
  },
  ii = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  },
  si = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  },
  ci = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  },
  li = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  },
  ui = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  },
  di = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  },
  fi = {
    ordinalNumber: Jo({
      matchPattern: ei,
      parsePattern: ti,
      valueCallback: function valueCallback(n) {
        return parseInt(n, 10);
      }
    }),
    era: Dt({
      matchPatterns: ni,
      defaultMatchWidth: "wide",
      parsePatterns: ri,
      defaultParseWidth: "any"
    }),
    quarter: Dt({
      matchPatterns: ai,
      defaultMatchWidth: "wide",
      parsePatterns: oi,
      defaultParseWidth: "any",
      valueCallback: function valueCallback(n) {
        return n + 1;
      }
    }),
    month: Dt({
      matchPatterns: ii,
      defaultMatchWidth: "wide",
      parsePatterns: si,
      defaultParseWidth: "any"
    }),
    day: Dt({
      matchPatterns: ci,
      defaultMatchWidth: "wide",
      parsePatterns: li,
      defaultParseWidth: "any"
    }),
    dayPeriod: Dt({
      matchPatterns: ui,
      defaultMatchWidth: "any",
      parsePatterns: di,
      defaultParseWidth: "any"
    })
  },
  pi = {
    code: "en-US",
    formatDistance: Fo,
    formatLong: Ao,
    formatRelative: Bo,
    localize: Xo,
    match: fi,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  };
function hi(n, r) {
  var t = ge(n, r == null ? void 0 : r.in);
  return ca(t, Yo(t)) + 1;
}
function mi(n, r) {
  var t = ge(n, r == null ? void 0 : r.in),
    e = +Jt(t) - +Oo(t);
  return Math.round(e / ia) + 1;
}
function ua(n, r) {
  var _ref5, _ref6, _ref7, _ref8;
  var u, d, f, p;
  var t = ge(n, r == null ? void 0 : r.in),
    e = t.getFullYear(),
    a = gn(),
    o = (_ref5 = (_ref6 = (_ref7 = (_ref8 = r == null ? void 0 : r.firstWeekContainsDate) !== null && _ref8 !== void 0 ? _ref8 : (d = (u = r == null ? void 0 : r.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) !== null && _ref7 !== void 0 ? _ref7 : a.firstWeekContainsDate) !== null && _ref6 !== void 0 ? _ref6 : (p = (f = a.locale) == null ? void 0 : f.options) == null ? void 0 : p.firstWeekContainsDate) !== null && _ref5 !== void 0 ? _ref5 : 1,
    i = Qe((r == null ? void 0 : r.in) || n, 0);
  i.setFullYear(e + 1, 0, o), i.setHours(0, 0, 0, 0);
  var s = ft(i, r),
    c = Qe((r == null ? void 0 : r.in) || n, 0);
  c.setFullYear(e, 0, o), c.setHours(0, 0, 0, 0);
  var l = ft(c, r);
  return +t >= +s ? e + 1 : +t >= +l ? e : e - 1;
}
function gi(n, r) {
  var _ref9, _ref10, _ref11, _ref12;
  var s, c, l, u;
  var t = gn(),
    e = (_ref9 = (_ref10 = (_ref11 = (_ref12 = r == null ? void 0 : r.firstWeekContainsDate) !== null && _ref12 !== void 0 ? _ref12 : (c = (s = r == null ? void 0 : r.locale) == null ? void 0 : s.options) == null ? void 0 : c.firstWeekContainsDate) !== null && _ref11 !== void 0 ? _ref11 : t.firstWeekContainsDate) !== null && _ref10 !== void 0 ? _ref10 : (u = (l = t.locale) == null ? void 0 : l.options) == null ? void 0 : u.firstWeekContainsDate) !== null && _ref9 !== void 0 ? _ref9 : 1,
    a = ua(n, r),
    o = Qe((r == null ? void 0 : r.in) || n, 0);
  return o.setFullYear(a, 0, e), o.setHours(0, 0, 0, 0), ft(o, r);
}
function vi(n, r) {
  var t = ge(n, r == null ? void 0 : r.in),
    e = +ft(t, r) - +gi(t, r);
  return Math.round(e / ia) + 1;
}
function _K(n, r) {
  var t = n < 0 ? "-" : "",
    e = Math.abs(n).toString().padStart(r, "0");
  return t + e;
}
var $e = {
    // Year
    y(n, r) {
      var t = n.getFullYear(),
        e = t > 0 ? t : 1 - t;
      return _K(r === "yy" ? e % 100 : e, r.length);
    },
    // Month
    M(n, r) {
      var t = n.getMonth();
      return r === "M" ? String(t + 1) : _K(t + 1, 2);
    },
    // Day of the month
    d(n, r) {
      return _K(n.getDate(), r.length);
    },
    // AM or PM
    a(n, r) {
      var t = n.getHours() / 12 >= 1 ? "pm" : "am";
      switch (r) {
        case "a":
        case "aa":
          return t.toUpperCase();
        case "aaa":
          return t;
        case "aaaaa":
          return t[0];
        case "aaaa":
        default:
          return t === "am" ? "a.m." : "p.m.";
      }
    },
    // Hour [1-12]
    h(n, r) {
      return _K(n.getHours() % 12 || 12, r.length);
    },
    // Hour [0-23]
    H(n, r) {
      return _K(n.getHours(), r.length);
    },
    // Minute
    m(n, r) {
      return _K(n.getMinutes(), r.length);
    },
    // Second
    s(n, r) {
      return _K(n.getSeconds(), r.length);
    },
    // Fraction of second
    S(n, r) {
      var t = r.length,
        e = n.getMilliseconds(),
        a = Math.trunc(e * Math.pow(10, t - 3));
      return _K(a, r.length);
    }
  },
  it = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  dr = {
    // Era
    G: function G(n, r, t) {
      var e = n.getFullYear() > 0 ? 1 : 0;
      switch (r) {
        // AD, BC
        case "G":
        case "GG":
        case "GGG":
          return t.era(e, {
            width: "abbreviated"
          });
        // A, B
        case "GGGGG":
          return t.era(e, {
            width: "narrow"
          });
        // Anno Domini, Before Christ
        case "GGGG":
        default:
          return t.era(e, {
            width: "wide"
          });
      }
    },
    // Year
    y: function y(n, r, t) {
      if (r === "yo") {
        var e = n.getFullYear(),
          a = e > 0 ? e : 1 - e;
        return t.ordinalNumber(a, {
          unit: "year"
        });
      }
      return $e.y(n, r);
    },
    // Local week-numbering year
    Y: function Y(n, r, t, e) {
      var a = ua(n, e),
        o = a > 0 ? a : 1 - a;
      if (r === "YY") {
        var i = o % 100;
        return _K(i, 2);
      }
      return r === "Yo" ? t.ordinalNumber(o, {
        unit: "year"
      }) : _K(o, r.length);
    },
    // ISO week-numbering year
    R: function R(n, r) {
      var t = sa(n);
      return _K(t, r.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(n, r) {
      var t = n.getFullYear();
      return _K(t, r.length);
    },
    // Quarter
    Q: function Q(n, r, t) {
      var e = Math.ceil((n.getMonth() + 1) / 3);
      switch (r) {
        // 1, 2, 3, 4
        case "Q":
          return String(e);
        // 01, 02, 03, 04
        case "QQ":
          return _K(e, 2);
        // 1st, 2nd, 3rd, 4th
        case "Qo":
          return t.ordinalNumber(e, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "QQQ":
          return t.quarter(e, {
            width: "abbreviated",
            context: "formatting"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "QQQQQ":
          return t.quarter(e, {
            width: "narrow",
            context: "formatting"
          });
        // 1st quarter, 2nd quarter, ...
        case "QQQQ":
        default:
          return t.quarter(e, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone quarter
    q: function q(n, r, t) {
      var e = Math.ceil((n.getMonth() + 1) / 3);
      switch (r) {
        // 1, 2, 3, 4
        case "q":
          return String(e);
        // 01, 02, 03, 04
        case "qq":
          return _K(e, 2);
        // 1st, 2nd, 3rd, 4th
        case "qo":
          return t.ordinalNumber(e, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "qqq":
          return t.quarter(e, {
            width: "abbreviated",
            context: "standalone"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "qqqqq":
          return t.quarter(e, {
            width: "narrow",
            context: "standalone"
          });
        // 1st quarter, 2nd quarter, ...
        case "qqqq":
        default:
          return t.quarter(e, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Month
    M: function M(n, r, t) {
      var e = n.getMonth();
      switch (r) {
        case "M":
        case "MM":
          return $e.M(n, r);
        // 1st, 2nd, ..., 12th
        case "Mo":
          return t.ordinalNumber(e + 1, {
            unit: "month"
          });
        // Jan, Feb, ..., Dec
        case "MMM":
          return t.month(e, {
            width: "abbreviated",
            context: "formatting"
          });
        // J, F, ..., D
        case "MMMMM":
          return t.month(e, {
            width: "narrow",
            context: "formatting"
          });
        // January, February, ..., December
        case "MMMM":
        default:
          return t.month(e, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone month
    L: function L(n, r, t) {
      var e = n.getMonth();
      switch (r) {
        // 1, 2, ..., 12
        case "L":
          return String(e + 1);
        // 01, 02, ..., 12
        case "LL":
          return _K(e + 1, 2);
        // 1st, 2nd, ..., 12th
        case "Lo":
          return t.ordinalNumber(e + 1, {
            unit: "month"
          });
        // Jan, Feb, ..., Dec
        case "LLL":
          return t.month(e, {
            width: "abbreviated",
            context: "standalone"
          });
        // J, F, ..., D
        case "LLLLL":
          return t.month(e, {
            width: "narrow",
            context: "standalone"
          });
        // January, February, ..., December
        case "LLLL":
        default:
          return t.month(e, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Local week of year
    w: function w(n, r, t, e) {
      var a = vi(n, e);
      return r === "wo" ? t.ordinalNumber(a, {
        unit: "week"
      }) : _K(a, r.length);
    },
    // ISO week of year
    I: function I(n, r, t) {
      var e = mi(n);
      return r === "Io" ? t.ordinalNumber(e, {
        unit: "week"
      }) : _K(e, r.length);
    },
    // Day of the month
    d: function d(n, r, t) {
      return r === "do" ? t.ordinalNumber(n.getDate(), {
        unit: "date"
      }) : $e.d(n, r);
    },
    // Day of year
    D: function D(n, r, t) {
      var e = hi(n);
      return r === "Do" ? t.ordinalNumber(e, {
        unit: "dayOfYear"
      }) : _K(e, r.length);
    },
    // Day of week
    E: function E(n, r, t) {
      var e = n.getDay();
      switch (r) {
        // Tue
        case "E":
        case "EE":
        case "EEE":
          return t.day(e, {
            width: "abbreviated",
            context: "formatting"
          });
        // T
        case "EEEEE":
          return t.day(e, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "EEEEEE":
          return t.day(e, {
            width: "short",
            context: "formatting"
          });
        // Tuesday
        case "EEEE":
        default:
          return t.day(e, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Local day of week
    e: function e(n, r, t, _e2) {
      var a = n.getDay(),
        o = (a - _e2.weekStartsOn + 8) % 7 || 7;
      switch (r) {
        // Numerical value (Nth day of week with current locale or weekStartsOn)
        case "e":
          return String(o);
        // Padded numerical value
        case "ee":
          return _K(o, 2);
        // 1st, 2nd, ..., 7th
        case "eo":
          return t.ordinalNumber(o, {
            unit: "day"
          });
        case "eee":
          return t.day(a, {
            width: "abbreviated",
            context: "formatting"
          });
        // T
        case "eeeee":
          return t.day(a, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "eeeeee":
          return t.day(a, {
            width: "short",
            context: "formatting"
          });
        // Tuesday
        case "eeee":
        default:
          return t.day(a, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone local day of week
    c: function c(n, r, t, e) {
      var a = n.getDay(),
        o = (a - e.weekStartsOn + 8) % 7 || 7;
      switch (r) {
        // Numerical value (same as in `e`)
        case "c":
          return String(o);
        // Padded numerical value
        case "cc":
          return _K(o, r.length);
        // 1st, 2nd, ..., 7th
        case "co":
          return t.ordinalNumber(o, {
            unit: "day"
          });
        case "ccc":
          return t.day(a, {
            width: "abbreviated",
            context: "standalone"
          });
        // T
        case "ccccc":
          return t.day(a, {
            width: "narrow",
            context: "standalone"
          });
        // Tu
        case "cccccc":
          return t.day(a, {
            width: "short",
            context: "standalone"
          });
        // Tuesday
        case "cccc":
        default:
          return t.day(a, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // ISO day of week
    i: function i(n, r, t) {
      var e = n.getDay(),
        a = e === 0 ? 7 : e;
      switch (r) {
        // 2
        case "i":
          return String(a);
        // 02
        case "ii":
          return _K(a, r.length);
        // 2nd
        case "io":
          return t.ordinalNumber(a, {
            unit: "day"
          });
        // Tue
        case "iii":
          return t.day(e, {
            width: "abbreviated",
            context: "formatting"
          });
        // T
        case "iiiii":
          return t.day(e, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "iiiiii":
          return t.day(e, {
            width: "short",
            context: "formatting"
          });
        // Tuesday
        case "iiii":
        default:
          return t.day(e, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM or PM
    a: function a(n, r, t) {
      var a = n.getHours() / 12 >= 1 ? "pm" : "am";
      switch (r) {
        case "a":
        case "aa":
          return t.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          });
        case "aaa":
          return t.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "aaaaa":
          return t.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return t.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM, PM, midnight, noon
    b: function b(n, r, t) {
      var e = n.getHours();
      var a;
      switch (e === 12 ? a = it.noon : e === 0 ? a = it.midnight : a = e / 12 >= 1 ? "pm" : "am", r) {
        case "b":
        case "bb":
          return t.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          });
        case "bbb":
          return t.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "bbbbb":
          return t.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return t.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(n, r, t) {
      var e = n.getHours();
      var a;
      switch (e >= 17 ? a = it.evening : e >= 12 ? a = it.afternoon : e >= 4 ? a = it.morning : a = it.night, r) {
        case "B":
        case "BB":
        case "BBB":
          return t.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          });
        case "BBBBB":
          return t.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return t.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Hour [1-12]
    h: function h(n, r, t) {
      if (r === "ho") {
        var e = n.getHours() % 12;
        return e === 0 && (e = 12), t.ordinalNumber(e, {
          unit: "hour"
        });
      }
      return $e.h(n, r);
    },
    // Hour [0-23]
    H: function H(n, r, t) {
      return r === "Ho" ? t.ordinalNumber(n.getHours(), {
        unit: "hour"
      }) : $e.H(n, r);
    },
    // Hour [0-11]
    K: function K(n, r, t) {
      var e = n.getHours() % 12;
      return r === "Ko" ? t.ordinalNumber(e, {
        unit: "hour"
      }) : _K(e, r.length);
    },
    // Hour [1-24]
    k: function k(n, r, t) {
      var e = n.getHours();
      return e === 0 && (e = 24), r === "ko" ? t.ordinalNumber(e, {
        unit: "hour"
      }) : _K(e, r.length);
    },
    // Minute
    m: function m(n, r, t) {
      return r === "mo" ? t.ordinalNumber(n.getMinutes(), {
        unit: "minute"
      }) : $e.m(n, r);
    },
    // Second
    s: function s(n, r, t) {
      return r === "so" ? t.ordinalNumber(n.getSeconds(), {
        unit: "second"
      }) : $e.s(n, r);
    },
    // Fraction of second
    S: function S(n, r) {
      return $e.S(n, r);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(n, r, t) {
      var e = n.getTimezoneOffset();
      if (e === 0) return "Z";
      switch (r) {
        // Hours and optional minutes
        case "X":
          return pr(e);
        // Hours, minutes and optional seconds without `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `XX`
        case "XXXX":
        case "XX":
          return je(e);
        // Hours, minutes and optional seconds with `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `XXX`
        case "XXXXX":
        case "XXX":
        // Hours and minutes with `:` delimiter
        default:
          return je(e, ":");
      }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(n, r, t) {
      var e = n.getTimezoneOffset();
      switch (r) {
        // Hours and optional minutes
        case "x":
          return pr(e);
        // Hours, minutes and optional seconds without `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `xx`
        case "xxxx":
        case "xx":
          return je(e);
        // Hours, minutes and optional seconds with `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `xxx`
        case "xxxxx":
        case "xxx":
        // Hours and minutes with `:` delimiter
        default:
          return je(e, ":");
      }
    },
    // Timezone (GMT)
    O: function O(n, r, t) {
      var e = n.getTimezoneOffset();
      switch (r) {
        // Short
        case "O":
        case "OO":
        case "OOO":
          return "GMT" + fr(e, ":");
        // Long
        case "OOOO":
        default:
          return "GMT" + je(e, ":");
      }
    },
    // Timezone (specific non-location)
    z: function z(n, r, t) {
      var e = n.getTimezoneOffset();
      switch (r) {
        // Short
        case "z":
        case "zz":
        case "zzz":
          return "GMT" + fr(e, ":");
        // Long
        case "zzzz":
        default:
          return "GMT" + je(e, ":");
      }
    },
    // Seconds timestamp
    t: function t(n, r, _t2) {
      var e = Math.trunc(+n / 1e3);
      return _K(e, r.length);
    },
    // Milliseconds timestamp
    T: function T(n, r, t) {
      return _K(+n, r.length);
    }
  };
function fr(n) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var t = n > 0 ? "-" : "+",
    e = Math.abs(n),
    a = Math.trunc(e / 60),
    o = e % 60;
  return o === 0 ? t + String(a) : t + String(a) + r + _K(o, 2);
}
function pr(n, r) {
  return n % 60 === 0 ? (n > 0 ? "-" : "+") + _K(Math.abs(n) / 60, 2) : je(n, r);
}
function je(n) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var t = n > 0 ? "-" : "+",
    e = Math.abs(n),
    a = _K(Math.trunc(e / 60), 2),
    o = _K(e % 60, 2);
  return t + a + r + o;
}
var hr = function hr(n, r) {
    switch (n) {
      case "P":
        return r.date({
          width: "short"
        });
      case "PP":
        return r.date({
          width: "medium"
        });
      case "PPP":
        return r.date({
          width: "long"
        });
      case "PPPP":
      default:
        return r.date({
          width: "full"
        });
    }
  },
  da = function da(n, r) {
    switch (n) {
      case "p":
        return r.time({
          width: "short"
        });
      case "pp":
        return r.time({
          width: "medium"
        });
      case "ppp":
        return r.time({
          width: "long"
        });
      case "pppp":
      default:
        return r.time({
          width: "full"
        });
    }
  },
  wi = function wi(n, r) {
    var t = n.match(/(P+)(p+)?/) || [],
      e = t[1],
      a = t[2];
    if (!a) return hr(n, r);
    var o;
    switch (e) {
      case "P":
        o = r.dateTime({
          width: "short"
        });
        break;
      case "PP":
        o = r.dateTime({
          width: "medium"
        });
        break;
      case "PPP":
        o = r.dateTime({
          width: "long"
        });
        break;
      case "PPPP":
      default:
        o = r.dateTime({
          width: "full"
        });
        break;
    }
    return o.replace("{{date}}", hr(e, r)).replace("{{time}}", da(a, r));
  },
  bi = {
    p: da,
    P: wi
  },
  yi = /^D+$/,
  Di = /^Y+$/,
  ki = ["D", "DD", "YY", "YYYY"];
function xi(n) {
  return yi.test(n);
}
function _i(n) {
  return Di.test(n);
}
function Mi(n, r, t) {
  var e = Ci(n, r, t);
  if (console.warn(e), ki.includes(n)) throw new RangeError(e);
}
function Ci(n, r, t) {
  var e = n[0] === "Y" ? "years" : "days of the month";
  return "Use `".concat(n.toLowerCase(), "` instead of `").concat(n, "` (in `").concat(r, "`) for formatting ").concat(e, " to the input `").concat(t, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md");
}
var Si = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,
  Pi = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,
  Ei = /^'([^]*?)'?$/,
  Oi = /''/g,
  Ti = /[a-zA-Z]/;
function ct(n, r, t) {
  var _e$locale, _ref13, _e$firstWeekContainsD, _ref14, _e$weekStartsOn;
  var u, d, f, p;
  var e = gn(),
    a = (_e$locale = e.locale) !== null && _e$locale !== void 0 ? _e$locale : pi,
    o = (_ref13 = (_e$firstWeekContainsD = e.firstWeekContainsDate) !== null && _e$firstWeekContainsD !== void 0 ? _e$firstWeekContainsD : (d = (u = e.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) !== null && _ref13 !== void 0 ? _ref13 : 1,
    i = (_ref14 = (_e$weekStartsOn = e.weekStartsOn) !== null && _e$weekStartsOn !== void 0 ? _e$weekStartsOn : (p = (f = e.locale) == null ? void 0 : f.options) == null ? void 0 : p.weekStartsOn) !== null && _ref14 !== void 0 ? _ref14 : 0,
    s = ge(n, t == null ? void 0 : t.in);
  if (!No(s)) throw new RangeError("Invalid time value");
  var c = r.match(Pi).map(function (h) {
    var g = h[0];
    if (g === "p" || g === "P") {
      var v = bi[g];
      return v(h, a.formatLong);
    }
    return h;
  }).join("").match(Si).map(function (h) {
    if (h === "''") return {
      isToken: !1,
      value: "'"
    };
    var g = h[0];
    if (g === "'") return {
      isToken: !1,
      value: Ni(h)
    };
    if (dr[g]) return {
      isToken: !0,
      value: h
    };
    if (g.match(Ti)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + g + "`");
    return {
      isToken: !1,
      value: h
    };
  });
  a.localize.preprocessor && (c = a.localize.preprocessor(s, c));
  var l = {
    firstWeekContainsDate: o,
    weekStartsOn: i,
    locale: a
  };
  return c.map(function (h) {
    if (!h.isToken) return h.value;
    var g = h.value;
    (_i(g) || xi(g)) && Mi(g, r, String(n));
    var v = dr[g[0]];
    return v(s, g, a.localize, l);
  }).join("");
}
function Ni(n) {
  var r = n.match(Ei);
  return r ? r[1].replace(Oi, "'") : n;
}
function Yi(n, r, t) {
  var _vn7 = vn(t == null ? void 0 : t.in, n, r),
    _vn8 = _slicedToArray(_vn7, 2),
    e = _vn8[0],
    a = _vn8[1];
  return e.getFullYear() === a.getFullYear() && e.getMonth() === a.getMonth();
}
function fa(n) {
  var r,
    t,
    e = "";
  if (typeof n == "string" || typeof n == "number") e += n;else if (typeof n == "object") if (Array.isArray(n)) {
    var a = n.length;
    for (r = 0; r < a; r++) {
      n[r] && (t = fa(n[r])) && (e && (e += " "), e += t);
    }
  } else for (t in n) {
    n[t] && (e && (e += " "), e += t);
  }
  return e;
}
function se() {
  for (var n, r, t = 0, e = "", a = arguments.length; t < a; t++) {
    (n = arguments[t]) && (r = fa(n)) && (e && (e += " "), e += r);
  }
  return e;
}
function M(n) {
  var r = Object.prototype.toString.call(n);
  return n instanceof Date || typeof n == "object" && r === "[object Date]" ? new n.constructor(+n) : typeof n == "number" || r === "[object Number]" || typeof n == "string" || r === "[object String]" ? new Date(n) : /* @__PURE__ */new Date(NaN);
}
function z(n, r) {
  return n instanceof Date ? new n.constructor(r) : new Date(r);
}
function we(n, r) {
  var t = M(n);
  return isNaN(r) ? z(n, NaN) : (r && t.setDate(t.getDate() + r), t);
}
function be(n, r) {
  var t = M(n);
  if (isNaN(r)) return z(n, NaN);
  if (!r) return t;
  var e = t.getDate(),
    a = z(n, t.getTime());
  a.setMonth(t.getMonth() + r + 1, 0);
  var o = a.getDate();
  return e >= o ? a : (t.setFullYear(a.getFullYear(), a.getMonth(), e), t);
}
function Kn(n, r) {
  var t = +M(n);
  return z(n, t + r);
}
var pa = 6048e5,
  Ri = 864e5,
  wn = 6e4,
  bn = 36e5,
  Li = 1e3;
function Fi(n, r) {
  return Kn(n, r * bn);
}
var Ii = {};
function ot() {
  return Ii;
}
function Le(n, r) {
  var _ref15, _ref16, _ref17, _ref18;
  var s, c, l, u;
  var t = ot(),
    e = (_ref15 = (_ref16 = (_ref17 = (_ref18 = r == null ? void 0 : r.weekStartsOn) !== null && _ref18 !== void 0 ? _ref18 : (c = (s = r == null ? void 0 : r.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) !== null && _ref17 !== void 0 ? _ref17 : t.weekStartsOn) !== null && _ref16 !== void 0 ? _ref16 : (u = (l = t.locale) == null ? void 0 : l.options) == null ? void 0 : u.weekStartsOn) !== null && _ref15 !== void 0 ? _ref15 : 0,
    a = M(n),
    o = a.getDay(),
    i = (o < e ? 7 : 0) + o - e;
  return a.setDate(a.getDate() - i), a.setHours(0, 0, 0, 0), a;
}
function pt(n) {
  return Le(n, {
    weekStartsOn: 1
  });
}
function ha(n) {
  var r = M(n),
    t = r.getFullYear(),
    e = z(n, 0);
  e.setFullYear(t + 1, 0, 4), e.setHours(0, 0, 0, 0);
  var a = pt(e),
    o = z(n, 0);
  o.setFullYear(t, 0, 4), o.setHours(0, 0, 0, 0);
  var i = pt(o);
  return r.getTime() >= a.getTime() ? t + 1 : r.getTime() >= i.getTime() ? t : t - 1;
}
function tt(n) {
  var r = M(n);
  return r.setHours(0, 0, 0, 0), r;
}
function tn(n) {
  var r = M(n),
    t = new Date(Date.UTC(r.getFullYear(), r.getMonth(), r.getDate(), r.getHours(), r.getMinutes(), r.getSeconds(), r.getMilliseconds()));
  return t.setUTCFullYear(r.getFullYear()), +n - +t;
}
function ht(n, r) {
  var t = tt(n),
    e = tt(r),
    a = +t - tn(t),
    o = +e - tn(e);
  return Math.round((a - o) / Ri);
}
function $i(n) {
  var r = ha(n),
    t = z(n, 0);
  return t.setFullYear(r, 0, 4), t.setHours(0, 0, 0, 0), pt(t);
}
function Wn(n, r) {
  return Kn(n, r * wn);
}
function jn(n, r) {
  var t = r * 3;
  return be(n, t);
}
function Wi(n, r) {
  return Kn(n, r * 1e3);
}
function nn(n, r) {
  var t = r * 7;
  return we(n, t);
}
function Te(n, r) {
  return be(n, r * 12);
}
function mr(n) {
  var r;
  return n.forEach(function (t) {
    var e = M(t);
    (r === void 0 || r < e || isNaN(Number(e))) && (r = e);
  }), r || /* @__PURE__ */new Date(NaN);
}
function gr(n) {
  var r;
  return n.forEach(function (t) {
    var e = M(t);
    (!r || r > e || isNaN(+e)) && (r = e);
  }), r || /* @__PURE__ */new Date(NaN);
}
function Ai(n, r) {
  var t = tt(n),
    e = tt(r);
  return +t == +e;
}
function Ne(n) {
  return n instanceof Date || typeof n == "object" && Object.prototype.toString.call(n) === "[object Date]";
}
function rn(n) {
  if (!Ne(n) && typeof n != "number") return !1;
  var r = M(n);
  return !isNaN(Number(r));
}
function an(n, r) {
  var t = M(n),
    e = M(r),
    a = t.getFullYear() - e.getFullYear(),
    o = t.getMonth() - e.getMonth();
  return a * 12 + o;
}
function Ge(n) {
  var r = M(n);
  return Math.trunc(r.getMonth() / 3) + 1;
}
function on(n, r) {
  var t = M(n),
    e = M(r),
    a = t.getFullYear() - e.getFullYear(),
    o = Ge(t) - Ge(e);
  return a * 4 + o;
}
function sn(n, r) {
  var t = M(n),
    e = M(r);
  return t.getFullYear() - e.getFullYear();
}
function Hi(n, r) {
  var t = M(n),
    e = M(r),
    a = vr(t, e),
    o = Math.abs(ht(t, e));
  t.setDate(t.getDate() - a * o);
  var i = +(vr(t, e) === -a),
    s = a * (o - i);
  return s === 0 ? 0 : s;
}
function vr(n, r) {
  var t = n.getFullYear() - r.getFullYear() || n.getMonth() - r.getMonth() || n.getDate() - r.getDate() || n.getHours() - r.getHours() || n.getMinutes() - r.getMinutes() || n.getSeconds() - r.getSeconds() || n.getMilliseconds() - r.getMilliseconds();
  return t < 0 ? -1 : t > 0 ? 1 : t;
}
function ma(n) {
  var r = M(n);
  return r.setHours(23, 59, 59, 999), r;
}
function ga(n) {
  var r = M(n),
    t = r.getMonth();
  return r.setFullYear(r.getFullYear(), t + 1, 0), r.setHours(23, 59, 59, 999), r;
}
function An(n) {
  var r = M(n),
    t = r.getMonth(),
    e = t - t % 3;
  return r.setMonth(e, 1), r.setHours(0, 0, 0, 0), r;
}
function va(n) {
  var r = M(n);
  return r.setDate(1), r.setHours(0, 0, 0, 0), r;
}
function wa(n) {
  var r = M(n),
    t = r.getFullYear();
  return r.setFullYear(t + 1, 0, 0), r.setHours(23, 59, 59, 999), r;
}
function yn(n) {
  var r = M(n),
    t = z(n, 0);
  return t.setFullYear(r.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function Bi(n, r) {
  var _ref19, _t$weekStartsOn;
  var s, c;
  var t = ot(),
    e = (_ref19 = (_t$weekStartsOn = t.weekStartsOn) !== null && _t$weekStartsOn !== void 0 ? _t$weekStartsOn : (c = (s = t.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) !== null && _ref19 !== void 0 ? _ref19 : 0,
    a = M(n),
    o = a.getDay(),
    i = (o < e ? -7 : 0) + 6 - (o - e);
  return a.setDate(a.getDate() + i), a.setHours(23, 59, 59, 999), a;
}
var Qi = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about 1 week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  },
  Vi = function Vi(n, r, t) {
    var e;
    var a = Qi[n];
    return typeof a == "string" ? e = a : r === 1 ? e = a.one : e = a.other.replace("{{count}}", r.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + e : e + " ago" : e;
  };
function Cn(n) {
  return function () {
    var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var t = r.width ? String(r.width) : n.defaultWidth;
    return n.formats[t] || n.formats[n.defaultWidth];
  };
}
var qi = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
  },
  Ki = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  },
  ji = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  },
  zi = {
    date: Cn({
      formats: qi,
      defaultWidth: "full"
    }),
    time: Cn({
      formats: Ki,
      defaultWidth: "full"
    }),
    dateTime: Cn({
      formats: ji,
      defaultWidth: "full"
    })
  },
  Ui = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  },
  Xi = function Xi(n, r, t, e) {
    return Ui[n];
  };
function kt(n) {
  return function (r, t) {
    var e = t != null && t.context ? String(t.context) : "standalone";
    var a;
    if (e === "formatting" && n.formattingValues) {
      var i = n.defaultFormattingWidth || n.defaultWidth,
        s = t != null && t.width ? String(t.width) : i;
      a = n.formattingValues[s] || n.formattingValues[i];
    } else {
      var _i3 = n.defaultWidth,
        _s3 = t != null && t.width ? String(t.width) : n.defaultWidth;
      a = n.values[_s3] || n.values[_i3];
    }
    var o = n.argumentCallback ? n.argumentCallback(r) : r;
    return a[o];
  };
}
var Gi = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"]
  },
  Zi = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
  },
  Ji = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  },
  es = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  },
  ts = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }
  },
  ns = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    }
  },
  rs = function rs(n, r) {
    var t = Number(n),
      e = t % 100;
    if (e > 20 || e < 10) switch (e % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
    return t + "th";
  },
  as = {
    ordinalNumber: rs,
    era: kt({
      values: Gi,
      defaultWidth: "wide"
    }),
    quarter: kt({
      values: Zi,
      defaultWidth: "wide",
      argumentCallback: function argumentCallback(n) {
        return n - 1;
      }
    }),
    month: kt({
      values: Ji,
      defaultWidth: "wide"
    }),
    day: kt({
      values: es,
      defaultWidth: "wide"
    }),
    dayPeriod: kt({
      values: ts,
      defaultWidth: "wide",
      formattingValues: ns,
      defaultFormattingWidth: "wide"
    })
  };
function xt(n) {
  return function (r) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var e = t.width,
      a = e && n.matchPatterns[e] || n.matchPatterns[n.defaultMatchWidth],
      o = r.match(a);
    if (!o) return null;
    var i = o[0],
      s = e && n.parsePatterns[e] || n.parsePatterns[n.defaultParseWidth],
      c = Array.isArray(s) ? is(s, function (d) {
        return d.test(i);
      }) :
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      os(s, function (d) {
        return d.test(i);
      });
    var l;
    l = n.valueCallback ? n.valueCallback(c) : c, l = t.valueCallback ?
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    t.valueCallback(l) : l;
    var u = r.slice(i.length);
    return {
      value: l,
      rest: u
    };
  };
}
function os(n, r) {
  for (var t in n) {
    if (Object.prototype.hasOwnProperty.call(n, t) && r(n[t])) return t;
  }
}
function is(n, r) {
  for (var t = 0; t < n.length; t++) {
    if (r(n[t])) return t;
  }
}
function ss(n) {
  return function (r) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var e = r.match(n.matchPattern);
    if (!e) return null;
    var a = e[0],
      o = r.match(n.parsePattern);
    if (!o) return null;
    var i = n.valueCallback ? n.valueCallback(o[0]) : o[0];
    i = t.valueCallback ? t.valueCallback(i) : i;
    var s = r.slice(a.length);
    return {
      value: i,
      rest: s
    };
  };
}
var cs = /^(\d+)(th|st|nd|rd)?/i,
  ls = /\d+/i,
  us = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  },
  ds = {
    any: [/^b/i, /^(a|c)/i]
  },
  fs = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  },
  ps = {
    any: [/1/i, /2/i, /3/i, /4/i]
  },
  hs = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  },
  ms = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  },
  gs = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  },
  vs = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  },
  ws = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  },
  bs = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  },
  ys = {
    ordinalNumber: ss({
      matchPattern: cs,
      parsePattern: ls,
      valueCallback: function valueCallback(n) {
        return parseInt(n, 10);
      }
    }),
    era: xt({
      matchPatterns: us,
      defaultMatchWidth: "wide",
      parsePatterns: ds,
      defaultParseWidth: "any"
    }),
    quarter: xt({
      matchPatterns: fs,
      defaultMatchWidth: "wide",
      parsePatterns: ps,
      defaultParseWidth: "any",
      valueCallback: function valueCallback(n) {
        return n + 1;
      }
    }),
    month: xt({
      matchPatterns: hs,
      defaultMatchWidth: "wide",
      parsePatterns: ms,
      defaultParseWidth: "any"
    }),
    day: xt({
      matchPatterns: gs,
      defaultMatchWidth: "wide",
      parsePatterns: vs,
      defaultParseWidth: "any"
    }),
    dayPeriod: xt({
      matchPatterns: ws,
      defaultMatchWidth: "any",
      parsePatterns: bs,
      defaultParseWidth: "any"
    })
  },
  ba = {
    code: "en-US",
    formatDistance: Vi,
    formatLong: zi,
    formatRelative: Xi,
    localize: as,
    match: ys,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  };
function Ds(n) {
  var r = M(n);
  return ht(r, yn(r)) + 1;
}
function zn(n) {
  var r = M(n),
    t = +pt(r) - +$i(r);
  return Math.round(t / pa) + 1;
}
function Un(n, r) {
  var _ref20, _ref21, _ref22, _ref23;
  var u, d, f, p;
  var t = M(n),
    e = t.getFullYear(),
    a = ot(),
    o = (_ref20 = (_ref21 = (_ref22 = (_ref23 = r == null ? void 0 : r.firstWeekContainsDate) !== null && _ref23 !== void 0 ? _ref23 : (d = (u = r == null ? void 0 : r.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) !== null && _ref22 !== void 0 ? _ref22 : a.firstWeekContainsDate) !== null && _ref21 !== void 0 ? _ref21 : (p = (f = a.locale) == null ? void 0 : f.options) == null ? void 0 : p.firstWeekContainsDate) !== null && _ref20 !== void 0 ? _ref20 : 1,
    i = z(n, 0);
  i.setFullYear(e + 1, 0, o), i.setHours(0, 0, 0, 0);
  var s = Le(i, r),
    c = z(n, 0);
  c.setFullYear(e, 0, o), c.setHours(0, 0, 0, 0);
  var l = Le(c, r);
  return t.getTime() >= s.getTime() ? e + 1 : t.getTime() >= l.getTime() ? e : e - 1;
}
function ks(n, r) {
  var _ref24, _ref25, _ref26, _ref27;
  var s, c, l, u;
  var t = ot(),
    e = (_ref24 = (_ref25 = (_ref26 = (_ref27 = r == null ? void 0 : r.firstWeekContainsDate) !== null && _ref27 !== void 0 ? _ref27 : (c = (s = r == null ? void 0 : r.locale) == null ? void 0 : s.options) == null ? void 0 : c.firstWeekContainsDate) !== null && _ref26 !== void 0 ? _ref26 : t.firstWeekContainsDate) !== null && _ref25 !== void 0 ? _ref25 : (u = (l = t.locale) == null ? void 0 : l.options) == null ? void 0 : u.firstWeekContainsDate) !== null && _ref24 !== void 0 ? _ref24 : 1,
    a = Un(n, r),
    o = z(n, 0);
  return o.setFullYear(a, 0, e), o.setHours(0, 0, 0, 0), Le(o, r);
}
function ya(n, r) {
  var t = M(n),
    e = +Le(t, r) - +ks(t, r);
  return Math.round(e / pa) + 1;
}
function j(n, r) {
  var t = n < 0 ? "-" : "",
    e = Math.abs(n).toString().padStart(r, "0");
  return t + e;
}
var We = {
    // Year
    y(n, r) {
      var t = n.getFullYear(),
        e = t > 0 ? t : 1 - t;
      return j(r === "yy" ? e % 100 : e, r.length);
    },
    // Month
    M(n, r) {
      var t = n.getMonth();
      return r === "M" ? String(t + 1) : j(t + 1, 2);
    },
    // Day of the month
    d(n, r) {
      return j(n.getDate(), r.length);
    },
    // AM or PM
    a(n, r) {
      var t = n.getHours() / 12 >= 1 ? "pm" : "am";
      switch (r) {
        case "a":
        case "aa":
          return t.toUpperCase();
        case "aaa":
          return t;
        case "aaaaa":
          return t[0];
        case "aaaa":
        default:
          return t === "am" ? "a.m." : "p.m.";
      }
    },
    // Hour [1-12]
    h(n, r) {
      return j(n.getHours() % 12 || 12, r.length);
    },
    // Hour [0-23]
    H(n, r) {
      return j(n.getHours(), r.length);
    },
    // Minute
    m(n, r) {
      return j(n.getMinutes(), r.length);
    },
    // Second
    s(n, r) {
      return j(n.getSeconds(), r.length);
    },
    // Fraction of second
    S(n, r) {
      var t = r.length,
        e = n.getMilliseconds(),
        a = Math.trunc(e * Math.pow(10, t - 3));
      return j(a, r.length);
    }
  },
  st = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wr = {
    // Era
    G: function G(n, r, t) {
      var e = n.getFullYear() > 0 ? 1 : 0;
      switch (r) {
        // AD, BC
        case "G":
        case "GG":
        case "GGG":
          return t.era(e, {
            width: "abbreviated"
          });
        // A, B
        case "GGGGG":
          return t.era(e, {
            width: "narrow"
          });
        // Anno Domini, Before Christ
        case "GGGG":
        default:
          return t.era(e, {
            width: "wide"
          });
      }
    },
    // Year
    y: function y(n, r, t) {
      if (r === "yo") {
        var e = n.getFullYear(),
          a = e > 0 ? e : 1 - e;
        return t.ordinalNumber(a, {
          unit: "year"
        });
      }
      return We.y(n, r);
    },
    // Local week-numbering year
    Y: function Y(n, r, t, e) {
      var a = Un(n, e),
        o = a > 0 ? a : 1 - a;
      if (r === "YY") {
        var i = o % 100;
        return j(i, 2);
      }
      return r === "Yo" ? t.ordinalNumber(o, {
        unit: "year"
      }) : j(o, r.length);
    },
    // ISO week-numbering year
    R: function R(n, r) {
      var t = ha(n);
      return j(t, r.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(n, r) {
      var t = n.getFullYear();
      return j(t, r.length);
    },
    // Quarter
    Q: function Q(n, r, t) {
      var e = Math.ceil((n.getMonth() + 1) / 3);
      switch (r) {
        // 1, 2, 3, 4
        case "Q":
          return String(e);
        // 01, 02, 03, 04
        case "QQ":
          return j(e, 2);
        // 1st, 2nd, 3rd, 4th
        case "Qo":
          return t.ordinalNumber(e, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "QQQ":
          return t.quarter(e, {
            width: "abbreviated",
            context: "formatting"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "QQQQQ":
          return t.quarter(e, {
            width: "narrow",
            context: "formatting"
          });
        // 1st quarter, 2nd quarter, ...
        case "QQQQ":
        default:
          return t.quarter(e, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone quarter
    q: function q(n, r, t) {
      var e = Math.ceil((n.getMonth() + 1) / 3);
      switch (r) {
        // 1, 2, 3, 4
        case "q":
          return String(e);
        // 01, 02, 03, 04
        case "qq":
          return j(e, 2);
        // 1st, 2nd, 3rd, 4th
        case "qo":
          return t.ordinalNumber(e, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "qqq":
          return t.quarter(e, {
            width: "abbreviated",
            context: "standalone"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "qqqqq":
          return t.quarter(e, {
            width: "narrow",
            context: "standalone"
          });
        // 1st quarter, 2nd quarter, ...
        case "qqqq":
        default:
          return t.quarter(e, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Month
    M: function M(n, r, t) {
      var e = n.getMonth();
      switch (r) {
        case "M":
        case "MM":
          return We.M(n, r);
        // 1st, 2nd, ..., 12th
        case "Mo":
          return t.ordinalNumber(e + 1, {
            unit: "month"
          });
        // Jan, Feb, ..., Dec
        case "MMM":
          return t.month(e, {
            width: "abbreviated",
            context: "formatting"
          });
        // J, F, ..., D
        case "MMMMM":
          return t.month(e, {
            width: "narrow",
            context: "formatting"
          });
        // January, February, ..., December
        case "MMMM":
        default:
          return t.month(e, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone month
    L: function L(n, r, t) {
      var e = n.getMonth();
      switch (r) {
        // 1, 2, ..., 12
        case "L":
          return String(e + 1);
        // 01, 02, ..., 12
        case "LL":
          return j(e + 1, 2);
        // 1st, 2nd, ..., 12th
        case "Lo":
          return t.ordinalNumber(e + 1, {
            unit: "month"
          });
        // Jan, Feb, ..., Dec
        case "LLL":
          return t.month(e, {
            width: "abbreviated",
            context: "standalone"
          });
        // J, F, ..., D
        case "LLLLL":
          return t.month(e, {
            width: "narrow",
            context: "standalone"
          });
        // January, February, ..., December
        case "LLLL":
        default:
          return t.month(e, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Local week of year
    w: function w(n, r, t, e) {
      var a = ya(n, e);
      return r === "wo" ? t.ordinalNumber(a, {
        unit: "week"
      }) : j(a, r.length);
    },
    // ISO week of year
    I: function I(n, r, t) {
      var e = zn(n);
      return r === "Io" ? t.ordinalNumber(e, {
        unit: "week"
      }) : j(e, r.length);
    },
    // Day of the month
    d: function d(n, r, t) {
      return r === "do" ? t.ordinalNumber(n.getDate(), {
        unit: "date"
      }) : We.d(n, r);
    },
    // Day of year
    D: function D(n, r, t) {
      var e = Ds(n);
      return r === "Do" ? t.ordinalNumber(e, {
        unit: "dayOfYear"
      }) : j(e, r.length);
    },
    // Day of week
    E: function E(n, r, t) {
      var e = n.getDay();
      switch (r) {
        // Tue
        case "E":
        case "EE":
        case "EEE":
          return t.day(e, {
            width: "abbreviated",
            context: "formatting"
          });
        // T
        case "EEEEE":
          return t.day(e, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "EEEEEE":
          return t.day(e, {
            width: "short",
            context: "formatting"
          });
        // Tuesday
        case "EEEE":
        default:
          return t.day(e, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Local day of week
    e: function e(n, r, t, _e3) {
      var a = n.getDay(),
        o = (a - _e3.weekStartsOn + 8) % 7 || 7;
      switch (r) {
        // Numerical value (Nth day of week with current locale or weekStartsOn)
        case "e":
          return String(o);
        // Padded numerical value
        case "ee":
          return j(o, 2);
        // 1st, 2nd, ..., 7th
        case "eo":
          return t.ordinalNumber(o, {
            unit: "day"
          });
        case "eee":
          return t.day(a, {
            width: "abbreviated",
            context: "formatting"
          });
        // T
        case "eeeee":
          return t.day(a, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "eeeeee":
          return t.day(a, {
            width: "short",
            context: "formatting"
          });
        // Tuesday
        case "eeee":
        default:
          return t.day(a, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone local day of week
    c: function c(n, r, t, e) {
      var a = n.getDay(),
        o = (a - e.weekStartsOn + 8) % 7 || 7;
      switch (r) {
        // Numerical value (same as in `e`)
        case "c":
          return String(o);
        // Padded numerical value
        case "cc":
          return j(o, r.length);
        // 1st, 2nd, ..., 7th
        case "co":
          return t.ordinalNumber(o, {
            unit: "day"
          });
        case "ccc":
          return t.day(a, {
            width: "abbreviated",
            context: "standalone"
          });
        // T
        case "ccccc":
          return t.day(a, {
            width: "narrow",
            context: "standalone"
          });
        // Tu
        case "cccccc":
          return t.day(a, {
            width: "short",
            context: "standalone"
          });
        // Tuesday
        case "cccc":
        default:
          return t.day(a, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // ISO day of week
    i: function i(n, r, t) {
      var e = n.getDay(),
        a = e === 0 ? 7 : e;
      switch (r) {
        // 2
        case "i":
          return String(a);
        // 02
        case "ii":
          return j(a, r.length);
        // 2nd
        case "io":
          return t.ordinalNumber(a, {
            unit: "day"
          });
        // Tue
        case "iii":
          return t.day(e, {
            width: "abbreviated",
            context: "formatting"
          });
        // T
        case "iiiii":
          return t.day(e, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "iiiiii":
          return t.day(e, {
            width: "short",
            context: "formatting"
          });
        // Tuesday
        case "iiii":
        default:
          return t.day(e, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM or PM
    a: function a(n, r, t) {
      var a = n.getHours() / 12 >= 1 ? "pm" : "am";
      switch (r) {
        case "a":
        case "aa":
          return t.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          });
        case "aaa":
          return t.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "aaaaa":
          return t.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return t.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM, PM, midnight, noon
    b: function b(n, r, t) {
      var e = n.getHours();
      var a;
      switch (e === 12 ? a = st.noon : e === 0 ? a = st.midnight : a = e / 12 >= 1 ? "pm" : "am", r) {
        case "b":
        case "bb":
          return t.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          });
        case "bbb":
          return t.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "bbbbb":
          return t.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return t.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(n, r, t) {
      var e = n.getHours();
      var a;
      switch (e >= 17 ? a = st.evening : e >= 12 ? a = st.afternoon : e >= 4 ? a = st.morning : a = st.night, r) {
        case "B":
        case "BB":
        case "BBB":
          return t.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          });
        case "BBBBB":
          return t.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return t.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Hour [1-12]
    h: function h(n, r, t) {
      if (r === "ho") {
        var e = n.getHours() % 12;
        return e === 0 && (e = 12), t.ordinalNumber(e, {
          unit: "hour"
        });
      }
      return We.h(n, r);
    },
    // Hour [0-23]
    H: function H(n, r, t) {
      return r === "Ho" ? t.ordinalNumber(n.getHours(), {
        unit: "hour"
      }) : We.H(n, r);
    },
    // Hour [0-11]
    K: function K(n, r, t) {
      var e = n.getHours() % 12;
      return r === "Ko" ? t.ordinalNumber(e, {
        unit: "hour"
      }) : j(e, r.length);
    },
    // Hour [1-24]
    k: function k(n, r, t) {
      var e = n.getHours();
      return e === 0 && (e = 24), r === "ko" ? t.ordinalNumber(e, {
        unit: "hour"
      }) : j(e, r.length);
    },
    // Minute
    m: function m(n, r, t) {
      return r === "mo" ? t.ordinalNumber(n.getMinutes(), {
        unit: "minute"
      }) : We.m(n, r);
    },
    // Second
    s: function s(n, r, t) {
      return r === "so" ? t.ordinalNumber(n.getSeconds(), {
        unit: "second"
      }) : We.s(n, r);
    },
    // Fraction of second
    S: function S(n, r) {
      return We.S(n, r);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(n, r, t) {
      var e = n.getTimezoneOffset();
      if (e === 0) return "Z";
      switch (r) {
        // Hours and optional minutes
        case "X":
          return yr(e);
        // Hours, minutes and optional seconds without `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `XX`
        case "XXXX":
        case "XX":
          return ze(e);
        // Hours, minutes and optional seconds with `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `XXX`
        case "XXXXX":
        case "XXX":
        // Hours and minutes with `:` delimiter
        default:
          return ze(e, ":");
      }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(n, r, t) {
      var e = n.getTimezoneOffset();
      switch (r) {
        // Hours and optional minutes
        case "x":
          return yr(e);
        // Hours, minutes and optional seconds without `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `xx`
        case "xxxx":
        case "xx":
          return ze(e);
        // Hours, minutes and optional seconds with `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `xxx`
        case "xxxxx":
        case "xxx":
        // Hours and minutes with `:` delimiter
        default:
          return ze(e, ":");
      }
    },
    // Timezone (GMT)
    O: function O(n, r, t) {
      var e = n.getTimezoneOffset();
      switch (r) {
        // Short
        case "O":
        case "OO":
        case "OOO":
          return "GMT" + br(e, ":");
        // Long
        case "OOOO":
        default:
          return "GMT" + ze(e, ":");
      }
    },
    // Timezone (specific non-location)
    z: function z(n, r, t) {
      var e = n.getTimezoneOffset();
      switch (r) {
        // Short
        case "z":
        case "zz":
        case "zzz":
          return "GMT" + br(e, ":");
        // Long
        case "zzzz":
        default:
          return "GMT" + ze(e, ":");
      }
    },
    // Seconds timestamp
    t: function t(n, r, _t3) {
      var e = Math.trunc(n.getTime() / 1e3);
      return j(e, r.length);
    },
    // Milliseconds timestamp
    T: function T(n, r, t) {
      var e = n.getTime();
      return j(e, r.length);
    }
  };
function br(n) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var t = n > 0 ? "-" : "+",
    e = Math.abs(n),
    a = Math.trunc(e / 60),
    o = e % 60;
  return o === 0 ? t + String(a) : t + String(a) + r + j(o, 2);
}
function yr(n, r) {
  return n % 60 === 0 ? (n > 0 ? "-" : "+") + j(Math.abs(n) / 60, 2) : ze(n, r);
}
function ze(n) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var t = n > 0 ? "-" : "+",
    e = Math.abs(n),
    a = j(Math.trunc(e / 60), 2),
    o = j(e % 60, 2);
  return t + a + r + o;
}
var Dr = function Dr(n, r) {
    switch (n) {
      case "P":
        return r.date({
          width: "short"
        });
      case "PP":
        return r.date({
          width: "medium"
        });
      case "PPP":
        return r.date({
          width: "long"
        });
      case "PPPP":
      default:
        return r.date({
          width: "full"
        });
    }
  },
  Da = function Da(n, r) {
    switch (n) {
      case "p":
        return r.time({
          width: "short"
        });
      case "pp":
        return r.time({
          width: "medium"
        });
      case "ppp":
        return r.time({
          width: "long"
        });
      case "pppp":
      default:
        return r.time({
          width: "full"
        });
    }
  },
  xs = function xs(n, r) {
    var t = n.match(/(P+)(p+)?/) || [],
      e = t[1],
      a = t[2];
    if (!a) return Dr(n, r);
    var o;
    switch (e) {
      case "P":
        o = r.dateTime({
          width: "short"
        });
        break;
      case "PP":
        o = r.dateTime({
          width: "medium"
        });
        break;
      case "PPP":
        o = r.dateTime({
          width: "long"
        });
        break;
      case "PPPP":
      default:
        o = r.dateTime({
          width: "full"
        });
        break;
    }
    return o.replace("{{date}}", Dr(e, r)).replace("{{time}}", Da(a, r));
  },
  cn = {
    p: Da,
    P: xs
  },
  _s = /^D+$/,
  Ms = /^Y+$/,
  Cs = ["D", "DD", "YY", "YYYY"];
function ka(n) {
  return _s.test(n);
}
function xa(n) {
  return Ms.test(n);
}
function Hn(n, r, t) {
  var e = Ss(n, r, t);
  if (console.warn(e), Cs.includes(n)) throw new RangeError(e);
}
function Ss(n, r, t) {
  var e = n[0] === "Y" ? "years" : "days of the month";
  return "Use `".concat(n.toLowerCase(), "` instead of `").concat(n, "` (in `").concat(r, "`) for formatting ").concat(e, " to the input `").concat(t, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md");
}
var Ps = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,
  Es = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,
  Os = /^'([^]*?)'?$/,
  Ts = /''/g,
  Ns = /[a-zA-Z]/;
function kr(n, r, t) {
  var _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37;
  var u, d, f, p, h, g, v, w;
  var e = ot(),
    a = (_ref28 = (_ref29 = t == null ? void 0 : t.locale) !== null && _ref29 !== void 0 ? _ref29 : e.locale) !== null && _ref28 !== void 0 ? _ref28 : ba,
    o = (_ref30 = (_ref31 = (_ref32 = (_ref33 = t == null ? void 0 : t.firstWeekContainsDate) !== null && _ref33 !== void 0 ? _ref33 : (d = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) !== null && _ref32 !== void 0 ? _ref32 : e.firstWeekContainsDate) !== null && _ref31 !== void 0 ? _ref31 : (p = (f = e.locale) == null ? void 0 : f.options) == null ? void 0 : p.firstWeekContainsDate) !== null && _ref30 !== void 0 ? _ref30 : 1,
    i = (_ref34 = (_ref35 = (_ref36 = (_ref37 = t == null ? void 0 : t.weekStartsOn) !== null && _ref37 !== void 0 ? _ref37 : (g = (h = t == null ? void 0 : t.locale) == null ? void 0 : h.options) == null ? void 0 : g.weekStartsOn) !== null && _ref36 !== void 0 ? _ref36 : e.weekStartsOn) !== null && _ref35 !== void 0 ? _ref35 : (w = (v = e.locale) == null ? void 0 : v.options) == null ? void 0 : w.weekStartsOn) !== null && _ref34 !== void 0 ? _ref34 : 0,
    s = M(n);
  if (!rn(s)) throw new RangeError("Invalid time value");
  var c = r.match(Es).map(function (D) {
    var b = D[0];
    if (b === "p" || b === "P") {
      var P = cn[b];
      return P(D, a.formatLong);
    }
    return D;
  }).join("").match(Ps).map(function (D) {
    if (D === "''") return {
      isToken: !1,
      value: "'"
    };
    var b = D[0];
    if (b === "'") return {
      isToken: !1,
      value: Ys(D)
    };
    if (wr[b]) return {
      isToken: !0,
      value: D
    };
    if (b.match(Ns)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + b + "`");
    return {
      isToken: !1,
      value: D
    };
  });
  a.localize.preprocessor && (c = a.localize.preprocessor(s, c));
  var l = {
    firstWeekContainsDate: o,
    weekStartsOn: i,
    locale: a
  };
  return c.map(function (D) {
    if (!D.isToken) return D.value;
    var b = D.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && xa(b) || !(t != null && t.useAdditionalDayOfYearTokens) && ka(b)) && Hn(b, r, String(n));
    var P = wr[b[0]];
    return P(s, b, a.localize, l);
  }).join("");
}
function Ys(n) {
  var r = n.match(Os);
  return r ? r[1].replace(Ts, "'") : n;
}
function xr(n) {
  return M(n).getDate();
}
function Rs(n) {
  return M(n).getDay();
}
function Ls(n) {
  var r = M(n),
    t = r.getFullYear(),
    e = r.getMonth(),
    a = z(n, 0);
  return a.setFullYear(t, e + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function Fs() {
  return Object.assign({}, ot());
}
function Ce(n) {
  return M(n).getHours();
}
function Is(n) {
  var t = M(n).getDay();
  return t === 0 && (t = 7), t;
}
function Se(n) {
  return M(n).getMinutes();
}
function ue(n) {
  return M(n).getMonth();
}
function Ye(n) {
  return M(n).getSeconds();
}
function Bn(n) {
  return M(n).getTime();
}
function F(n) {
  return M(n).getFullYear();
}
function Ve(n, r) {
  var t = M(n),
    e = M(r);
  return t.getTime() > e.getTime();
}
function nt(n, r) {
  var t = M(n),
    e = M(r);
  return +t < +e;
}
function $s(n, r) {
  var t = M(n),
    e = M(r);
  return +t == +e;
}
function Ws(n, r) {
  var t = r instanceof Date ? z(r, 0) : new r(0);
  return t.setFullYear(n.getFullYear(), n.getMonth(), n.getDate()), t.setHours(n.getHours(), n.getMinutes(), n.getSeconds(), n.getMilliseconds()), t;
}
var As = 10;
var _a = /*#__PURE__*/function () {
  function _a() {
    _classCallCheck(this, _a);
    C(this, "subPriority", 0);
  }
  _createClass(_a, [{
    key: "validate",
    value: function validate(r, t) {
      return !0;
    }
  }]);
  return _a;
}();
var Hs = /*#__PURE__*/function (_a2) {
  _inherits(Hs, _a2);
  var _super = _createSuper(Hs);
  function Hs(r, t, e, a, o) {
    var _this;
    _classCallCheck(this, Hs);
    _this = _super.call(this), _this.value = r, _this.validateValue = t, _this.setValue = e, _this.priority = a, o && (_this.subPriority = o);
    return _this;
  }
  _createClass(Hs, [{
    key: "validate",
    value: function validate(r, t) {
      return this.validateValue(r, this.value, t);
    }
  }, {
    key: "set",
    value: function set(r, t, e) {
      return this.setValue(r, t, this.value, e);
    }
  }]);
  return Hs;
}(_a);
var Bs = /*#__PURE__*/function (_a3) {
  _inherits(Bs, _a3);
  var _super2 = _createSuper(Bs);
  function Bs() {
    var _this2;
    _classCallCheck(this, Bs);
    _this2 = _super2.apply(this, arguments);
    C(_assertThisInitialized(_this2), "priority", As);
    C(_assertThisInitialized(_this2), "subPriority", -1);
    return _this2;
  }
  _createClass(Bs, [{
    key: "set",
    value: function set(t, e) {
      return e.timestampIsSet ? t : z(t, Ws(t, Date));
    }
  }]);
  return Bs;
}(_a);
var q = /*#__PURE__*/function () {
  function q() {
    _classCallCheck(this, q);
  }
  _createClass(q, [{
    key: "run",
    value: function run(r, t, e, a) {
      var o = this.parse(r, t, e, a);
      return o ? {
        setter: new Hs(o.value, this.validate, this.set, this.priority, this.subPriority),
        rest: o.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function validate(r, t, e) {
      return !0;
    }
  }]);
  return q;
}();
var Qs = /*#__PURE__*/function (_q) {
  _inherits(Qs, _q);
  var _super3 = _createSuper(Qs);
  function Qs() {
    var _this3;
    _classCallCheck(this, Qs);
    _this3 = _super3.apply(this, arguments);
    C(_assertThisInitialized(_this3), "priority", 140);
    C(_assertThisInitialized(_this3), "incompatibleTokens", ["R", "u", "t", "T"]);
    return _this3;
  }
  _createClass(Qs, [{
    key: "parse",
    value: function parse(t, e, a) {
      switch (e) {
        // AD, BC
        case "G":
        case "GG":
        case "GGG":
          return a.era(t, {
            width: "abbreviated"
          }) || a.era(t, {
            width: "narrow"
          });
        // A, B
        case "GGGGG":
          return a.era(t, {
            width: "narrow"
          });
        // Anno Domini, Before Christ
        case "GGGG":
        default:
          return a.era(t, {
            width: "wide"
          }) || a.era(t, {
            width: "abbreviated"
          }) || a.era(t, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      return e.era = a, t.setFullYear(a, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
  }]);
  return Qs;
}(q);
var te = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/
    // 0 to 9999, -0 to -9999
  },
  xe = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
  };
function ne(n, r) {
  return n && {
    value: r(n.value),
    rest: n.rest
  };
}
function Z(n, r) {
  var t = r.match(n);
  return t ? {
    value: parseInt(t[0], 10),
    rest: r.slice(t[0].length)
  } : null;
}
function _e(n, r) {
  var t = r.match(n);
  if (!t) return null;
  if (t[0] === "Z") return {
    value: 0,
    rest: r.slice(1)
  };
  var e = t[1] === "+" ? 1 : -1,
    a = t[2] ? parseInt(t[2], 10) : 0,
    o = t[3] ? parseInt(t[3], 10) : 0,
    i = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: e * (a * bn + o * wn + i * Li),
    rest: r.slice(t[0].length)
  };
}
function Ma(n) {
  return Z(te.anyDigitsSigned, n);
}
function ee(n, r) {
  switch (n) {
    case 1:
      return Z(te.singleDigit, r);
    case 2:
      return Z(te.twoDigits, r);
    case 3:
      return Z(te.threeDigits, r);
    case 4:
      return Z(te.fourDigits, r);
    default:
      return Z(new RegExp("^\\d{1," + n + "}"), r);
  }
}
function ln(n, r) {
  switch (n) {
    case 1:
      return Z(te.singleDigitSigned, r);
    case 2:
      return Z(te.twoDigitsSigned, r);
    case 3:
      return Z(te.threeDigitsSigned, r);
    case 4:
      return Z(te.fourDigitsSigned, r);
    default:
      return Z(new RegExp("^-?\\d{1," + n + "}"), r);
  }
}
function Xn(n) {
  switch (n) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Ca(n, r) {
  var t = r > 0,
    e = t ? r : 1 - r;
  var a;
  if (e <= 50) a = n || 100;else {
    var o = e + 50,
      i = Math.trunc(o / 100) * 100,
      s = n >= o % 100;
    a = n + i - (s ? 100 : 0);
  }
  return t ? a : 1 - a;
}
function Sa(n) {
  return n % 400 === 0 || n % 4 === 0 && n % 100 !== 0;
}
var Vs = /*#__PURE__*/function (_q2) {
  _inherits(Vs, _q2);
  var _super4 = _createSuper(Vs);
  function Vs() {
    var _this4;
    _classCallCheck(this, Vs);
    _this4 = _super4.apply(this, arguments);
    C(_assertThisInitialized(_this4), "priority", 130);
    C(_assertThisInitialized(_this4), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
    return _this4;
  }
  _createClass(Vs, [{
    key: "parse",
    value: function parse(t, e, a) {
      var o = function o(i) {
        return {
          year: i,
          isTwoDigitYear: e === "yy"
        };
      };
      switch (e) {
        case "y":
          return ne(ee(4, t), o);
        case "yo":
          return ne(a.ordinalNumber(t, {
            unit: "year"
          }), o);
        default:
          return ne(ee(e.length, t), o);
      }
    }
  }, {
    key: "validate",
    value: function validate(t, e) {
      return e.isTwoDigitYear || e.year > 0;
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      var o = t.getFullYear();
      if (a.isTwoDigitYear) {
        var s = Ca(a.year, o);
        return t.setFullYear(s, 0, 1), t.setHours(0, 0, 0, 0), t;
      }
      var i = !("era" in e) || e.era === 1 ? a.year : 1 - a.year;
      return t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
  }]);
  return Vs;
}(q);
var qs = /*#__PURE__*/function (_q3) {
  _inherits(qs, _q3);
  var _super5 = _createSuper(qs);
  function qs() {
    var _this5;
    _classCallCheck(this, qs);
    _this5 = _super5.apply(this, arguments);
    C(_assertThisInitialized(_this5), "priority", 130);
    C(_assertThisInitialized(_this5), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]);
    return _this5;
  }
  _createClass(qs, [{
    key: "parse",
    value: function parse(t, e, a) {
      var o = function o(i) {
        return {
          year: i,
          isTwoDigitYear: e === "YY"
        };
      };
      switch (e) {
        case "Y":
          return ne(ee(4, t), o);
        case "Yo":
          return ne(a.ordinalNumber(t, {
            unit: "year"
          }), o);
        default:
          return ne(ee(e.length, t), o);
      }
    }
  }, {
    key: "validate",
    value: function validate(t, e) {
      return e.isTwoDigitYear || e.year > 0;
    }
  }, {
    key: "set",
    value: function set(t, e, a, o) {
      var i = Un(t, o);
      if (a.isTwoDigitYear) {
        var c = Ca(a.year, i);
        return t.setFullYear(c, 0, o.firstWeekContainsDate), t.setHours(0, 0, 0, 0), Le(t, o);
      }
      var s = !("era" in e) || e.era === 1 ? a.year : 1 - a.year;
      return t.setFullYear(s, 0, o.firstWeekContainsDate), t.setHours(0, 0, 0, 0), Le(t, o);
    }
  }]);
  return qs;
}(q);
var Ks = /*#__PURE__*/function (_q4) {
  _inherits(Ks, _q4);
  var _super6 = _createSuper(Ks);
  function Ks() {
    var _this6;
    _classCallCheck(this, Ks);
    _this6 = _super6.apply(this, arguments);
    C(_assertThisInitialized(_this6), "priority", 130);
    C(_assertThisInitialized(_this6), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]);
    return _this6;
  }
  _createClass(Ks, [{
    key: "parse",
    value: function parse(t, e) {
      return ln(e === "R" ? 4 : e.length, t);
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      var o = z(t, 0);
      return o.setFullYear(a, 0, 4), o.setHours(0, 0, 0, 0), pt(o);
    }
  }]);
  return Ks;
}(q);
var js = /*#__PURE__*/function (_q5) {
  _inherits(js, _q5);
  var _super7 = _createSuper(js);
  function js() {
    var _this7;
    _classCallCheck(this, js);
    _this7 = _super7.apply(this, arguments);
    C(_assertThisInitialized(_this7), "priority", 130);
    C(_assertThisInitialized(_this7), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
    return _this7;
  }
  _createClass(js, [{
    key: "parse",
    value: function parse(t, e) {
      return ln(e === "u" ? 4 : e.length, t);
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      return t.setFullYear(a, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
  }]);
  return js;
}(q);
var zs = /*#__PURE__*/function (_q6) {
  _inherits(zs, _q6);
  var _super8 = _createSuper(zs);
  function zs() {
    var _this8;
    _classCallCheck(this, zs);
    _this8 = _super8.apply(this, arguments);
    C(_assertThisInitialized(_this8), "priority", 120);
    C(_assertThisInitialized(_this8), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]);
    return _this8;
  }
  _createClass(zs, [{
    key: "parse",
    value: function parse(t, e, a) {
      switch (e) {
        // 1, 2, 3, 4
        case "Q":
        case "QQ":
          return ee(e.length, t);
        // 1st, 2nd, 3rd, 4th
        case "Qo":
          return a.ordinalNumber(t, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "QQQ":
          return a.quarter(t, {
            width: "abbreviated",
            context: "formatting"
          }) || a.quarter(t, {
            width: "narrow",
            context: "formatting"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "QQQQQ":
          return a.quarter(t, {
            width: "narrow",
            context: "formatting"
          });
        // 1st quarter, 2nd quarter, ...
        case "QQQQ":
        default:
          return a.quarter(t, {
            width: "wide",
            context: "formatting"
          }) || a.quarter(t, {
            width: "abbreviated",
            context: "formatting"
          }) || a.quarter(t, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(t, e) {
      return e >= 1 && e <= 4;
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      return t.setMonth((a - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
    }
  }]);
  return zs;
}(q);
var Us = /*#__PURE__*/function (_q7) {
  _inherits(Us, _q7);
  var _super9 = _createSuper(Us);
  function Us() {
    var _this9;
    _classCallCheck(this, Us);
    _this9 = _super9.apply(this, arguments);
    C(_assertThisInitialized(_this9), "priority", 120);
    C(_assertThisInitialized(_this9), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]);
    return _this9;
  }
  _createClass(Us, [{
    key: "parse",
    value: function parse(t, e, a) {
      switch (e) {
        // 1, 2, 3, 4
        case "q":
        case "qq":
          return ee(e.length, t);
        // 1st, 2nd, 3rd, 4th
        case "qo":
          return a.ordinalNumber(t, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "qqq":
          return a.quarter(t, {
            width: "abbreviated",
            context: "standalone"
          }) || a.quarter(t, {
            width: "narrow",
            context: "standalone"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "qqqqq":
          return a.quarter(t, {
            width: "narrow",
            context: "standalone"
          });
        // 1st quarter, 2nd quarter, ...
        case "qqqq":
        default:
          return a.quarter(t, {
            width: "wide",
            context: "standalone"
          }) || a.quarter(t, {
            width: "abbreviated",
            context: "standalone"
          }) || a.quarter(t, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(t, e) {
      return e >= 1 && e <= 4;
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      return t.setMonth((a - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
    }
  }]);
  return Us;
}(q);
var Xs = /*#__PURE__*/function (_q8) {
  _inherits(Xs, _q8);
  var _super10 = _createSuper(Xs);
  function Xs() {
    var _this10;
    _classCallCheck(this, Xs);
    _this10 = _super10.apply(this, arguments);
    C(_assertThisInitialized(_this10), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]);
    C(_assertThisInitialized(_this10), "priority", 110);
    return _this10;
  }
  _createClass(Xs, [{
    key: "parse",
    value: function parse(t, e, a) {
      var o = function o(i) {
        return i - 1;
      };
      switch (e) {
        // 1, 2, ..., 12
        case "M":
          return ne(Z(te.month, t), o);
        // 01, 02, ..., 12
        case "MM":
          return ne(ee(2, t), o);
        // 1st, 2nd, ..., 12th
        case "Mo":
          return ne(a.ordinalNumber(t, {
            unit: "month"
          }), o);
        // Jan, Feb, ..., Dec
        case "MMM":
          return a.month(t, {
            width: "abbreviated",
            context: "formatting"
          }) || a.month(t, {
            width: "narrow",
            context: "formatting"
          });
        // J, F, ..., D
        case "MMMMM":
          return a.month(t, {
            width: "narrow",
            context: "formatting"
          });
        // January, February, ..., December
        case "MMMM":
        default:
          return a.month(t, {
            width: "wide",
            context: "formatting"
          }) || a.month(t, {
            width: "abbreviated",
            context: "formatting"
          }) || a.month(t, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(t, e) {
      return e >= 0 && e <= 11;
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      return t.setMonth(a, 1), t.setHours(0, 0, 0, 0), t;
    }
  }]);
  return Xs;
}(q);
var Gs = /*#__PURE__*/function (_q9) {
  _inherits(Gs, _q9);
  var _super11 = _createSuper(Gs);
  function Gs() {
    var _this11;
    _classCallCheck(this, Gs);
    _this11 = _super11.apply(this, arguments);
    C(_assertThisInitialized(_this11), "priority", 110);
    C(_assertThisInitialized(_this11), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]);
    return _this11;
  }
  _createClass(Gs, [{
    key: "parse",
    value: function parse(t, e, a) {
      var o = function o(i) {
        return i - 1;
      };
      switch (e) {
        // 1, 2, ..., 12
        case "L":
          return ne(Z(te.month, t), o);
        // 01, 02, ..., 12
        case "LL":
          return ne(ee(2, t), o);
        // 1st, 2nd, ..., 12th
        case "Lo":
          return ne(a.ordinalNumber(t, {
            unit: "month"
          }), o);
        // Jan, Feb, ..., Dec
        case "LLL":
          return a.month(t, {
            width: "abbreviated",
            context: "standalone"
          }) || a.month(t, {
            width: "narrow",
            context: "standalone"
          });
        // J, F, ..., D
        case "LLLLL":
          return a.month(t, {
            width: "narrow",
            context: "standalone"
          });
        // January, February, ..., December
        case "LLLL":
        default:
          return a.month(t, {
            width: "wide",
            context: "standalone"
          }) || a.month(t, {
            width: "abbreviated",
            context: "standalone"
          }) || a.month(t, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(t, e) {
      return e >= 0 && e <= 11;
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      return t.setMonth(a, 1), t.setHours(0, 0, 0, 0), t;
    }
  }]);
  return Gs;
}(q);
function Zs(n, r, t) {
  var e = M(n),
    a = ya(e, t) - r;
  return e.setDate(e.getDate() - a * 7), e;
}
var Js = /*#__PURE__*/function (_q10) {
  _inherits(Js, _q10);
  var _super12 = _createSuper(Js);
  function Js() {
    var _this12;
    _classCallCheck(this, Js);
    _this12 = _super12.apply(this, arguments);
    C(_assertThisInitialized(_this12), "priority", 100);
    C(_assertThisInitialized(_this12), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]);
    return _this12;
  }
  _createClass(Js, [{
    key: "parse",
    value: function parse(t, e, a) {
      switch (e) {
        case "w":
          return Z(te.week, t);
        case "wo":
          return a.ordinalNumber(t, {
            unit: "week"
          });
        default:
          return ee(e.length, t);
      }
    }
  }, {
    key: "validate",
    value: function validate(t, e) {
      return e >= 1 && e <= 53;
    }
  }, {
    key: "set",
    value: function set(t, e, a, o) {
      return Le(Zs(t, a, o), o);
    }
  }]);
  return Js;
}(q);
function ec(n, r) {
  var t = M(n),
    e = zn(t) - r;
  return t.setDate(t.getDate() - e * 7), t;
}
var tc = /*#__PURE__*/function (_q11) {
  _inherits(tc, _q11);
  var _super13 = _createSuper(tc);
  function tc() {
    var _this13;
    _classCallCheck(this, tc);
    _this13 = _super13.apply(this, arguments);
    C(_assertThisInitialized(_this13), "priority", 100);
    C(_assertThisInitialized(_this13), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]);
    return _this13;
  }
  _createClass(tc, [{
    key: "parse",
    value: function parse(t, e, a) {
      switch (e) {
        case "I":
          return Z(te.week, t);
        case "Io":
          return a.ordinalNumber(t, {
            unit: "week"
          });
        default:
          return ee(e.length, t);
      }
    }
  }, {
    key: "validate",
    value: function validate(t, e) {
      return e >= 1 && e <= 53;
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      return pt(ec(t, a));
    }
  }]);
  return tc;
}(q);
var nc = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  rc = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var ac = /*#__PURE__*/function (_q12) {
  _inherits(ac, _q12);
  var _super14 = _createSuper(ac);
  function ac() {
    var _this14;
    _classCallCheck(this, ac);
    _this14 = _super14.apply(this, arguments);
    C(_assertThisInitialized(_this14), "priority", 90);
    C(_assertThisInitialized(_this14), "subPriority", 1);
    C(_assertThisInitialized(_this14), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]);
    return _this14;
  }
  _createClass(ac, [{
    key: "parse",
    value: function parse(t, e, a) {
      switch (e) {
        case "d":
          return Z(te.date, t);
        case "do":
          return a.ordinalNumber(t, {
            unit: "date"
          });
        default:
          return ee(e.length, t);
      }
    }
  }, {
    key: "validate",
    value: function validate(t, e) {
      var a = t.getFullYear(),
        o = Sa(a),
        i = t.getMonth();
      return o ? e >= 1 && e <= rc[i] : e >= 1 && e <= nc[i];
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      return t.setDate(a), t.setHours(0, 0, 0, 0), t;
    }
  }]);
  return ac;
}(q);
var oc = /*#__PURE__*/function (_q13) {
  _inherits(oc, _q13);
  var _super15 = _createSuper(oc);
  function oc() {
    var _this15;
    _classCallCheck(this, oc);
    _this15 = _super15.apply(this, arguments);
    C(_assertThisInitialized(_this15), "priority", 90);
    C(_assertThisInitialized(_this15), "subpriority", 1);
    C(_assertThisInitialized(_this15), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]);
    return _this15;
  }
  _createClass(oc, [{
    key: "parse",
    value: function parse(t, e, a) {
      switch (e) {
        case "D":
        case "DD":
          return Z(te.dayOfYear, t);
        case "Do":
          return a.ordinalNumber(t, {
            unit: "date"
          });
        default:
          return ee(e.length, t);
      }
    }
  }, {
    key: "validate",
    value: function validate(t, e) {
      var a = t.getFullYear();
      return Sa(a) ? e >= 1 && e <= 366 : e >= 1 && e <= 365;
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      return t.setMonth(0, a), t.setHours(0, 0, 0, 0), t;
    }
  }]);
  return oc;
}(q);
function Gn(n, r, t) {
  var _ref38, _ref39, _ref40, _ref41;
  var d, f, p, h;
  var e = ot(),
    a = (_ref38 = (_ref39 = (_ref40 = (_ref41 = t == null ? void 0 : t.weekStartsOn) !== null && _ref41 !== void 0 ? _ref41 : (f = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : f.weekStartsOn) !== null && _ref40 !== void 0 ? _ref40 : e.weekStartsOn) !== null && _ref39 !== void 0 ? _ref39 : (h = (p = e.locale) == null ? void 0 : p.options) == null ? void 0 : h.weekStartsOn) !== null && _ref38 !== void 0 ? _ref38 : 0,
    o = M(n),
    i = o.getDay(),
    c = (r % 7 + 7) % 7,
    l = 7 - a,
    u = r < 0 || r > 6 ? r - (i + l) % 7 : (c + l) % 7 - (i + l) % 7;
  return we(o, u);
}
var ic = /*#__PURE__*/function (_q14) {
  _inherits(ic, _q14);
  var _super16 = _createSuper(ic);
  function ic() {
    var _this16;
    _classCallCheck(this, ic);
    _this16 = _super16.apply(this, arguments);
    C(_assertThisInitialized(_this16), "priority", 90);
    C(_assertThisInitialized(_this16), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
    return _this16;
  }
  _createClass(ic, [{
    key: "parse",
    value: function parse(t, e, a) {
      switch (e) {
        // Tue
        case "E":
        case "EE":
        case "EEE":
          return a.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(t, {
            width: "short",
            context: "formatting"
          }) || a.day(t, {
            width: "narrow",
            context: "formatting"
          });
        // T
        case "EEEEE":
          return a.day(t, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "EEEEEE":
          return a.day(t, {
            width: "short",
            context: "formatting"
          }) || a.day(t, {
            width: "narrow",
            context: "formatting"
          });
        // Tuesday
        case "EEEE":
        default:
          return a.day(t, {
            width: "wide",
            context: "formatting"
          }) || a.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(t, {
            width: "short",
            context: "formatting"
          }) || a.day(t, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(t, e) {
      return e >= 0 && e <= 6;
    }
  }, {
    key: "set",
    value: function set(t, e, a, o) {
      return t = Gn(t, a, o), t.setHours(0, 0, 0, 0), t;
    }
  }]);
  return ic;
}(q);
var sc = /*#__PURE__*/function (_q15) {
  _inherits(sc, _q15);
  var _super17 = _createSuper(sc);
  function sc() {
    var _this17;
    _classCallCheck(this, sc);
    _this17 = _super17.apply(this, arguments);
    C(_assertThisInitialized(_this17), "priority", 90);
    C(_assertThisInitialized(_this17), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]);
    return _this17;
  }
  _createClass(sc, [{
    key: "parse",
    value: function parse(t, e, a, o) {
      var i = function i(s) {
        var c = Math.floor((s - 1) / 7) * 7;
        return (s + o.weekStartsOn + 6) % 7 + c;
      };
      switch (e) {
        // 3
        case "e":
        case "ee":
          return ne(ee(e.length, t), i);
        // 3rd
        case "eo":
          return ne(a.ordinalNumber(t, {
            unit: "day"
          }), i);
        // Tue
        case "eee":
          return a.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(t, {
            width: "short",
            context: "formatting"
          }) || a.day(t, {
            width: "narrow",
            context: "formatting"
          });
        // T
        case "eeeee":
          return a.day(t, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "eeeeee":
          return a.day(t, {
            width: "short",
            context: "formatting"
          }) || a.day(t, {
            width: "narrow",
            context: "formatting"
          });
        // Tuesday
        case "eeee":
        default:
          return a.day(t, {
            width: "wide",
            context: "formatting"
          }) || a.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(t, {
            width: "short",
            context: "formatting"
          }) || a.day(t, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(t, e) {
      return e >= 0 && e <= 6;
    }
  }, {
    key: "set",
    value: function set(t, e, a, o) {
      return t = Gn(t, a, o), t.setHours(0, 0, 0, 0), t;
    }
  }]);
  return sc;
}(q);
var cc = /*#__PURE__*/function (_q16) {
  _inherits(cc, _q16);
  var _super18 = _createSuper(cc);
  function cc() {
    var _this18;
    _classCallCheck(this, cc);
    _this18 = _super18.apply(this, arguments);
    C(_assertThisInitialized(_this18), "priority", 90);
    C(_assertThisInitialized(_this18), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]);
    return _this18;
  }
  _createClass(cc, [{
    key: "parse",
    value: function parse(t, e, a, o) {
      var i = function i(s) {
        var c = Math.floor((s - 1) / 7) * 7;
        return (s + o.weekStartsOn + 6) % 7 + c;
      };
      switch (e) {
        // 3
        case "c":
        case "cc":
          return ne(ee(e.length, t), i);
        // 3rd
        case "co":
          return ne(a.ordinalNumber(t, {
            unit: "day"
          }), i);
        // Tue
        case "ccc":
          return a.day(t, {
            width: "abbreviated",
            context: "standalone"
          }) || a.day(t, {
            width: "short",
            context: "standalone"
          }) || a.day(t, {
            width: "narrow",
            context: "standalone"
          });
        // T
        case "ccccc":
          return a.day(t, {
            width: "narrow",
            context: "standalone"
          });
        // Tu
        case "cccccc":
          return a.day(t, {
            width: "short",
            context: "standalone"
          }) || a.day(t, {
            width: "narrow",
            context: "standalone"
          });
        // Tuesday
        case "cccc":
        default:
          return a.day(t, {
            width: "wide",
            context: "standalone"
          }) || a.day(t, {
            width: "abbreviated",
            context: "standalone"
          }) || a.day(t, {
            width: "short",
            context: "standalone"
          }) || a.day(t, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(t, e) {
      return e >= 0 && e <= 6;
    }
  }, {
    key: "set",
    value: function set(t, e, a, o) {
      return t = Gn(t, a, o), t.setHours(0, 0, 0, 0), t;
    }
  }]);
  return cc;
}(q);
function lc(n, r) {
  var t = M(n),
    e = Is(t),
    a = r - e;
  return we(t, a);
}
var uc = /*#__PURE__*/function (_q17) {
  _inherits(uc, _q17);
  var _super19 = _createSuper(uc);
  function uc() {
    var _this19;
    _classCallCheck(this, uc);
    _this19 = _super19.apply(this, arguments);
    C(_assertThisInitialized(_this19), "priority", 90);
    C(_assertThisInitialized(_this19), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]);
    return _this19;
  }
  _createClass(uc, [{
    key: "parse",
    value: function parse(t, e, a) {
      var o = function o(i) {
        return i === 0 ? 7 : i;
      };
      switch (e) {
        // 2
        case "i":
        case "ii":
          return ee(e.length, t);
        // 2nd
        case "io":
          return a.ordinalNumber(t, {
            unit: "day"
          });
        // Tue
        case "iii":
          return ne(a.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(t, {
            width: "short",
            context: "formatting"
          }) || a.day(t, {
            width: "narrow",
            context: "formatting"
          }), o);
        // T
        case "iiiii":
          return ne(a.day(t, {
            width: "narrow",
            context: "formatting"
          }), o);
        // Tu
        case "iiiiii":
          return ne(a.day(t, {
            width: "short",
            context: "formatting"
          }) || a.day(t, {
            width: "narrow",
            context: "formatting"
          }), o);
        // Tuesday
        case "iiii":
        default:
          return ne(a.day(t, {
            width: "wide",
            context: "formatting"
          }) || a.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(t, {
            width: "short",
            context: "formatting"
          }) || a.day(t, {
            width: "narrow",
            context: "formatting"
          }), o);
      }
    }
  }, {
    key: "validate",
    value: function validate(t, e) {
      return e >= 1 && e <= 7;
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      return t = lc(t, a), t.setHours(0, 0, 0, 0), t;
    }
  }]);
  return uc;
}(q);
var dc = /*#__PURE__*/function (_q18) {
  _inherits(dc, _q18);
  var _super20 = _createSuper(dc);
  function dc() {
    var _this20;
    _classCallCheck(this, dc);
    _this20 = _super20.apply(this, arguments);
    C(_assertThisInitialized(_this20), "priority", 80);
    C(_assertThisInitialized(_this20), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
    return _this20;
  }
  _createClass(dc, [{
    key: "parse",
    value: function parse(t, e, a) {
      switch (e) {
        case "a":
        case "aa":
        case "aaa":
          return a.dayPeriod(t, {
            width: "abbreviated",
            context: "formatting"
          }) || a.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return a.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return a.dayPeriod(t, {
            width: "wide",
            context: "formatting"
          }) || a.dayPeriod(t, {
            width: "abbreviated",
            context: "formatting"
          }) || a.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      return t.setHours(Xn(a), 0, 0, 0), t;
    }
  }]);
  return dc;
}(q);
var fc = /*#__PURE__*/function (_q19) {
  _inherits(fc, _q19);
  var _super21 = _createSuper(fc);
  function fc() {
    var _this21;
    _classCallCheck(this, fc);
    _this21 = _super21.apply(this, arguments);
    C(_assertThisInitialized(_this21), "priority", 80);
    C(_assertThisInitialized(_this21), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
    return _this21;
  }
  _createClass(fc, [{
    key: "parse",
    value: function parse(t, e, a) {
      switch (e) {
        case "b":
        case "bb":
        case "bbb":
          return a.dayPeriod(t, {
            width: "abbreviated",
            context: "formatting"
          }) || a.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return a.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return a.dayPeriod(t, {
            width: "wide",
            context: "formatting"
          }) || a.dayPeriod(t, {
            width: "abbreviated",
            context: "formatting"
          }) || a.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      return t.setHours(Xn(a), 0, 0, 0), t;
    }
  }]);
  return fc;
}(q);
var pc = /*#__PURE__*/function (_q20) {
  _inherits(pc, _q20);
  var _super22 = _createSuper(pc);
  function pc() {
    var _this22;
    _classCallCheck(this, pc);
    _this22 = _super22.apply(this, arguments);
    C(_assertThisInitialized(_this22), "priority", 80);
    C(_assertThisInitialized(_this22), "incompatibleTokens", ["a", "b", "t", "T"]);
    return _this22;
  }
  _createClass(pc, [{
    key: "parse",
    value: function parse(t, e, a) {
      switch (e) {
        case "B":
        case "BB":
        case "BBB":
          return a.dayPeriod(t, {
            width: "abbreviated",
            context: "formatting"
          }) || a.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return a.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return a.dayPeriod(t, {
            width: "wide",
            context: "formatting"
          }) || a.dayPeriod(t, {
            width: "abbreviated",
            context: "formatting"
          }) || a.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      return t.setHours(Xn(a), 0, 0, 0), t;
    }
  }]);
  return pc;
}(q);
var hc = /*#__PURE__*/function (_q21) {
  _inherits(hc, _q21);
  var _super23 = _createSuper(hc);
  function hc() {
    var _this23;
    _classCallCheck(this, hc);
    _this23 = _super23.apply(this, arguments);
    C(_assertThisInitialized(_this23), "priority", 70);
    C(_assertThisInitialized(_this23), "incompatibleTokens", ["H", "K", "k", "t", "T"]);
    return _this23;
  }
  _createClass(hc, [{
    key: "parse",
    value: function parse(t, e, a) {
      switch (e) {
        case "h":
          return Z(te.hour12h, t);
        case "ho":
          return a.ordinalNumber(t, {
            unit: "hour"
          });
        default:
          return ee(e.length, t);
      }
    }
  }, {
    key: "validate",
    value: function validate(t, e) {
      return e >= 1 && e <= 12;
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      var o = t.getHours() >= 12;
      return o && a < 12 ? t.setHours(a + 12, 0, 0, 0) : !o && a === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(a, 0, 0, 0), t;
    }
  }]);
  return hc;
}(q);
var mc = /*#__PURE__*/function (_q22) {
  _inherits(mc, _q22);
  var _super24 = _createSuper(mc);
  function mc() {
    var _this24;
    _classCallCheck(this, mc);
    _this24 = _super24.apply(this, arguments);
    C(_assertThisInitialized(_this24), "priority", 70);
    C(_assertThisInitialized(_this24), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
    return _this24;
  }
  _createClass(mc, [{
    key: "parse",
    value: function parse(t, e, a) {
      switch (e) {
        case "H":
          return Z(te.hour23h, t);
        case "Ho":
          return a.ordinalNumber(t, {
            unit: "hour"
          });
        default:
          return ee(e.length, t);
      }
    }
  }, {
    key: "validate",
    value: function validate(t, e) {
      return e >= 0 && e <= 23;
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      return t.setHours(a, 0, 0, 0), t;
    }
  }]);
  return mc;
}(q);
var gc = /*#__PURE__*/function (_q23) {
  _inherits(gc, _q23);
  var _super25 = _createSuper(gc);
  function gc() {
    var _this25;
    _classCallCheck(this, gc);
    _this25 = _super25.apply(this, arguments);
    C(_assertThisInitialized(_this25), "priority", 70);
    C(_assertThisInitialized(_this25), "incompatibleTokens", ["h", "H", "k", "t", "T"]);
    return _this25;
  }
  _createClass(gc, [{
    key: "parse",
    value: function parse(t, e, a) {
      switch (e) {
        case "K":
          return Z(te.hour11h, t);
        case "Ko":
          return a.ordinalNumber(t, {
            unit: "hour"
          });
        default:
          return ee(e.length, t);
      }
    }
  }, {
    key: "validate",
    value: function validate(t, e) {
      return e >= 0 && e <= 11;
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      return t.getHours() >= 12 && a < 12 ? t.setHours(a + 12, 0, 0, 0) : t.setHours(a, 0, 0, 0), t;
    }
  }]);
  return gc;
}(q);
var vc = /*#__PURE__*/function (_q24) {
  _inherits(vc, _q24);
  var _super26 = _createSuper(vc);
  function vc() {
    var _this26;
    _classCallCheck(this, vc);
    _this26 = _super26.apply(this, arguments);
    C(_assertThisInitialized(_this26), "priority", 70);
    C(_assertThisInitialized(_this26), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
    return _this26;
  }
  _createClass(vc, [{
    key: "parse",
    value: function parse(t, e, a) {
      switch (e) {
        case "k":
          return Z(te.hour24h, t);
        case "ko":
          return a.ordinalNumber(t, {
            unit: "hour"
          });
        default:
          return ee(e.length, t);
      }
    }
  }, {
    key: "validate",
    value: function validate(t, e) {
      return e >= 1 && e <= 24;
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      var o = a <= 24 ? a % 24 : a;
      return t.setHours(o, 0, 0, 0), t;
    }
  }]);
  return vc;
}(q);
var wc = /*#__PURE__*/function (_q25) {
  _inherits(wc, _q25);
  var _super27 = _createSuper(wc);
  function wc() {
    var _this27;
    _classCallCheck(this, wc);
    _this27 = _super27.apply(this, arguments);
    C(_assertThisInitialized(_this27), "priority", 60);
    C(_assertThisInitialized(_this27), "incompatibleTokens", ["t", "T"]);
    return _this27;
  }
  _createClass(wc, [{
    key: "parse",
    value: function parse(t, e, a) {
      switch (e) {
        case "m":
          return Z(te.minute, t);
        case "mo":
          return a.ordinalNumber(t, {
            unit: "minute"
          });
        default:
          return ee(e.length, t);
      }
    }
  }, {
    key: "validate",
    value: function validate(t, e) {
      return e >= 0 && e <= 59;
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      return t.setMinutes(a, 0, 0), t;
    }
  }]);
  return wc;
}(q);
var bc = /*#__PURE__*/function (_q26) {
  _inherits(bc, _q26);
  var _super28 = _createSuper(bc);
  function bc() {
    var _this28;
    _classCallCheck(this, bc);
    _this28 = _super28.apply(this, arguments);
    C(_assertThisInitialized(_this28), "priority", 50);
    C(_assertThisInitialized(_this28), "incompatibleTokens", ["t", "T"]);
    return _this28;
  }
  _createClass(bc, [{
    key: "parse",
    value: function parse(t, e, a) {
      switch (e) {
        case "s":
          return Z(te.second, t);
        case "so":
          return a.ordinalNumber(t, {
            unit: "second"
          });
        default:
          return ee(e.length, t);
      }
    }
  }, {
    key: "validate",
    value: function validate(t, e) {
      return e >= 0 && e <= 59;
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      return t.setSeconds(a, 0), t;
    }
  }]);
  return bc;
}(q);
var yc = /*#__PURE__*/function (_q27) {
  _inherits(yc, _q27);
  var _super29 = _createSuper(yc);
  function yc() {
    var _this29;
    _classCallCheck(this, yc);
    _this29 = _super29.apply(this, arguments);
    C(_assertThisInitialized(_this29), "priority", 30);
    C(_assertThisInitialized(_this29), "incompatibleTokens", ["t", "T"]);
    return _this29;
  }
  _createClass(yc, [{
    key: "parse",
    value: function parse(t, e) {
      var a = function a(o) {
        return Math.trunc(o * Math.pow(10, -e.length + 3));
      };
      return ne(ee(e.length, t), a);
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      return t.setMilliseconds(a), t;
    }
  }]);
  return yc;
}(q);
var Dc = /*#__PURE__*/function (_q28) {
  _inherits(Dc, _q28);
  var _super30 = _createSuper(Dc);
  function Dc() {
    var _this30;
    _classCallCheck(this, Dc);
    _this30 = _super30.apply(this, arguments);
    C(_assertThisInitialized(_this30), "priority", 10);
    C(_assertThisInitialized(_this30), "incompatibleTokens", ["t", "T", "x"]);
    return _this30;
  }
  _createClass(Dc, [{
    key: "parse",
    value: function parse(t, e) {
      switch (e) {
        case "X":
          return _e(xe.basicOptionalMinutes, t);
        case "XX":
          return _e(xe.basic, t);
        case "XXXX":
          return _e(xe.basicOptionalSeconds, t);
        case "XXXXX":
          return _e(xe.extendedOptionalSeconds, t);
        case "XXX":
        default:
          return _e(xe.extended, t);
      }
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      return e.timestampIsSet ? t : z(t, t.getTime() - tn(t) - a);
    }
  }]);
  return Dc;
}(q);
var kc = /*#__PURE__*/function (_q29) {
  _inherits(kc, _q29);
  var _super31 = _createSuper(kc);
  function kc() {
    var _this31;
    _classCallCheck(this, kc);
    _this31 = _super31.apply(this, arguments);
    C(_assertThisInitialized(_this31), "priority", 10);
    C(_assertThisInitialized(_this31), "incompatibleTokens", ["t", "T", "X"]);
    return _this31;
  }
  _createClass(kc, [{
    key: "parse",
    value: function parse(t, e) {
      switch (e) {
        case "x":
          return _e(xe.basicOptionalMinutes, t);
        case "xx":
          return _e(xe.basic, t);
        case "xxxx":
          return _e(xe.basicOptionalSeconds, t);
        case "xxxxx":
          return _e(xe.extendedOptionalSeconds, t);
        case "xxx":
        default:
          return _e(xe.extended, t);
      }
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      return e.timestampIsSet ? t : z(t, t.getTime() - tn(t) - a);
    }
  }]);
  return kc;
}(q);
var xc = /*#__PURE__*/function (_q30) {
  _inherits(xc, _q30);
  var _super32 = _createSuper(xc);
  function xc() {
    var _this32;
    _classCallCheck(this, xc);
    _this32 = _super32.apply(this, arguments);
    C(_assertThisInitialized(_this32), "priority", 40);
    C(_assertThisInitialized(_this32), "incompatibleTokens", "*");
    return _this32;
  }
  _createClass(xc, [{
    key: "parse",
    value: function parse(t) {
      return Ma(t);
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      return [z(t, a * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]);
  return xc;
}(q);
var _c = /*#__PURE__*/function (_q31) {
  _inherits(_c, _q31);
  var _super33 = _createSuper(_c);
  function _c() {
    var _this33;
    _classCallCheck(this, _c);
    _this33 = _super33.apply(this, arguments);
    C(_assertThisInitialized(_this33), "priority", 20);
    C(_assertThisInitialized(_this33), "incompatibleTokens", "*");
    return _this33;
  }
  _createClass(_c, [{
    key: "parse",
    value: function parse(t) {
      return Ma(t);
    }
  }, {
    key: "set",
    value: function set(t, e, a) {
      return [z(t, a), {
        timestampIsSet: !0
      }];
    }
  }]);
  return _c;
}(q);
var Mc = {
    G: new Qs(),
    y: new Vs(),
    Y: new qs(),
    R: new Ks(),
    u: new js(),
    Q: new zs(),
    q: new Us(),
    M: new Xs(),
    L: new Gs(),
    w: new Js(),
    I: new tc(),
    d: new ac(),
    D: new oc(),
    E: new ic(),
    e: new sc(),
    c: new cc(),
    i: new uc(),
    a: new dc(),
    b: new fc(),
    B: new pc(),
    h: new hc(),
    H: new mc(),
    K: new gc(),
    k: new vc(),
    m: new wc(),
    s: new bc(),
    S: new yc(),
    X: new Dc(),
    x: new kc(),
    t: new xc(),
    T: new _c()
  },
  Cc = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,
  Sc = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,
  Pc = /^'([^]*?)'?$/,
  Ec = /''/g,
  Oc = /\S/,
  Tc = /[a-zA-Z]/;
function Sn(n, r, t, e) {
  var _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51;
  var g, v, w, D, b, P, S, T;
  var a = Fs(),
    o = (_ref42 = (_ref43 = e == null ? void 0 : e.locale) !== null && _ref43 !== void 0 ? _ref43 : a.locale) !== null && _ref42 !== void 0 ? _ref42 : ba,
    i = (_ref44 = (_ref45 = (_ref46 = (_ref47 = e == null ? void 0 : e.firstWeekContainsDate) !== null && _ref47 !== void 0 ? _ref47 : (v = (g = e == null ? void 0 : e.locale) == null ? void 0 : g.options) == null ? void 0 : v.firstWeekContainsDate) !== null && _ref46 !== void 0 ? _ref46 : a.firstWeekContainsDate) !== null && _ref45 !== void 0 ? _ref45 : (D = (w = a.locale) == null ? void 0 : w.options) == null ? void 0 : D.firstWeekContainsDate) !== null && _ref44 !== void 0 ? _ref44 : 1,
    s = (_ref48 = (_ref49 = (_ref50 = (_ref51 = e == null ? void 0 : e.weekStartsOn) !== null && _ref51 !== void 0 ? _ref51 : (P = (b = e == null ? void 0 : e.locale) == null ? void 0 : b.options) == null ? void 0 : P.weekStartsOn) !== null && _ref50 !== void 0 ? _ref50 : a.weekStartsOn) !== null && _ref49 !== void 0 ? _ref49 : (T = (S = a.locale) == null ? void 0 : S.options) == null ? void 0 : T.weekStartsOn) !== null && _ref48 !== void 0 ? _ref48 : 0;
  if (r === "") return n === "" ? M(t) : z(t, NaN);
  var c = {
      firstWeekContainsDate: i,
      weekStartsOn: s,
      locale: o
    },
    l = [new Bs()],
    u = r.match(Sc).map(function (y) {
      var x = y[0];
      if (x in cn) {
        var E = cn[x];
        return E(y, o.formatLong);
      }
      return y;
    }).join("").match(Cc),
    d = [];
  var _loop = function _loop() {
    if (_isArray) {
      if (_i4 >= _iterator.length) return "break";
      _ref52 = _iterator[_i4++];
    } else {
      _i4 = _iterator.next();
      if (_i4.done) return "break";
      _ref52 = _i4.value;
    }
    var y = _ref52;
    !(e != null && e.useAdditionalWeekYearTokens) && xa(y) && Hn(y, r, n), !(e != null && e.useAdditionalDayOfYearTokens) && ka(y) && Hn(y, r, n);
    var x = y[0],
      E = Mc[x];
    if (E) {
      var B = E.incompatibleTokens;
      if (Array.isArray(B)) {
        var N = d.find(function (W) {
          return B.includes(W.token) || W.token === x;
        });
        if (N) throw new RangeError("The format string mustn't contain `".concat(N.fullToken, "` and `").concat(y, "` at the same time"));
      } else if (E.incompatibleTokens === "*" && d.length > 0) throw new RangeError("The format string mustn't contain `".concat(y, "` and any other token at the same time"));
      d.push({
        token: x,
        fullToken: y
      });
      var L = E.run(n, y, o.match, c);
      if (!L) return {
        v: z(t, NaN)
      };
      l.push(L.setter), n = L.rest;
    } else {
      if (x.match(Tc)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + x + "`");
      if (y === "''" ? y = "'" : x === "'" && (y = Nc(y)), n.indexOf(y) === 0) n = n.slice(y.length);else return {
        v: z(t, NaN)
      };
    }
  };
  for (var _iterator = u, _isArray = Array.isArray(_iterator), _i4 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref52;
    var _ret = _loop();
    if (_ret === "break") break;
    if (typeof _ret === "object") return _ret.v;
  }
  if (n.length > 0 && Oc.test(n)) return z(t, NaN);
  var f = l.map(function (y) {
    return y.priority;
  }).sort(function (y, x) {
    return x - y;
  }).filter(function (y, x, E) {
    return E.indexOf(y) === x;
  }).map(function (y) {
    return l.filter(function (x) {
      return x.priority === y;
    }).sort(function (x, E) {
      return E.subPriority - x.subPriority;
    });
  }).map(function (y) {
    return y[0];
  });
  var p = M(t);
  if (isNaN(p.getTime())) return z(t, NaN);
  var h = {};
  for (var _iterator2 = f, _isArray2 = Array.isArray(_iterator2), _i5 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
    var _ref53;
    if (_isArray2) {
      if (_i5 >= _iterator2.length) break;
      _ref53 = _iterator2[_i5++];
    } else {
      _i5 = _iterator2.next();
      if (_i5.done) break;
      _ref53 = _i5.value;
    }
    var y = _ref53;
    if (!y.validate(p, c)) return z(t, NaN);
    var x = y.set(p, h, c);
    Array.isArray(x) ? (p = x[0], Object.assign(h, x[1])) : p = x;
  }
  return z(t, p);
}
function Nc(n) {
  return n.match(Pc)[1].replace(Ec, "'");
}
function Yc(n, r) {
  var t = M(n),
    e = M(r);
  return t.getFullYear() === e.getFullYear() && t.getMonth() === e.getMonth();
}
function Rc(n, r) {
  var t = An(n),
    e = An(r);
  return +t == +e;
}
function Lc(n, r) {
  var t = M(n),
    e = M(r);
  return t.getFullYear() === e.getFullYear();
}
function Ot(n, r) {
  var t = +M(n),
    _sort = [+M(r.start), +M(r.end)].sort(function (o, i) {
      return o - i;
    }),
    _sort2 = _slicedToArray(_sort, 2),
    e = _sort2[0],
    a = _sort2[1];
  return t >= e && t <= a;
}
function Fc(n, r) {
  return we(n, -r);
}
function Ic(n, r) {
  var e = Hc(n);
  var a;
  if (e.date) {
    var c = Bc(e.date, 2);
    a = Qc(c.restDateString, c.year);
  }
  if (!a || isNaN(a.getTime())) return /* @__PURE__ */new Date(NaN);
  var o = a.getTime();
  var i = 0,
    s;
  if (e.time && (i = Vc(e.time), isNaN(i))) return /* @__PURE__ */new Date(NaN);
  if (e.timezone) {
    if (s = qc(e.timezone), isNaN(s)) return /* @__PURE__ */new Date(NaN);
  } else {
    var _c2 = new Date(o + i),
      l = /* @__PURE__ */new Date(0);
    return l.setFullYear(_c2.getUTCFullYear(), _c2.getUTCMonth(), _c2.getUTCDate()), l.setHours(_c2.getUTCHours(), _c2.getUTCMinutes(), _c2.getUTCSeconds(), _c2.getUTCMilliseconds()), l;
  }
  return new Date(o + i + s);
}
var $t = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
  },
  $c = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/,
  Wc = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/,
  Ac = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function Hc(n) {
  var r = {},
    t = n.split($t.dateTimeDelimiter);
  var e;
  if (t.length > 2) return r;
  if (/:/.test(t[0]) ? e = t[0] : (r.date = t[0], e = t[1], $t.timeZoneDelimiter.test(r.date) && (r.date = n.split($t.timeZoneDelimiter)[0], e = n.substr(r.date.length, n.length))), e) {
    var a = $t.timezone.exec(e);
    a ? (r.time = e.replace(a[1], ""), r.timezone = a[1]) : r.time = e;
  }
  return r;
}
function Bc(n, r) {
  var t = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + r) + "})|(\\d{2}|[+-]\\d{" + (2 + r) + "})$)"),
    e = n.match(t);
  if (!e) return {
    year: NaN,
    restDateString: ""
  };
  var a = e[1] ? parseInt(e[1]) : null,
    o = e[2] ? parseInt(e[2]) : null;
  return {
    year: o === null ? a : o * 100,
    restDateString: n.slice((e[1] || e[2]).length)
  };
}
function Qc(n, r) {
  if (r === null) return /* @__PURE__ */new Date(NaN);
  var t = n.match($c);
  if (!t) return /* @__PURE__ */new Date(NaN);
  var e = !!t[4],
    a = _t(t[1]),
    o = _t(t[2]) - 1,
    i = _t(t[3]),
    s = _t(t[4]),
    c = _t(t[5]) - 1;
  if (e) return Xc(r, s, c) ? Kc(r, s, c) : /* @__PURE__ */new Date(NaN);
  {
    var l = /* @__PURE__ */new Date(0);
    return !zc(r, o, i) || !Uc(r, a) ? /* @__PURE__ */new Date(NaN) : (l.setUTCFullYear(r, o, Math.max(a, i)), l);
  }
}
function _t(n) {
  return n ? parseInt(n) : 1;
}
function Vc(n) {
  var r = n.match(Wc);
  if (!r) return NaN;
  var t = Pn(r[1]),
    e = Pn(r[2]),
    a = Pn(r[3]);
  return Gc(t, e, a) ? t * bn + e * wn + a * 1e3 : NaN;
}
function Pn(n) {
  return n && parseFloat(n.replace(",", ".")) || 0;
}
function qc(n) {
  if (n === "Z") return 0;
  var r = n.match(Ac);
  if (!r) return 0;
  var t = r[1] === "+" ? -1 : 1,
    e = parseInt(r[2]),
    a = r[3] && parseInt(r[3]) || 0;
  return Zc(e, a) ? t * (e * bn + a * wn) : NaN;
}
function Kc(n, r, t) {
  var e = /* @__PURE__ */new Date(0);
  e.setUTCFullYear(n, 0, 4);
  var a = e.getUTCDay() || 7,
    o = (r - 1) * 7 + t + 1 - a;
  return e.setUTCDate(e.getUTCDate() + o), e;
}
var jc = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Pa(n) {
  return n % 400 === 0 || n % 4 === 0 && n % 100 !== 0;
}
function zc(n, r, t) {
  return r >= 0 && r <= 11 && t >= 1 && t <= (jc[r] || (Pa(n) ? 29 : 28));
}
function Uc(n, r) {
  return r >= 1 && r <= (Pa(n) ? 366 : 365);
}
function Xc(n, r, t) {
  return r >= 1 && r <= 53 && t >= 0 && t <= 6;
}
function Gc(n, r, t) {
  return n === 24 ? r === 0 && t === 0 : t >= 0 && t < 60 && r >= 0 && r < 60 && n >= 0 && n < 25;
}
function Zc(n, r) {
  return r >= 0 && r <= 59;
}
function de(n, r) {
  var t = M(n),
    e = t.getFullYear(),
    a = t.getDate(),
    o = z(n, 0);
  o.setFullYear(e, r, 15), o.setHours(0, 0, 0, 0);
  var i = Ls(o);
  return t.setMonth(r, Math.min(a, i)), t;
}
function Jc(n, r) {
  var t = M(n);
  return isNaN(+t) ? z(n, NaN) : (r.year != null && t.setFullYear(r.year), r.month != null && (t = de(t, r.month)), r.date != null && t.setDate(r.date), r.hours != null && t.setHours(r.hours), r.minutes != null && t.setMinutes(r.minutes), r.seconds != null && t.setSeconds(r.seconds), r.milliseconds != null && t.setMilliseconds(r.milliseconds), t);
}
function Kt(n, r) {
  var t = M(n);
  return t.setHours(r), t;
}
function jt(n, r) {
  var t = M(n);
  return t.setMinutes(r), t;
}
function lt(n, r) {
  var t = M(n),
    e = Math.trunc(t.getMonth() / 3) + 1,
    a = r - e;
  return de(t, t.getMonth() + a * 3);
}
function zt(n, r) {
  var t = M(n);
  return t.setSeconds(r), t;
}
function De(n, r) {
  var t = M(n);
  return isNaN(+t) ? z(n, NaN) : (t.setFullYear(r), t);
}
function Ze(n, r) {
  return be(n, -r);
}
function Ea(n, r) {
  return jn(n, -r);
}
function _r(n, r) {
  return nn(n, -r);
}
function mt(n, r) {
  return Te(n, -r);
}
function el() {
  return typeof window < "u";
}
function Oa(n) {
  var r;
  return (n == null || (r = n.ownerDocument) == null ? void 0 : r.defaultView) || window;
}
function Ct(n) {
  return el() ? n instanceof Element || n instanceof Oa(n).Element : !1;
}
function tl(n) {
  return Oa(n).getComputedStyle(n);
}
var gt = Math.min,
  Je = Math.max,
  un = Math.round,
  Wt = Math.floor,
  qe = function qe(n) {
    return {
      x: n,
      y: n
    };
  },
  nl = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
  },
  rl = {
    start: "end",
    end: "start"
  };
function Qn(n, r, t) {
  return Je(n, gt(r, t));
}
function Yt(n, r) {
  return typeof n == "function" ? n(r) : n;
}
function rt(n) {
  return n.split("-")[0];
}
function Rt(n) {
  return n.split("-")[1];
}
function Ta(n) {
  return n === "x" ? "y" : "x";
}
function Zn(n) {
  return n === "y" ? "height" : "width";
}
function Dn(n) {
  return ["top", "bottom"].includes(rt(n)) ? "y" : "x";
}
function Jn(n) {
  return Ta(Dn(n));
}
function al(n, r, t) {
  t === void 0 && (t = !1);
  var e = Rt(n),
    a = Jn(n),
    o = Zn(a);
  var i = a === "x" ? e === (t ? "end" : "start") ? "right" : "left" : e === "start" ? "bottom" : "top";
  return r.reference[o] > r.floating[o] && (i = dn(i)), [i, dn(i)];
}
function ol(n) {
  var r = dn(n);
  return [Vn(n), r, Vn(r)];
}
function Vn(n) {
  return n.replace(/start|end/g, function (r) {
    return rl[r];
  });
}
function il(n, r, t) {
  var e = ["left", "right"],
    a = ["right", "left"],
    o = ["top", "bottom"],
    i = ["bottom", "top"];
  switch (n) {
    case "top":
    case "bottom":
      return t ? r ? a : e : r ? e : a;
    case "left":
    case "right":
      return r ? o : i;
    default:
      return [];
  }
}
function sl(n, r, t, e) {
  var a = Rt(n);
  var o = il(rt(n), t === "start", e);
  return a && (o = o.map(function (i) {
    return i + "-" + a;
  }), r && (o = o.concat(o.map(Vn)))), o;
}
function dn(n) {
  return n.replace(/left|right|bottom|top/g, function (r) {
    return nl[r];
  });
}
function cl(n) {
  return _objectSpread({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, n);
}
function Na(n) {
  return typeof n != "number" ? cl(n) : {
    top: n,
    right: n,
    bottom: n,
    left: n
  };
}
function fn(n) {
  return _objectSpread(_objectSpread({}, n), {}, {
    top: n.y,
    left: n.x,
    right: n.x + n.width,
    bottom: n.y + n.height
  });
}
function Mr(n, r, t) {
  var e = n.reference,
    a = n.floating;
  var o = Dn(r),
    i = Jn(r),
    s = Zn(i),
    c = rt(r),
    l = o === "y",
    u = e.x + e.width / 2 - a.width / 2,
    d = e.y + e.height / 2 - a.height / 2,
    f = e[s] / 2 - a[s] / 2;
  var p;
  switch (c) {
    case "top":
      p = {
        x: u,
        y: e.y - a.height
      };
      break;
    case "bottom":
      p = {
        x: u,
        y: e.y + e.height
      };
      break;
    case "right":
      p = {
        x: e.x + e.width,
        y: d
      };
      break;
    case "left":
      p = {
        x: e.x - a.width,
        y: d
      };
      break;
    default:
      p = {
        x: e.x,
        y: e.y
      };
  }
  switch (Rt(r)) {
    case "start":
      p[i] -= f * (t && l ? -1 : 1);
      break;
    case "end":
      p[i] += f * (t && l ? -1 : 1);
      break;
  }
  return p;
}
var ll = /*#__PURE__*/function () {
  var _ref54 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(n, r, t) {
    var _t$placement, e, _t$strategy, a, _t$middleware, o, i, s, c, l, _Mr, u, d, f, p, h, g, _Mr2, _s$g, v, w, _yield$w, D, b, P, S;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _t$placement = t.placement;
            e = _t$placement === void 0 ? "bottom" : _t$placement;
            _t$strategy = t.strategy;
            a = _t$strategy === void 0 ? "absolute" : _t$strategy;
            _t$middleware = t.middleware;
            o = _t$middleware === void 0 ? [] : _t$middleware;
            i = t.platform;
            s = o.filter(Boolean);
            _context.next = 10;
            return i.isRTL == null ? void 0 : i.isRTL(r);
          case 10:
            c = _context.sent;
            _context.next = 13;
            return i.getElementRects({
              reference: n,
              floating: r,
              strategy: a
            });
          case 13:
            l = _context.sent;
            _Mr = Mr(l, e, c);
            u = _Mr.x;
            d = _Mr.y;
            f = e;
            p = {};
            h = 0;
            g = 0;
          case 21:
            if (!(g < s.length)) {
              _context.next = 56;
              break;
            }
            _s$g = s[g];
            v = _s$g.name;
            w = _s$g.fn;
            _context.next = 27;
            return w({
              x: u,
              y: d,
              initialPlacement: e,
              placement: f,
              strategy: a,
              middlewareData: p,
              rects: l,
              platform: i,
              elements: {
                reference: n,
                floating: r
              }
            });
          case 27:
            _yield$w = _context.sent;
            D = _yield$w.x;
            b = _yield$w.y;
            P = _yield$w.data;
            S = _yield$w.reset;
            u = D !== null && D !== void 0 ? D : u;
            d = b !== null && b !== void 0 ? b : d;
            p = _objectSpread(_objectSpread({}, p), {}, {
              [v]: _objectSpread(_objectSpread({}, p[v]), P)
            });
            _context.t0 = S && h <= 50;
            if (!_context.t0) {
              _context.next = 53;
              break;
            }
            h++;
            _context.t1 = typeof S == "object";
            if (!_context.t1) {
              _context.next = 52;
              break;
            }
            S.placement && (f = S.placement);
            _context.t2 = S.rects;
            if (!_context.t2) {
              _context.next = 51;
              break;
            }
            if (!(S.rects === !0)) {
              _context.next = 49;
              break;
            }
            _context.next = 46;
            return i.getElementRects({
              reference: n,
              floating: r,
              strategy: a
            });
          case 46:
            _context.t3 = _context.sent;
            _context.next = 50;
            break;
          case 49:
            _context.t3 = S.rects;
          case 50:
            l = _context.t3;
          case 51:
            _Mr2 = Mr(l, f, c), u = _Mr2.x, d = _Mr2.y;
          case 52:
            g = -1;
          case 53:
            g++;
            _context.next = 21;
            break;
          case 56:
            return _context.abrupt("return", {
              x: u,
              y: d,
              placement: f,
              strategy: a,
              middlewareData: p
            });
          case 57:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function ll(_x, _x2, _x3) {
    return _ref54.apply(this, arguments);
  };
}();
function Ya(_x4, _x5) {
  return _Ya.apply(this, arguments);
}
function _Ya() {
  _Ya = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(n, r) {
    var t, e, a, o, i, s, c, _Yt3, _Yt3$boundary, l, _Yt3$rootBoundary, u, _Yt3$elementContext, d, _Yt3$altBoundary, f, _Yt3$padding, p, h, v, w, D, b, P, S;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            r === void 0 && (r = {});
            e = n.x;
            a = n.y;
            o = n.platform;
            i = n.rects;
            s = n.elements;
            c = n.strategy;
            _Yt3 = Yt(r, n);
            _Yt3$boundary = _Yt3.boundary;
            l = _Yt3$boundary === void 0 ? "clippingAncestors" : _Yt3$boundary;
            _Yt3$rootBoundary = _Yt3.rootBoundary;
            u = _Yt3$rootBoundary === void 0 ? "viewport" : _Yt3$rootBoundary;
            _Yt3$elementContext = _Yt3.elementContext;
            d = _Yt3$elementContext === void 0 ? "floating" : _Yt3$elementContext;
            _Yt3$altBoundary = _Yt3.altBoundary;
            f = _Yt3$altBoundary === void 0 ? !1 : _Yt3$altBoundary;
            _Yt3$padding = _Yt3.padding;
            p = _Yt3$padding === void 0 ? 0 : _Yt3$padding;
            h = Na(p);
            v = s[f ? d === "floating" ? "reference" : "floating" : d];
            _context7.t0 = fn;
            _context7.t1 = o;
            _context7.next = 24;
            return o.isElement == null ? void 0 : o.isElement(v);
          case 24:
            _context7.t3 = t = _context7.sent;
            _context7.t2 = _context7.t3 == null;
            if (_context7.t2) {
              _context7.next = 28;
              break;
            }
            _context7.t2 = t;
          case 28:
            if (!_context7.t2) {
              _context7.next = 32;
              break;
            }
            _context7.t4 = v;
            _context7.next = 38;
            break;
          case 32:
            _context7.t5 = v.contextElement;
            if (_context7.t5) {
              _context7.next = 37;
              break;
            }
            _context7.next = 36;
            return o.getDocumentElement == null ? void 0 : o.getDocumentElement(s.floating);
          case 36:
            _context7.t5 = _context7.sent;
          case 37:
            _context7.t4 = _context7.t5;
          case 38:
            _context7.t6 = _context7.t4;
            _context7.t7 = l;
            _context7.t8 = u;
            _context7.t9 = c;
            _context7.t10 = {
              element: _context7.t6,
              boundary: _context7.t7,
              rootBoundary: _context7.t8,
              strategy: _context7.t9
            };
            _context7.next = 45;
            return _context7.t1.getClippingRect.call(_context7.t1, _context7.t10);
          case 45:
            _context7.t11 = _context7.sent;
            w = (0, _context7.t0)(_context7.t11);
            D = d === "floating" ? _objectSpread(_objectSpread({}, i.floating), {}, {
              x: e,
              y: a
            }) : i.reference;
            _context7.next = 50;
            return o.getOffsetParent == null ? void 0 : o.getOffsetParent(s.floating);
          case 50:
            b = _context7.sent;
            _context7.next = 53;
            return o.isElement == null ? void 0 : o.isElement(b);
          case 53:
            if (!_context7.sent) {
              _context7.next = 62;
              break;
            }
            _context7.next = 56;
            return o.getScale == null ? void 0 : o.getScale(b);
          case 56:
            _context7.t13 = _context7.sent;
            if (_context7.t13) {
              _context7.next = 59;
              break;
            }
            _context7.t13 = {
              x: 1,
              y: 1
            };
          case 59:
            _context7.t12 = _context7.t13;
            _context7.next = 63;
            break;
          case 62:
            _context7.t12 = {
              x: 1,
              y: 1
            };
          case 63:
            P = _context7.t12;
            _context7.t14 = fn;
            if (!o.convertOffsetParentRelativeRectToViewportRelativeRect) {
              _context7.next = 71;
              break;
            }
            _context7.next = 68;
            return o.convertOffsetParentRelativeRectToViewportRelativeRect({
              elements: s,
              rect: D,
              offsetParent: b,
              strategy: c
            });
          case 68:
            _context7.t15 = _context7.sent;
            _context7.next = 72;
            break;
          case 71:
            _context7.t15 = D;
          case 72:
            _context7.t16 = _context7.t15;
            S = (0, _context7.t14)(_context7.t16);
            return _context7.abrupt("return", {
              top: (w.top - S.top + h.top) / P.y,
              bottom: (S.bottom - w.bottom + h.bottom) / P.y,
              left: (w.left - S.left + h.left) / P.x,
              right: (S.right - w.right + h.right) / P.x
            });
          case 75:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _Ya.apply(this, arguments);
}
var ul = function ul(n) {
    return {
      name: "arrow",
      options: n,
      fn(r) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          var t, e, a, o, i, s, c, _ref55, l, _ref55$padding, u, d, f, p, h, g, v, w, D, b, P, S, T, y, x, E, B, L, N, W, H, A, O, R;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  t = r.x, e = r.y, a = r.placement, o = r.rects, i = r.platform, s = r.elements, c = r.middlewareData, _ref55 = Yt(n, r) || {}, l = _ref55.element, _ref55$padding = _ref55.padding, u = _ref55$padding === void 0 ? 0 : _ref55$padding;
                  if (!(l == null)) {
                    _context2.next = 3;
                    break;
                  }
                  return _context2.abrupt("return", {});
                case 3:
                  d = Na(u);
                  f = {
                    x: t,
                    y: e
                  };
                  p = Jn(a);
                  h = Zn(p);
                  _context2.next = 9;
                  return i.getDimensions(l);
                case 9:
                  g = _context2.sent;
                  v = p === "y";
                  w = v ? "top" : "left";
                  D = v ? "bottom" : "right";
                  b = v ? "clientHeight" : "clientWidth";
                  P = o.reference[h] + o.reference[p] - f[p] - o.floating[h];
                  S = f[p] - o.reference[p];
                  _context2.next = 18;
                  return i.getOffsetParent == null ? void 0 : i.getOffsetParent(l);
                case 18:
                  T = _context2.sent;
                  y = T ? T[b] : 0;
                  _context2.t0 = !y;
                  if (_context2.t0) {
                    _context2.next = 25;
                    break;
                  }
                  _context2.next = 24;
                  return i.isElement == null ? void 0 : i.isElement(T);
                case 24:
                  _context2.t0 = !_context2.sent;
                case 25:
                  _context2.t1 = _context2.t0;
                  if (!_context2.t1) {
                    _context2.next = 28;
                    break;
                  }
                  y = s.floating[b] || o.floating[h];
                case 28:
                  x = P / 2 - S / 2, E = y / 2 - g[h] / 2 - 1, B = gt(d[w], E), L = gt(d[D], E), N = B, W = y - g[h] - L, H = y / 2 - g[h] / 2 + x, A = Qn(N, H, W), O = !c.arrow && Rt(a) != null && H !== A && o.reference[h] / 2 - (H < N ? B : L) - g[h] / 2 < 0, R = O ? H < N ? H - N : H - W : 0;
                  return _context2.abrupt("return", {
                    [p]: f[p] + R,
                    data: _objectSpread({
                      [p]: A,
                      centerOffset: H - A - R
                    }, O && {
                      alignmentOffset: R
                    }),
                    reset: O
                  });
                case 30:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))();
      }
    };
  },
  dl = function dl(n) {
    return n === void 0 && (n = {}), {
      name: "flip",
      options: n,
      fn(r) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
          var t, e, a, o, i, s, c, l, _Yt, _Yt$mainAxis, u, _Yt$crossAxis, d, f, _Yt$fallbackStrategy, p, _Yt$fallbackAxisSideD, h, _Yt$flipAlignment, g, v, w, D, b, P, S, T, y, x, N, E, B, _N, W, H, L, A;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  a = r.placement, o = r.middlewareData, i = r.rects, s = r.initialPlacement, c = r.platform, l = r.elements, _Yt = Yt(n, r), _Yt$mainAxis = _Yt.mainAxis, u = _Yt$mainAxis === void 0 ? !0 : _Yt$mainAxis, _Yt$crossAxis = _Yt.crossAxis, d = _Yt$crossAxis === void 0 ? !0 : _Yt$crossAxis, f = _Yt.fallbackPlacements, _Yt$fallbackStrategy = _Yt.fallbackStrategy, p = _Yt$fallbackStrategy === void 0 ? "bestFit" : _Yt$fallbackStrategy, _Yt$fallbackAxisSideD = _Yt.fallbackAxisSideDirection, h = _Yt$fallbackAxisSideD === void 0 ? "none" : _Yt$fallbackAxisSideD, _Yt$flipAlignment = _Yt.flipAlignment, g = _Yt$flipAlignment === void 0 ? !0 : _Yt$flipAlignment, v = _objectWithoutProperties(_Yt, _excluded);
                  if (!((t = o.arrow) != null && t.alignmentOffset)) {
                    _context3.next = 3;
                    break;
                  }
                  return _context3.abrupt("return", {});
                case 3:
                  w = rt(a);
                  D = rt(s) === s;
                  _context3.next = 7;
                  return c.isRTL == null ? void 0 : c.isRTL(l.floating);
                case 7:
                  b = _context3.sent;
                  P = f || (D || !g ? [dn(s)] : ol(s));
                  !f && h !== "none" && P.push.apply(P, _toConsumableArray(sl(s, g, h, b)));
                  S = [s].concat(_toConsumableArray(P));
                  _context3.next = 13;
                  return Ya(r, v);
                case 13:
                  T = _context3.sent;
                  y = [];
                  x = ((e = o.flip) == null ? void 0 : e.overflows) || [];
                  if (u && y.push(T[w]), d) {
                    N = al(a, i, b);
                    y.push(T[N[0]], T[N[1]]);
                  }
                  if (!(x = [].concat(_toConsumableArray(x), [{
                    placement: a,
                    overflows: y
                  }]), !y.every(function (N) {
                    return N <= 0;
                  }))) {
                    _context3.next = 33;
                    break;
                  }
                  _N = (((E = o.flip) == null ? void 0 : E.index) || 0) + 1, W = S[_N];
                  if (!W) {
                    _context3.next = 21;
                    break;
                  }
                  return _context3.abrupt("return", {
                    data: {
                      index: _N,
                      overflows: x
                    },
                    reset: {
                      placement: W
                    }
                  });
                case 21:
                  H = (B = x.filter(function (A) {
                    return A.overflows[0] <= 0;
                  }).sort(function (A, O) {
                    return A.overflows[1] - O.overflows[1];
                  })[0]) == null ? void 0 : B.placement;
                  if (H) {
                    _context3.next = 31;
                    break;
                  }
                  _context3.t0 = p;
                  _context3.next = _context3.t0 === "bestFit" ? 26 : _context3.t0 === "initialPlacement" ? 29 : 31;
                  break;
                case 26:
                  A = (L = x.map(function (O) {
                    return [O.placement, O.overflows.filter(function (R) {
                      return R > 0;
                    }).reduce(function (R, $) {
                      return R + $;
                    }, 0)];
                  }).sort(function (O, R) {
                    return O[1] - R[1];
                  })[0]) == null ? void 0 : L[0];
                  A && (H = A);
                  return _context3.abrupt("break", 31);
                case 29:
                  H = s;
                  return _context3.abrupt("break", 31);
                case 31:
                  if (!(a !== H)) {
                    _context3.next = 33;
                    break;
                  }
                  return _context3.abrupt("return", {
                    reset: {
                      placement: H
                    }
                  });
                case 33:
                  return _context3.abrupt("return", {});
                case 34:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))();
      }
    };
  };
function fl(_x6, _x7) {
  return _fl.apply(this, arguments);
}
function _fl() {
  _fl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(n, r) {
    var t, e, a, o, i, s, c, l, u, d, _ref167, f, p, h;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            t = n.placement;
            e = n.platform;
            a = n.elements;
            _context8.next = 5;
            return e.isRTL == null ? void 0 : e.isRTL(a.floating);
          case 5:
            o = _context8.sent;
            i = rt(t);
            s = Rt(t);
            c = Dn(t) === "y";
            l = ["left", "top"].includes(i) ? -1 : 1;
            u = o && c ? -1 : 1;
            d = Yt(r, n);
            _ref167 = typeof d == "number" ? {
              mainAxis: d,
              crossAxis: 0,
              alignmentAxis: null
            } : _objectSpread({
              mainAxis: 0,
              crossAxis: 0,
              alignmentAxis: null
            }, d), f = _ref167.mainAxis, p = _ref167.crossAxis, h = _ref167.alignmentAxis;
            return _context8.abrupt("return", (s && typeof h == "number" && (p = s === "end" ? h * -1 : h), c ? {
              x: p * u,
              y: f * l
            } : {
              x: f * l,
              y: p * u
            }));
          case 14:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _fl.apply(this, arguments);
}
var pl = function pl(n) {
    return n === void 0 && (n = 0), {
      name: "offset",
      options: n,
      fn(r) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
          var t, e, a, o, i, s, c;
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  a = r.x;
                  o = r.y;
                  i = r.placement;
                  s = r.middlewareData;
                  _context4.next = 6;
                  return fl(r, n);
                case 6:
                  c = _context4.sent;
                  return _context4.abrupt("return", i === ((t = s.offset) == null ? void 0 : t.placement) && (e = s.arrow) != null && e.alignmentOffset ? {} : {
                    x: a + c.x,
                    y: o + c.y,
                    data: _objectSpread(_objectSpread({}, c), {}, {
                      placement: i
                    })
                  });
                case 8:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }))();
      }
    };
  },
  hl = function hl(n) {
    return n === void 0 && (n = {}), {
      name: "shift",
      options: n,
      fn(r) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
          var t, e, a, _Yt2, _Yt2$mainAxis, o, _Yt2$crossAxis, i, _Yt2$limiter, s, c, l, u, d, f, p, h, v, w, D, b, _v, _w, _D, _b, g;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  t = r.x;
                  e = r.y;
                  a = r.placement;
                  _Yt2 = Yt(n, r);
                  _Yt2$mainAxis = _Yt2.mainAxis;
                  o = _Yt2$mainAxis === void 0 ? !0 : _Yt2$mainAxis;
                  _Yt2$crossAxis = _Yt2.crossAxis;
                  i = _Yt2$crossAxis === void 0 ? !1 : _Yt2$crossAxis;
                  _Yt2$limiter = _Yt2.limiter;
                  s = _Yt2$limiter === void 0 ? {
                    fn: function fn(v) {
                      var w = v.x,
                        D = v.y;
                      return {
                        x: w,
                        y: D
                      };
                    }
                  } : _Yt2$limiter;
                  c = _objectWithoutProperties(_Yt2, _excluded2);
                  l = {
                    x: t,
                    y: e
                  };
                  _context5.next = 14;
                  return Ya(r, c);
                case 14:
                  u = _context5.sent;
                  d = Dn(rt(a));
                  f = Ta(d);
                  p = l[f], h = l[d];
                  if (o) {
                    v = f === "y" ? "top" : "left", w = f === "y" ? "bottom" : "right", D = p + u[v], b = p - u[w];
                    p = Qn(D, p, b);
                  }
                  if (i) {
                    _v = d === "y" ? "top" : "left", _w = d === "y" ? "bottom" : "right", _D = h + u[_v], _b = h - u[_w];
                    h = Qn(_D, h, _b);
                  }
                  g = s.fn(_objectSpread(_objectSpread({}, r), {}, {
                    [f]: p,
                    [d]: h
                  }));
                  return _context5.abrupt("return", _objectSpread(_objectSpread({}, g), {}, {
                    data: {
                      x: g.x - t,
                      y: g.y - e
                    }
                  }));
                case 22:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }))();
      }
    };
  };
function wt(n) {
  return Ra(n) ? (n.nodeName || "").toLowerCase() : "#document";
}
function fe(n) {
  var r;
  return (n == null || (r = n.ownerDocument) == null ? void 0 : r.defaultView) || window;
}
function Fe(n) {
  var r;
  return (r = (Ra(n) ? n.ownerDocument : n.document) || window.document) == null ? void 0 : r.documentElement;
}
function Ra(n) {
  return n instanceof Node || n instanceof fe(n).Node;
}
function Pe(n) {
  return n instanceof Element || n instanceof fe(n).Element;
}
function Ee(n) {
  return n instanceof HTMLElement || n instanceof fe(n).HTMLElement;
}
function Cr(n) {
  return typeof ShadowRoot > "u" ? !1 : n instanceof ShadowRoot || n instanceof fe(n).ShadowRoot;
}
function Lt(n) {
  var _ye = ye(n),
    r = _ye.overflow,
    t = _ye.overflowX,
    e = _ye.overflowY,
    a = _ye.display;
  return /auto|scroll|overlay|hidden|clip/.test(r + e + t) && !["inline", "contents"].includes(a);
}
function ml(n) {
  return ["table", "td", "th"].includes(wt(n));
}
function er(n) {
  var r = tr(),
    t = ye(n);
  return t.transform !== "none" || t.perspective !== "none" || (t.containerType ? t.containerType !== "normal" : !1) || !r && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !r && (t.filter ? t.filter !== "none" : !1) || ["transform", "perspective", "filter"].some(function (e) {
    return (t.willChange || "").includes(e);
  }) || ["paint", "layout", "strict", "content"].some(function (e) {
    return (t.contain || "").includes(e);
  });
}
function gl(n) {
  var r = Ke(n);
  for (; Ee(r) && !vt(r);) {
    if (er(r)) return r;
    r = Ke(r);
  }
  return null;
}
function tr() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function vt(n) {
  return ["html", "body", "#document"].includes(wt(n));
}
function ye(n) {
  return fe(n).getComputedStyle(n);
}
function kn(n) {
  return Pe(n) ? {
    scrollLeft: n.scrollLeft,
    scrollTop: n.scrollTop
  } : {
    scrollLeft: n.pageXOffset,
    scrollTop: n.pageYOffset
  };
}
function Ke(n) {
  if (wt(n) === "html") return n;
  var r =
  // Step into the shadow DOM of the parent of a slotted node.
  n.assignedSlot ||
  // DOM Element detected.
  n.parentNode ||
  // ShadowRoot detected.
  Cr(n) && n.host ||
  // Fallback.
  Fe(n);
  return Cr(r) ? r.host : r;
}
function La(n) {
  var r = Ke(n);
  return vt(r) ? n.ownerDocument ? n.ownerDocument.body : n.body : Ee(r) && Lt(r) ? r : La(r);
}
function Tt(n, r, t) {
  var e;
  r === void 0 && (r = []), t === void 0 && (t = !0);
  var a = La(n),
    o = a === ((e = n.ownerDocument) == null ? void 0 : e.body),
    i = fe(a);
  return o ? r.concat(i, i.visualViewport || [], Lt(a) ? a : [], i.frameElement && t ? Tt(i.frameElement) : []) : r.concat(a, Tt(a, [], t));
}
function Fa(n) {
  var r = ye(n);
  var t = parseFloat(r.width) || 0,
    e = parseFloat(r.height) || 0;
  var a = Ee(n),
    o = a ? n.offsetWidth : t,
    i = a ? n.offsetHeight : e,
    s = un(t) !== o || un(e) !== i;
  return s && (t = o, e = i), {
    width: t,
    height: e,
    $: s
  };
}
function nr(n) {
  return Pe(n) ? n : n.contextElement;
}
function ut(n) {
  var r = nr(n);
  if (!Ee(r)) return qe(1);
  var t = r.getBoundingClientRect(),
    _Fa = Fa(r),
    e = _Fa.width,
    a = _Fa.height,
    o = _Fa.$;
  var i = (o ? un(t.width) : t.width) / e,
    s = (o ? un(t.height) : t.height) / a;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
var vl = /* @__PURE__ */qe(0);
function Ia(n) {
  var r = fe(n);
  return !tr() || !r.visualViewport ? vl : {
    x: r.visualViewport.offsetLeft,
    y: r.visualViewport.offsetTop
  };
}
function wl(n, r, t) {
  return r === void 0 && (r = !1), !t || r && t !== fe(n) ? !1 : r;
}
function at(n, r, t, e) {
  r === void 0 && (r = !1), t === void 0 && (t = !1);
  var a = n.getBoundingClientRect(),
    o = nr(n);
  var i = qe(1);
  r && (e ? Pe(e) && (i = ut(e)) : i = ut(n));
  var s = wl(o, t, e) ? Ia(o) : qe(0);
  var c = (a.left + s.x) / i.x,
    l = (a.top + s.y) / i.y,
    u = a.width / i.x,
    d = a.height / i.y;
  if (o) {
    var f = fe(o),
      p = e && Pe(e) ? fe(e) : e;
    var h = f,
      g = h.frameElement;
    for (; g && e && p !== h;) {
      var v = ut(g),
        w = g.getBoundingClientRect(),
        D = ye(g),
        b = w.left + (g.clientLeft + parseFloat(D.paddingLeft)) * v.x,
        P = w.top + (g.clientTop + parseFloat(D.paddingTop)) * v.y;
      c *= v.x, l *= v.y, u *= v.x, d *= v.y, c += b, l += P, h = fe(g), g = h.frameElement;
    }
  }
  return fn({
    width: u,
    height: d,
    x: c,
    y: l
  });
}
var bl = [":popover-open", ":modal"];
function rr(n) {
  return bl.some(function (r) {
    try {
      return n.matches(r);
    } catch (_unused) {
      return !1;
    }
  });
}
function yl(n) {
  var r = n.elements,
    t = n.rect,
    e = n.offsetParent,
    a = n.strategy;
  var o = a === "fixed",
    i = Fe(e),
    s = r ? rr(r.floating) : !1;
  if (e === i || s && o) return t;
  var c = {
      scrollLeft: 0,
      scrollTop: 0
    },
    l = qe(1);
  var u = qe(0),
    d = Ee(e);
  if ((d || !d && !o) && ((wt(e) !== "body" || Lt(i)) && (c = kn(e)), Ee(e))) {
    var f = at(e);
    l = ut(e), u.x = f.x + e.clientLeft, u.y = f.y + e.clientTop;
  }
  return {
    width: t.width * l.x,
    height: t.height * l.y,
    x: t.x * l.x - c.scrollLeft * l.x + u.x,
    y: t.y * l.y - c.scrollTop * l.y + u.y
  };
}
function Dl(n) {
  return Array.from(n.getClientRects());
}
function $a(n) {
  return at(Fe(n)).left + kn(n).scrollLeft;
}
function kl(n) {
  var r = Fe(n),
    t = kn(n),
    e = n.ownerDocument.body,
    a = Je(r.scrollWidth, r.clientWidth, e.scrollWidth, e.clientWidth),
    o = Je(r.scrollHeight, r.clientHeight, e.scrollHeight, e.clientHeight);
  var i = -t.scrollLeft + $a(n);
  var s = -t.scrollTop;
  return ye(e).direction === "rtl" && (i += Je(r.clientWidth, e.clientWidth) - a), {
    width: a,
    height: o,
    x: i,
    y: s
  };
}
function xl(n, r) {
  var t = fe(n),
    e = Fe(n),
    a = t.visualViewport;
  var o = e.clientWidth,
    i = e.clientHeight,
    s = 0,
    c = 0;
  if (a) {
    o = a.width, i = a.height;
    var l = tr();
    (!l || l && r === "fixed") && (s = a.offsetLeft, c = a.offsetTop);
  }
  return {
    width: o,
    height: i,
    x: s,
    y: c
  };
}
function _l(n, r) {
  var t = at(n, !0, r === "fixed"),
    e = t.top + n.clientTop,
    a = t.left + n.clientLeft,
    o = Ee(n) ? ut(n) : qe(1),
    i = n.clientWidth * o.x,
    s = n.clientHeight * o.y,
    c = a * o.x,
    l = e * o.y;
  return {
    width: i,
    height: s,
    x: c,
    y: l
  };
}
function Sr(n, r, t) {
  var e;
  if (r === "viewport") e = xl(n, t);else if (r === "document") e = kl(Fe(n));else if (Pe(r)) e = _l(r, t);else {
    var a = Ia(n);
    e = _objectSpread(_objectSpread({}, r), {}, {
      x: r.x - a.x,
      y: r.y - a.y
    });
  }
  return fn(e);
}
function Wa(n, r) {
  var t = Ke(n);
  return t === r || !Pe(t) || vt(t) ? !1 : ye(t).position === "fixed" || Wa(t, r);
}
function Ml(n, r) {
  var t = r.get(n);
  if (t) return t;
  var e = Tt(n, [], !1).filter(function (s) {
      return Pe(s) && wt(s) !== "body";
    }),
    a = null;
  var o = ye(n).position === "fixed";
  var i = o ? Ke(n) : n;
  for (; Pe(i) && !vt(i);) {
    var s = ye(i),
      c = er(i);
    !c && s.position === "fixed" && (a = null), (o ? !c && !a : !c && s.position === "static" && !!a && ["absolute", "fixed"].includes(a.position) || Lt(i) && !c && Wa(n, i)) ? e = e.filter(function (u) {
      return u !== i;
    }) : a = s, i = Ke(i);
  }
  return r.set(n, e), e;
}
function Cl(n) {
  var r = n.element,
    t = n.boundary,
    e = n.rootBoundary,
    a = n.strategy;
  var i = [].concat(_toConsumableArray(t === "clippingAncestors" ? rr(r) ? [] : Ml(r, this._c) : [].concat(t)), [e]),
    s = i[0],
    c = i.reduce(function (l, u) {
      var d = Sr(r, u, a);
      return l.top = Je(d.top, l.top), l.right = gt(d.right, l.right), l.bottom = gt(d.bottom, l.bottom), l.left = Je(d.left, l.left), l;
    }, Sr(r, s, a));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function Sl(n) {
  var _Fa2 = Fa(n),
    r = _Fa2.width,
    t = _Fa2.height;
  return {
    width: r,
    height: t
  };
}
function Pl(n, r, t) {
  var e = Ee(r),
    a = Fe(r),
    o = t === "fixed",
    i = at(n, !0, o, r);
  var s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var c = qe(0);
  if (e || !e && !o) if ((wt(r) !== "body" || Lt(a)) && (s = kn(r)), e) {
    var d = at(r, !0, o, r);
    c.x = d.x + r.clientLeft, c.y = d.y + r.clientTop;
  } else a && (c.x = $a(a));
  var l = i.left + s.scrollLeft - c.x,
    u = i.top + s.scrollTop - c.y;
  return {
    x: l,
    y: u,
    width: i.width,
    height: i.height
  };
}
function En(n) {
  return ye(n).position === "static";
}
function Pr(n, r) {
  return !Ee(n) || ye(n).position === "fixed" ? null : r ? r(n) : n.offsetParent;
}
function Aa(n, r) {
  var t = fe(n);
  if (rr(n)) return t;
  if (!Ee(n)) {
    var a = Ke(n);
    for (; a && !vt(a);) {
      if (Pe(a) && !En(a)) return a;
      a = Ke(a);
    }
    return t;
  }
  var e = Pr(n, r);
  for (; e && ml(e) && En(e);) {
    e = Pr(e, r);
  }
  return e && vt(e) && En(e) && !er(e) ? t : e || gl(n) || t;
}
var El = /*#__PURE__*/function () {
  var _ref56 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(n) {
    var r, t, e;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            r = this.getOffsetParent || Aa;
            t = this.getDimensions;
            _context6.next = 4;
            return t(n.floating);
          case 4:
            e = _context6.sent;
            _context6.t0 = Pl;
            _context6.t1 = n.reference;
            _context6.next = 9;
            return r(n.floating);
          case 9:
            _context6.t2 = _context6.sent;
            _context6.t3 = n.strategy;
            _context6.t4 = (0, _context6.t0)(_context6.t1, _context6.t2, _context6.t3);
            _context6.t5 = {
              x: 0,
              y: 0,
              width: e.width,
              height: e.height
            };
            return _context6.abrupt("return", {
              reference: _context6.t4,
              floating: _context6.t5
            });
          case 14:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));
  return function El(_x8) {
    return _ref56.apply(this, arguments);
  };
}();
function Ol(n) {
  return ye(n).direction === "rtl";
}
var Tl = {
  convertOffsetParentRelativeRectToViewportRelativeRect: yl,
  getDocumentElement: Fe,
  getClippingRect: Cl,
  getOffsetParent: Aa,
  getElementRects: El,
  getClientRects: Dl,
  getDimensions: Sl,
  getScale: ut,
  isElement: Pe,
  isRTL: Ol
};
function Nl(n, r) {
  var t = null,
    e;
  var a = Fe(n);
  function o() {
    var s;
    clearTimeout(e), (s = t) == null || s.disconnect(), t = null;
  }
  function i(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), o();
    var _n$getBoundingClientR = n.getBoundingClientRect(),
      l = _n$getBoundingClientR.left,
      u = _n$getBoundingClientR.top,
      d = _n$getBoundingClientR.width,
      f = _n$getBoundingClientR.height;
    if (s || r(), !d || !f) return;
    var p = Wt(u),
      h = Wt(a.clientWidth - (l + d)),
      g = Wt(a.clientHeight - (u + f)),
      v = Wt(l),
      D = {
        rootMargin: -p + "px " + -h + "px " + -g + "px " + -v + "px",
        threshold: Je(0, gt(1, c)) || 1
      };
    var b = !0;
    function P(S) {
      var T = S[0].intersectionRatio;
      if (T !== c) {
        if (!b) return i();
        T ? i(!1, T) : e = setTimeout(function () {
          i(!1, 1e-7);
        }, 1e3);
      }
      b = !1;
    }
    try {
      t = new IntersectionObserver(P, _objectSpread(_objectSpread({}, D), {}, {
        // Handle <iframe>s
        root: a.ownerDocument
      }));
    } catch (_unused2) {
      t = new IntersectionObserver(P, D);
    }
    t.observe(n);
  }
  return i(!0), o;
}
function Yl(n, r, t, e) {
  e === void 0 && (e = {});
  var _e4 = e,
    _e4$ancestorScroll = _e4.ancestorScroll,
    a = _e4$ancestorScroll === void 0 ? !0 : _e4$ancestorScroll,
    _e4$ancestorResize = _e4.ancestorResize,
    o = _e4$ancestorResize === void 0 ? !0 : _e4$ancestorResize,
    _e4$elementResize = _e4.elementResize,
    i = _e4$elementResize === void 0 ? typeof ResizeObserver == "function" : _e4$elementResize,
    _e4$layoutShift = _e4.layoutShift,
    s = _e4$layoutShift === void 0 ? typeof IntersectionObserver == "function" : _e4$layoutShift,
    _e4$animationFrame = _e4.animationFrame,
    c = _e4$animationFrame === void 0 ? !1 : _e4$animationFrame,
    l = nr(n),
    u = a || o ? [].concat(_toConsumableArray(l ? Tt(l) : []), _toConsumableArray(Tt(r))) : [];
  u.forEach(function (w) {
    a && w.addEventListener("scroll", t, {
      passive: !0
    }), o && w.addEventListener("resize", t);
  });
  var d = l && s ? Nl(l, t) : null;
  var f = -1,
    p = null;
  i && (p = new ResizeObserver(function (w) {
    var _w2 = _slicedToArray(w, 1),
      D = _w2[0];
    D && D.target === l && p && (p.unobserve(r), cancelAnimationFrame(f), f = requestAnimationFrame(function () {
      var b;
      (b = p) == null || b.observe(r);
    })), t();
  }), l && !c && p.observe(l), p.observe(r));
  var h,
    g = c ? at(n) : null;
  c && v();
  function v() {
    var w = at(n);
    g && (w.x !== g.x || w.y !== g.y || w.width !== g.width || w.height !== g.height) && t(), g = w, h = requestAnimationFrame(v);
  }
  return t(), function () {
    var w;
    u.forEach(function (D) {
      a && D.removeEventListener("scroll", t), o && D.removeEventListener("resize", t);
    }), d == null || d(), (w = p) == null || w.disconnect(), p = null, c && cancelAnimationFrame(h);
  };
}
var Ha = pl,
  Rl = hl,
  Ba = dl,
  Er = ul,
  Ll = function Ll(n, r, t) {
    var e = /* @__PURE__ */new Map(),
      a = _objectSpread({
        platform: Tl
      }, t),
      o = _objectSpread(_objectSpread({}, a.platform), {}, {
        _c: e
      });
    return ll(n, r, _objectSpread(_objectSpread({}, a), {}, {
      platform: o
    }));
  };
var Ut = typeof document < "u" ? na : Ue;
function pn(n, r) {
  if (n === r) return !0;
  if (typeof n != typeof r) return !1;
  if (typeof n == "function" && n.toString() === r.toString()) return !0;
  var t, e, a;
  if (n && r && typeof n == "object") {
    if (Array.isArray(n)) {
      if (t = n.length, t !== r.length) return !1;
      for (e = t; e-- !== 0;) {
        if (!pn(n[e], r[e])) return !1;
      }
      return !0;
    }
    if (a = Object.keys(n), t = a.length, t !== Object.keys(r).length) return !1;
    for (e = t; e-- !== 0;) {
      if (!{}.hasOwnProperty.call(r, a[e])) return !1;
    }
    for (e = t; e-- !== 0;) {
      var o = a[e];
      if (!(o === "_owner" && n.$$typeof) && !pn(n[o], r[o])) return !1;
    }
    return !0;
  }
  return n !== n && r !== r;
}
function Qa(n) {
  return typeof window > "u" ? 1 : (n.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Or(n, r) {
  var t = Qa(n);
  return Math.round(r * t) / t;
}
function On(n) {
  var r = Y.useRef(n);
  return Ut(function () {
    r.current = n;
  }), r;
}
function Fl(n) {
  n === void 0 && (n = {});
  var _n2 = n,
    _n2$placement = _n2.placement,
    r = _n2$placement === void 0 ? "bottom" : _n2$placement,
    _n2$strategy = _n2.strategy,
    t = _n2$strategy === void 0 ? "absolute" : _n2$strategy,
    _n2$middleware = _n2.middleware,
    e = _n2$middleware === void 0 ? [] : _n2$middleware,
    a = _n2.platform,
    _n2$elements = _n2.elements;
  _n2$elements = _n2$elements === void 0 ? {} : _n2$elements;
  var o = _n2$elements.reference,
    i = _n2$elements.floating,
    _n2$transform = _n2.transform,
    s = _n2$transform === void 0 ? !0 : _n2$transform,
    c = _n2.whileElementsMounted,
    l = _n2.open,
    _Y$useState = Y.useState({
      x: 0,
      y: 0,
      strategy: t,
      placement: r,
      middlewareData: {},
      isPositioned: !1
    }),
    _Y$useState2 = _slicedToArray(_Y$useState, 2),
    u = _Y$useState2[0],
    d = _Y$useState2[1],
    _Y$useState3 = Y.useState(e),
    _Y$useState4 = _slicedToArray(_Y$useState3, 2),
    f = _Y$useState4[0],
    p = _Y$useState4[1];
  pn(f, e) || p(e);
  var _Y$useState5 = Y.useState(null),
    _Y$useState6 = _slicedToArray(_Y$useState5, 2),
    h = _Y$useState6[0],
    g = _Y$useState6[1],
    _Y$useState7 = Y.useState(null),
    _Y$useState8 = _slicedToArray(_Y$useState7, 2),
    v = _Y$useState8[0],
    w = _Y$useState8[1],
    D = Y.useCallback(function ($) {
      $ !== T.current && (T.current = $, g($));
    }, []),
    b = Y.useCallback(function ($) {
      $ !== y.current && (y.current = $, w($));
    }, []),
    P = o || h,
    S = i || v,
    T = Y.useRef(null),
    y = Y.useRef(null),
    x = Y.useRef(u),
    E = c != null,
    B = On(c),
    L = On(a),
    N = On(l),
    W = Y.useCallback(function () {
      if (!T.current || !y.current) return;
      var $ = {
        placement: r,
        strategy: t,
        middleware: f
      };
      L.current && ($.platform = L.current), Ll(T.current, y.current, $).then(function (X) {
        var ve = _objectSpread(_objectSpread({}, X), {}, {
          // The floating element's position may be recomputed while it's closed
          // but still mounted (such as when transitioning out). To ensure
          // `isPositioned` will be `false` initially on the next open, avoid
          // setting it to `true` when `open === false` (must be specified).
          isPositioned: N.current !== !1
        });
        H.current && !pn(x.current, ve) && (x.current = ve, Co.flushSync(function () {
          d(ve);
        }));
      });
    }, [f, r, t, L, N]);
  Ut(function () {
    l === !1 && x.current.isPositioned && (x.current.isPositioned = !1, d(function ($) {
      return _objectSpread(_objectSpread({}, $), {}, {
        isPositioned: !1
      });
    }));
  }, [l]);
  var H = Y.useRef(!1);
  Ut(function () {
    return H.current = !0, function () {
      H.current = !1;
    };
  }, []), Ut(function () {
    if (P && (T.current = P), S && (y.current = S), P && S) {
      if (B.current) return B.current(P, S, W);
      W();
    }
  }, [P, S, W, B, E]);
  var A = Y.useMemo(function () {
      return {
        reference: T,
        floating: y,
        setReference: D,
        setFloating: b
      };
    }, [D, b]),
    O = Y.useMemo(function () {
      return {
        reference: P,
        floating: S
      };
    }, [P, S]),
    R = Y.useMemo(function () {
      var $ = {
        position: t,
        left: 0,
        top: 0
      };
      if (!O.floating) return $;
      var X = Or(O.floating, u.x),
        ve = Or(O.floating, u.y);
      return s ? _objectSpread(_objectSpread({}, $), {}, {
        transform: "translate(" + X + "px, " + ve + "px)"
      }, Qa(O.floating) >= 1.5 && {
        willChange: "transform"
      }) : {
        position: t,
        left: X,
        top: ve
      };
    }, [t, s, O.floating, u.x, u.y]);
  return Y.useMemo(function () {
    return _objectSpread(_objectSpread({}, u), {}, {
      update: W,
      refs: A,
      elements: O,
      floatingStyles: R
    });
  }, [u, W, A, O, R]);
}
var Il = function Il(n) {
    function r(t) {
      return {}.hasOwnProperty.call(t, "current");
    }
    return {
      name: "arrow",
      options: n,
      fn(t) {
        var _ref57 = typeof n == "function" ? n(t) : n,
          e = _ref57.element,
          a = _ref57.padding;
        return e && r(e) ? e.current != null ? Er({
          element: e.current,
          padding: a
        }).fn(t) : {} : e ? Er({
          element: e,
          padding: a
        }).fn(t) : {};
      }
    };
  },
  $l = function $l(n, r) {
    return _objectSpread(_objectSpread({}, Ha(n)), {}, {
      options: [n, r]
    });
  },
  Wl = function Wl(n, r) {
    return _objectSpread(_objectSpread({}, Ba(n)), {}, {
      options: [n, r]
    });
  },
  Al = function Al(n, r) {
    return _objectSpread(_objectSpread({}, Il(n)), {}, {
      options: [n, r]
    });
  },
  Va = _objectSpread({}, Y),
  Hl = Va.useInsertionEffect,
  Bl = Hl || function (n) {
    return n();
  };
function Ql(n) {
  var r = Y.useRef(function () {
    if (process.env.NODE_ENV !== "production") throw new Error("Cannot call an event handler while rendering.");
  });
  return Bl(function () {
    r.current = n;
  }), Y.useCallback(function () {
    for (var t = arguments.length, e = new Array(t), a = 0; a < t; a++) {
      e[a] = arguments[a];
    }
    return r.current == null ? void 0 : r.current.apply(r, e);
  }, []);
}
var hn = typeof document < "u" ? na : Ue;
var Tr = !1,
  Vl = 0;
var Nr = function Nr() {
  return (
    // Ensure the id is unique with multiple independent versions of Floating UI
    // on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + Vl++
  );
};
function ql() {
  var _Y$useState9 = Y.useState(function () {
      return Tr ? Nr() : void 0;
    }),
    _Y$useState10 = _slicedToArray(_Y$useState9, 2),
    n = _Y$useState10[0],
    r = _Y$useState10[1];
  return hn(function () {
    n == null && r(Nr());
  }, []), Y.useEffect(function () {
    Tr = !0;
  }, []), n;
}
var Kl = Va.useId,
  qa = Kl || ql;
var Nt;
process.env.NODE_ENV !== "production" && (Nt = /* @__PURE__ */new Set());
function jl() {
  for (var n, r = arguments.length, t = new Array(r), e = 0; e < r; e++) {
    t[e] = arguments[e];
  }
  var a = "Floating UI: " + t.join(" ");
  if (!((n = Nt) != null && n.has(a))) {
    var o;
    (o = Nt) == null || o.add(a), console.warn(a);
  }
}
function zl() {
  for (var n, r = arguments.length, t = new Array(r), e = 0; e < r; e++) {
    t[e] = arguments[e];
  }
  var a = "Floating UI: " + t.join(" ");
  if (!((n = Nt) != null && n.has(a))) {
    var o;
    (o = Nt) == null || o.add(a), console.error(a);
  }
}
var Ul = /* @__PURE__ */Y.forwardRef(function (r, t) {
  var _r$context = r.context,
    e = _r$context.placement,
    a = _r$context.elements.floating,
    _r$context$middleware = _r$context.middlewareData,
    o = _r$context$middleware.arrow,
    i = _r$context$middleware.shift,
    _r$width = r.width,
    s = _r$width === void 0 ? 14 : _r$width,
    _r$height = r.height,
    c = _r$height === void 0 ? 7 : _r$height,
    _r$tipRadius = r.tipRadius,
    l = _r$tipRadius === void 0 ? 0 : _r$tipRadius,
    _r$strokeWidth = r.strokeWidth,
    u = _r$strokeWidth === void 0 ? 0 : _r$strokeWidth,
    d = r.staticOffset,
    f = r.stroke,
    p = r.d,
    _r$style = r.style;
  _r$style = _r$style === void 0 ? {} : _r$style;
  var h = _r$style.transform,
    g = _objectWithoutProperties(_r$style, _excluded3),
    v = _objectWithoutProperties(r, _excluded4);
  process.env.NODE_ENV !== "production" && (t || jl("The `ref` prop is required for `FloatingArrow`."));
  var w = qa(),
    _Y$useState11 = Y.useState(!1),
    _Y$useState12 = _slicedToArray(_Y$useState11, 2),
    D = _Y$useState12[0],
    b = _Y$useState12[1];
  if (hn(function () {
    if (!a) return;
    tl(a).direction === "rtl" && b(!0);
  }, [a]), !a) return null;
  var _e$split = e.split("-"),
    _e$split2 = _slicedToArray(_e$split, 2),
    P = _e$split2[0],
    S = _e$split2[1],
    T = P === "top" || P === "bottom";
  var y = d;
  (T && i != null && i.x || !T && i != null && i.y) && (y = null);
  var x = u * 2,
    E = x / 2,
    B = s / 2 * (l / -8 + 1),
    L = c / 2 * l / 4,
    N = !!p,
    W = y && S === "end" ? "bottom" : "top";
  var H = y && S === "end" ? "right" : "left";
  y && D && (H = S === "end" ? "left" : "right");
  var A = (o == null ? void 0 : o.x) != null ? y || o.x : "",
    O = (o == null ? void 0 : o.y) != null ? y || o.y : "",
    R = p || "M0,0" + (" H" + s) + (" L" + (s - B) + "," + (c - L)) + (" Q" + s / 2 + "," + c + " " + B + "," + (c - L)) + " Z",
    $ = {
      top: N ? "rotate(180deg)" : "",
      left: N ? "rotate(90deg)" : "rotate(-90deg)",
      bottom: N ? "" : "rotate(180deg)",
      right: N ? "rotate(-90deg)" : "rotate(90deg)"
    }[P];
  return /* @__PURE__ */pe("svg", _objectSpread(_objectSpread({}, v), {}, {
    "aria-hidden": !0,
    ref: t,
    width: N ? s : s + x,
    height: s,
    viewBox: "0 0 " + s + " " + (c > s ? c : s),
    style: _objectSpread({
      position: "absolute",
      pointerEvents: "none",
      [H]: A,
      [W]: O,
      [P]: T || N ? "100%" : "calc(100% - " + x / 2 + "px)",
      transform: [$, h].filter(function (X) {
        return !!X;
      }).join(" ")
    }, g),
    children: [x > 0 && /* @__PURE__ */_("path", {
      clipPath: "url(#" + w + ")",
      fill: "none",
      stroke: f,
      strokeWidth: x + (p ? 0 : 1),
      d: R
    }), /* @__PURE__ */_("path", {
      stroke: x && !p ? v.fill : "none",
      d: R
    }), /* @__PURE__ */_("clipPath", {
      id: w,
      children: /* @__PURE__ */_("rect", {
        x: -E,
        y: E * (N ? -1 : 1),
        width: s + x,
        height: s
      })
    })]
  }));
});
function Xl() {
  var n = /* @__PURE__ */new Map();
  return {
    emit(r, t) {
      var e;
      (e = n.get(r)) == null || e.forEach(function (a) {
        return a(t);
      });
    },
    on(r, t) {
      n.set(r, [].concat(_toConsumableArray(n.get(r) || []), [t]));
    },
    off(r, t) {
      var e;
      n.set(r, ((e = n.get(r)) == null ? void 0 : e.filter(function (a) {
        return a !== t;
      })) || []);
    }
  };
}
var Gl = /* @__PURE__ */Y.createContext(null),
  Zl = /* @__PURE__ */Y.createContext(null),
  Jl = function Jl() {
    var n;
    return ((n = Y.useContext(Gl)) == null ? void 0 : n.id) || null;
  },
  eu = function eu() {
    return Y.useContext(Zl);
  };
function tu(n) {
  var _n$open = n.open,
    r = _n$open === void 0 ? !1 : _n$open,
    t = n.onOpenChange,
    e = n.elements,
    a = qa(),
    o = Y.useRef({}),
    _Y$useState13 = Y.useState(function () {
      return Xl();
    }),
    _Y$useState14 = _slicedToArray(_Y$useState13, 1),
    i = _Y$useState14[0],
    s = Jl() != null;
  if (process.env.NODE_ENV !== "production") {
    var p = e.reference;
    p && !Ct(p) && zl("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  var _Y$useState15 = Y.useState(e.reference),
    _Y$useState16 = _slicedToArray(_Y$useState15, 2),
    c = _Y$useState16[0],
    l = _Y$useState16[1],
    u = Ql(function (p, h, g) {
      o.current.openEvent = p ? h : void 0, i.emit("openchange", {
        open: p,
        event: h,
        reason: g,
        nested: s
      }), t == null || t(p, h, g);
    }),
    d = Y.useMemo(function () {
      return {
        setPositionReference: l
      };
    }, []),
    f = Y.useMemo(function () {
      return {
        reference: c || e.reference || null,
        floating: e.floating || null,
        domReference: e.reference
      };
    }, [c, e.reference, e.floating]);
  return Y.useMemo(function () {
    return {
      dataRef: o,
      open: r,
      onOpenChange: u,
      elements: f,
      events: i,
      floatingId: a,
      refs: d
    };
  }, [r, u, f, i, a, d]);
}
function nu(n) {
  n === void 0 && (n = {});
  var _n3 = n,
    r = _n3.nodeId,
    t = tu(_objectSpread(_objectSpread({}, n), {}, {
      elements: _objectSpread({
        reference: null,
        floating: null
      }, n.elements)
    })),
    e = n.rootContext || t,
    a = e.elements,
    _Y$useState17 = Y.useState(null),
    _Y$useState18 = _slicedToArray(_Y$useState17, 2),
    o = _Y$useState18[0],
    i = _Y$useState18[1],
    _Y$useState19 = Y.useState(null),
    _Y$useState20 = _slicedToArray(_Y$useState19, 2),
    s = _Y$useState20[0],
    c = _Y$useState20[1],
    u = (a == null ? void 0 : a.domReference) || o,
    d = Y.useRef(null),
    f = eu();
  hn(function () {
    u && (d.current = u);
  }, [u]);
  var p = Fl(_objectSpread(_objectSpread({}, n), {}, {
      elements: _objectSpread(_objectSpread({}, a), s && {
        reference: s
      })
    })),
    h = Y.useCallback(function (b) {
      var P = Ct(b) ? {
        getBoundingClientRect: function getBoundingClientRect() {
          return b.getBoundingClientRect();
        },
        contextElement: b
      } : b;
      c(P), p.refs.setReference(P);
    }, [p.refs]),
    g = Y.useCallback(function (b) {
      (Ct(b) || b === null) && (d.current = b, i(b)), (Ct(p.refs.reference.current) || p.refs.reference.current === null ||
      // Don't allow setting virtual elements using the old technique back to
      // `null` to support `positionReference` + an unstable `reference`
      // callback ref.
      b !== null && !Ct(b)) && p.refs.setReference(b);
    }, [p.refs]),
    v = Y.useMemo(function () {
      return _objectSpread(_objectSpread({}, p.refs), {}, {
        setReference: g,
        setPositionReference: h,
        domReference: d
      });
    }, [p.refs, g, h]),
    w = Y.useMemo(function () {
      return _objectSpread(_objectSpread({}, p.elements), {}, {
        domReference: u
      });
    }, [p.elements, u]),
    D = Y.useMemo(function () {
      return _objectSpread(_objectSpread(_objectSpread({}, p), e), {}, {
        refs: v,
        elements: w,
        nodeId: r
      });
    }, [p, v, w, r, e]);
  return hn(function () {
    e.dataRef.current.floatingContext = D;
    var b = f == null ? void 0 : f.nodesRef.current.find(function (P) {
      return P.id === r;
    });
    b && (b.context = D);
  }), Y.useMemo(function () {
    return _objectSpread(_objectSpread({}, p), {}, {
      context: D,
      refs: v,
      elements: w
    });
  }, [p, v, w, D]);
}
/*!
  react-datepicker v7.6.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/
var _qn = function qn(r, t) {
  return _qn = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (e, a) {
    e.__proto__ = a;
  } || function (e, a) {
    for (var o in a) {
      Object.prototype.hasOwnProperty.call(a, o) && (e[o] = a[o]);
    }
  }, _qn(r, t);
};
function ie(n, r) {
  if (typeof r != "function" && r !== null) throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
  _qn(n, r);
  function t() {
    this.constructor = n;
  }
  n.prototype = r === null ? Object.create(r) : (t.prototype = r.prototype, new t());
}
var _V = function V() {
  return _V = Object.assign || function (t) {
    for (var e, a = 1, o = arguments.length; a < o; a++) {
      e = arguments[a];
      for (var i in e) {
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
      }
    }
    return t;
  }, _V.apply(this, arguments);
};
function Me(n, r, t) {
  if (t || arguments.length === 2) for (var e = 0, a = r.length, o; e < a; e++) {
    (o || !(e in r)) && (o || (o = Array.prototype.slice.call(r, 0, e)), o[e] = r[e]);
  }
  return n.concat(o || Array.prototype.slice.call(r));
}
var ru = function ru(n) {
    var r = n.showTimeSelectOnly,
      t = r === void 0 ? !1 : r,
      e = n.showTime,
      a = e === void 0 ? !1 : e,
      o = n.className,
      i = n.children,
      s = t ? "Choose Time" : "Choose Date".concat(a ? " and Time" : "");
    return /*#__PURE__*/m.createElement("div", {
      className: o,
      role: "dialog",
      "aria-label": s,
      "aria-modal": "true"
    }, i);
  },
  au = function au(n, r) {
    var t = Fn(null),
      e = Fn(n);
    e.current = n;
    var a = aa(function (o) {
      var i;
      t.current && !t.current.contains(o.target) && (r && o.target instanceof HTMLElement && o.target.classList.contains(r) || (i = e.current) === null || i === void 0 || i.call(e, o));
    }, [r]);
    return Ue(function () {
      return document.addEventListener("mousedown", a), function () {
        document.removeEventListener("mousedown", a);
      };
    }, [a]), t;
  },
  xn = function xn(n) {
    var r = n.children,
      t = n.onClickOutside,
      e = n.className,
      a = n.containerRef,
      o = n.style,
      i = n.ignoreClass,
      s = au(t, i);
    return /*#__PURE__*/m.createElement("div", {
      className: e,
      style: o,
      ref: function ref(c) {
        s.current = c, a && (a.current = c);
      }
    }, r);
  },
  k;
(function (n) {
  n.ArrowUp = "ArrowUp", n.ArrowDown = "ArrowDown", n.ArrowLeft = "ArrowLeft", n.ArrowRight = "ArrowRight", n.PageUp = "PageUp", n.PageDown = "PageDown", n.Home = "Home", n.End = "End", n.Enter = "Enter", n.Space = " ", n.Tab = "Tab", n.Escape = "Escape", n.Backspace = "Backspace", n.X = "x";
})(k || (k = {}));
function Ka() {
  var n = typeof window < "u" ? window : globalThis;
  return n;
}
var Ft = 12,
  ou = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function U(n) {
  if (n == null) return /* @__PURE__ */new Date();
  var r = typeof n == "string" ? Ic(n) : M(n);
  return Oe(r) ? r : /* @__PURE__ */new Date();
}
function Tn(n, r, t, e, a) {
  var o,
    i = null,
    s = et(t) || et(Et()),
    c = !0;
  if (Array.isArray(r)) return r.forEach(function (u) {
    var d = Sn(n, u, /* @__PURE__ */new Date(), {
      locale: s,
      useAdditionalWeekYearTokens: !0,
      useAdditionalDayOfYearTokens: !0
    });
    e && (c = Oe(d, a) && n === G(d, u, t)), Oe(d, a) && c && (i = d);
  }), i;
  if (i = Sn(n, r, /* @__PURE__ */new Date(), {
    locale: s,
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  }), e) c = Oe(i) && n === G(i, r, t);else if (!Oe(i)) {
    var l = ((o = r.match(ou)) !== null && o !== void 0 ? o : []).map(function (u) {
      var d = u[0];
      if (d === "p" || d === "P") {
        var f = cn[d];
        return s ? f(u, s.formatLong) : d;
      }
      return u;
    }).join("");
    n.length > 0 && (i = Sn(n, l.slice(0, n.length), /* @__PURE__ */new Date(), {
      useAdditionalWeekYearTokens: !0,
      useAdditionalDayOfYearTokens: !0
    })), Oe(i) || (i = new Date(n));
  }
  return Oe(i) && c ? i : null;
}
function Oe(n, r) {
  return rn(n) && !nt(n, r !== null && r !== void 0 ? r : /* @__PURE__ */new Date("1/1/1800"));
}
function G(n, r, t) {
  if (t === "en") return kr(n, r, {
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  });
  var e = t ? et(t) : void 0;
  return t && !e && console.warn('A locale object was not found for the provided string ["'.concat(t, '"].')), !e && Et() && et(Et()) && (e = et(Et())), kr(n, r, {
    locale: e,
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  });
}
function he(n, r) {
  var t = r.dateFormat,
    e = r.locale,
    a = Array.isArray(t) && t.length > 0 ? t[0] : t;
  return n && G(n, a, e) || "";
}
function iu(n, r, t) {
  if (!n) return "";
  var e = he(n, t),
    a = r ? he(r, t) : "";
  return "".concat(e, " - ").concat(a);
}
function su(n, r) {
  if (!(n != null && n.length)) return "";
  var t = n[0] ? he(n[0], r) : "";
  if (n.length === 1) return t;
  if (n.length === 2 && n[1]) {
    var e = he(n[1], r);
    return "".concat(t, ", ").concat(e);
  }
  var a = n.length - 1;
  return "".concat(t, " (+").concat(a, ")");
}
function Nn(n, r) {
  var t = r.hour,
    e = t === void 0 ? 0 : t,
    a = r.minute,
    o = a === void 0 ? 0 : a,
    i = r.second,
    s = i === void 0 ? 0 : i;
  return Kt(jt(zt(n, s), o), e);
}
function cu(n) {
  return zn(n);
}
function lu(n, r) {
  return G(n, "ddd", r);
}
function Xt(n) {
  return tt(n);
}
function He(n, r, t) {
  var e = et(r || Et());
  return Le(n, {
    locale: e,
    weekStartsOn: t
  });
}
function Re(n) {
  return va(n);
}
function St(n) {
  return yn(n);
}
function Yr(n) {
  return An(n);
}
function Rr() {
  return tt(U());
}
function Lr(n) {
  return ma(n);
}
function uu(n) {
  return Bi(n);
}
function du(n) {
  return ga(n);
}
function ke(n, r) {
  return n && r ? Lc(n, r) : !n && !r;
}
function le(n, r) {
  return n && r ? Yc(n, r) : !n && !r;
}
function mn(n, r) {
  return n && r ? Rc(n, r) : !n && !r;
}
function Q(n, r) {
  return n && r ? Ai(n, r) : !n && !r;
}
function Xe(n, r) {
  return n && r ? $s(n, r) : !n && !r;
}
function Pt(n, r, t) {
  var e,
    a = tt(r),
    o = ma(t);
  try {
    e = Ot(n, {
      start: a,
      end: o
    });
  } catch (_unused3) {
    e = !1;
  }
  return e;
}
function Et() {
  var n = Ka();
  return n.__localeId__;
}
function et(n) {
  if (typeof n == "string") {
    var r = Ka();
    return r.__localeData__ ? r.__localeData__[n] : void 0;
  } else return n;
}
function fu(n, r, t) {
  return r(G(n, "EEEE", t));
}
function pu(n, r) {
  return G(n, "EEEEEE", r);
}
function hu(n, r) {
  return G(n, "EEE", r);
}
function ar(n, r) {
  return G(de(U(), n), "LLLL", r);
}
function ja(n, r) {
  return G(de(U(), n), "LLL", r);
}
function mu(n, r) {
  return G(lt(U(), n), "QQQ", r);
}
function me(n, r) {
  var t = r === void 0 ? {} : r,
    e = t.minDate,
    a = t.maxDate,
    o = t.excludeDates,
    i = t.excludeDateIntervals,
    s = t.includeDates,
    c = t.includeDateIntervals,
    l = t.filterDate;
  return It(n, {
    minDate: e,
    maxDate: a
  }) || o && o.some(function (u) {
    return u instanceof Date ? Q(n, u) : Q(n, u.date);
  }) || i && i.some(function (u) {
    var d = u.start,
      f = u.end;
    return Ot(n, {
      start: d,
      end: f
    });
  }) || s && !s.some(function (u) {
    return Q(n, u);
  }) || c && !c.some(function (u) {
    var d = u.start,
      f = u.end;
    return Ot(n, {
      start: d,
      end: f
    });
  }) || l && !l(U(n)) || !1;
}
function or(n, r) {
  var t = r === void 0 ? {} : r,
    e = t.excludeDates,
    a = t.excludeDateIntervals;
  return a && a.length > 0 ? a.some(function (o) {
    var i = o.start,
      s = o.end;
    return Ot(n, {
      start: i,
      end: s
    });
  }) : e && e.some(function (o) {
    var i;
    return o instanceof Date ? Q(n, o) : Q(n, (i = o.date) !== null && i !== void 0 ? i : /* @__PURE__ */new Date());
  }) || !1;
}
function za(n, r) {
  var t = r === void 0 ? {} : r,
    e = t.minDate,
    a = t.maxDate,
    o = t.excludeDates,
    i = t.includeDates,
    s = t.filterDate;
  return It(n, {
    minDate: e ? va(e) : void 0,
    maxDate: a ? ga(a) : void 0
  }) || (o == null ? void 0 : o.some(function (c) {
    return le(n, c instanceof Date ? c : c.date);
  })) || i && !i.some(function (c) {
    return le(n, c);
  }) || s && !s(U(n)) || !1;
}
function At(n, r, t, e) {
  var a = F(n),
    o = ue(n),
    i = F(r),
    s = ue(r),
    c = F(e);
  return a === i && a === c ? o <= t && t <= s : a < i ? c === a && o <= t || c === i && s >= t || c < i && c > a : !1;
}
function gu(n, r) {
  var t = r === void 0 ? {} : r,
    e = t.minDate,
    a = t.maxDate,
    o = t.excludeDates,
    i = t.includeDates;
  return It(n, {
    minDate: e,
    maxDate: a
  }) || o && o.some(function (s) {
    return le(s instanceof Date ? s : s.date, n);
  }) || i && !i.some(function (s) {
    return le(s, n);
  }) || !1;
}
function Ht(n, r) {
  var t = r === void 0 ? {} : r,
    e = t.minDate,
    a = t.maxDate,
    o = t.excludeDates,
    i = t.includeDates,
    s = t.filterDate;
  return It(n, {
    minDate: e,
    maxDate: a
  }) || (o == null ? void 0 : o.some(function (c) {
    return mn(n, c instanceof Date ? c : c.date);
  })) || i && !i.some(function (c) {
    return mn(n, c);
  }) || s && !s(U(n)) || !1;
}
function Bt(n, r, t) {
  if (!r || !t || !rn(r) || !rn(t)) return !1;
  var e = F(r),
    a = F(t);
  return e <= n && a >= n;
}
function Gt(n, r) {
  var t = r === void 0 ? {} : r,
    e = t.minDate,
    a = t.maxDate,
    o = t.excludeDates,
    i = t.includeDates,
    s = t.filterDate,
    c = new Date(n, 0, 1);
  return It(c, {
    minDate: e ? yn(e) : void 0,
    maxDate: a ? wa(a) : void 0
  }) || (o == null ? void 0 : o.some(function (l) {
    return ke(c, l instanceof Date ? l : l.date);
  })) || i && !i.some(function (l) {
    return ke(c, l);
  }) || s && !s(U(c)) || !1;
}
function Qt(n, r, t, e) {
  var a = F(n),
    o = Ge(n),
    i = F(r),
    s = Ge(r),
    c = F(e);
  return a === i && a === c ? o <= t && t <= s : a < i ? c === a && o <= t || c === i && s >= t || c < i && c > a : !1;
}
function It(n, r) {
  var t,
    e = r === void 0 ? {} : r,
    a = e.minDate,
    o = e.maxDate;
  return (t = a && ht(n, a) < 0 || o && ht(n, o) > 0) !== null && t !== void 0 ? t : !1;
}
function Fr(n, r) {
  return r.some(function (t) {
    return Ce(t) === Ce(n) && Se(t) === Se(n) && Ye(t) === Ye(n);
  });
}
function Ir(n, r) {
  var t = r === void 0 ? {} : r,
    e = t.excludeTimes,
    a = t.includeTimes,
    o = t.filterTime;
  return e && Fr(n, e) || a && !Fr(n, a) || o && !o(n) || !1;
}
function $r(n, r) {
  var t = r.minTime,
    e = r.maxTime;
  if (!t || !e) throw new Error("Both minTime and maxTime props required");
  var a = U();
  a = Kt(a, Ce(n)), a = jt(a, Se(n)), a = zt(a, Ye(n));
  var o = U();
  o = Kt(o, Ce(t)), o = jt(o, Se(t)), o = zt(o, Ye(t));
  var i = U();
  i = Kt(i, Ce(e)), i = jt(i, Se(e)), i = zt(i, Ye(e));
  var s;
  try {
    s = !Ot(a, {
      start: o,
      end: i
    });
  } catch (_unused4) {
    s = !1;
  }
  return s;
}
function Wr(n, r) {
  var t = r === void 0 ? {} : r,
    e = t.minDate,
    a = t.includeDates,
    o = Ze(n, 1);
  return e && an(e, o) > 0 || a && a.every(function (i) {
    return an(i, o) > 0;
  }) || !1;
}
function Ar(n, r) {
  var t = r === void 0 ? {} : r,
    e = t.maxDate,
    a = t.includeDates,
    o = be(n, 1);
  return e && an(o, e) > 0 || a && a.every(function (i) {
    return an(o, i) > 0;
  }) || !1;
}
function vu(n, r) {
  var t = r === void 0 ? {} : r,
    e = t.minDate,
    a = t.includeDates,
    o = yn(n),
    i = Ea(o, 1);
  return e && on(e, i) > 0 || a && a.every(function (s) {
    return on(s, i) > 0;
  }) || !1;
}
function wu(n, r) {
  var t = r === void 0 ? {} : r,
    e = t.maxDate,
    a = t.includeDates,
    o = wa(n),
    i = jn(o, 1);
  return e && on(i, e) > 0 || a && a.every(function (s) {
    return on(i, s) > 0;
  }) || !1;
}
function Hr(n, r) {
  var t = r === void 0 ? {} : r,
    e = t.minDate,
    a = t.includeDates,
    o = mt(n, 1);
  return e && sn(e, o) > 0 || a && a.every(function (i) {
    return sn(i, o) > 0;
  }) || !1;
}
function bu(n, r) {
  var t = r === void 0 ? {} : r,
    e = t.minDate,
    a = t.yearItemNumber,
    o = a === void 0 ? Ft : a,
    i = St(mt(n, o)),
    s = Ae(i, o).endPeriod,
    c = e && F(e);
  return c && c > s || !1;
}
function Br(n, r) {
  var t = r === void 0 ? {} : r,
    e = t.maxDate,
    a = t.includeDates,
    o = Te(n, 1);
  return e && sn(o, e) > 0 || a && a.every(function (i) {
    return sn(o, i) > 0;
  }) || !1;
}
function yu(n, r) {
  var t = r === void 0 ? {} : r,
    e = t.maxDate,
    a = t.yearItemNumber,
    o = a === void 0 ? Ft : a,
    i = Te(n, o),
    s = Ae(i, o).startPeriod,
    c = e && F(e);
  return c && c < s || !1;
}
function Ua(n) {
  var r = n.minDate,
    t = n.includeDates;
  if (t && r) {
    var e = t.filter(function (a) {
      return ht(a, r) >= 0;
    });
    return gr(e);
  } else return t ? gr(t) : r;
}
function Xa(n) {
  var r = n.maxDate,
    t = n.includeDates;
  if (t && r) {
    var e = t.filter(function (a) {
      return ht(a, r) <= 0;
    });
    return mr(e);
  } else return t ? mr(t) : r;
}
function Qr(n, r) {
  var t;
  n === void 0 && (n = []), r === void 0 && (r = "react-datepicker__day--highlighted");
  for (var e = /* @__PURE__ */new Map(), a = 0, o = n.length; a < o; a++) {
    var i = n[a];
    if (Ne(i)) {
      var s = G(i, "MM.dd.yyyy"),
        c = e.get(s) || [];
      c.includes(r) || (c.push(r), e.set(s, c));
    } else if (typeof i == "object") {
      var l = Object.keys(i),
        u = (t = l[0]) !== null && t !== void 0 ? t : "",
        d = i[u];
      if (typeof u == "string" && Array.isArray(d)) for (var f = 0, p = d.length; f < p; f++) {
        var h = d[f];
        if (h) {
          var s = G(h, "MM.dd.yyyy"),
            c = e.get(s) || [];
          c.includes(u) || (c.push(u), e.set(s, c));
        }
      }
    }
  }
  return e;
}
function Du(n, r) {
  return n.length !== r.length ? !1 : n.every(function (t, e) {
    return t === r[e];
  });
}
function ku(n, r) {
  n === void 0 && (n = []), r === void 0 && (r = "react-datepicker__day--holidays");
  var t = /* @__PURE__ */new Map();
  return n.forEach(function (e) {
    var a = e.date,
      o = e.holidayName;
    if (Ne(a)) {
      var i = G(a, "MM.dd.yyyy"),
        s = t.get(i) || {
          className: "",
          holidayNames: []
        };
      if (!("className" in s && s.className === r && Du(s.holidayNames, [o]))) {
        s.className = r;
        var c = s.holidayNames;
        s.holidayNames = c ? Me(Me([], c, !0), [o], !1) : [o], t.set(i, s);
      }
    }
  }), t;
}
function xu(n, r, t, e, a) {
  for (var o = a.length, i = [], s = 0; s < o; s++) {
    var c = n,
      l = a[s];
    l && (c = Fi(c, Ce(l)), c = Wn(c, Se(l)), c = Wi(c, Ye(l)));
    var u = Wn(n, (t + 1) * e);
    Ve(c, r) && nt(c, u) && l != null && i.push(l);
  }
  return i;
}
function Vr(n) {
  return n < 10 ? "0".concat(n) : "".concat(n);
}
function Ae(n, r) {
  r === void 0 && (r = Ft);
  var t = Math.ceil(F(n) / r) * r,
    e = t - (r - 1);
  return {
    startPeriod: e,
    endPeriod: t
  };
}
function _u(n) {
  var r = new Date(n.getFullYear(), n.getMonth(), n.getDate()),
    t = new Date(n.getFullYear(), n.getMonth(), n.getDate(), 24);
  return Math.round((+t - +r) / 36e5);
}
function qr(n) {
  var r = n.getSeconds(),
    t = n.getMilliseconds();
  return M(n.getTime() - r * 1e3 - t);
}
function Mu(n, r) {
  return qr(n).getTime() === qr(r).getTime();
}
function Kr(n) {
  if (!Ne(n)) throw new Error("Invalid date");
  var r = new Date(n);
  return r.setHours(0, 0, 0, 0), r;
}
function jr(n, r) {
  if (!Ne(n) || !Ne(r)) throw new Error("Invalid date received");
  var t = Kr(n),
    e = Kr(r);
  return nt(t, e);
}
function Ga(n) {
  return n.key === k.Space;
}
var Cu = /** @class */
  function (n) {
    ie(r, n);
    function r(t) {
      var e = n.call(this, t) || this;
      return e.inputRef = /*#__PURE__*/m.createRef(), e.onTimeChange = function (a) {
        var o, i;
        e.setState({
          time: a
        });
        var s = e.props.date,
          c = s instanceof Date && !isNaN(+s),
          l = c ? s : /* @__PURE__ */new Date();
        if (a != null && a.includes(":")) {
          var u = a.split(":"),
            d = u[0],
            f = u[1];
          l.setHours(Number(d)), l.setMinutes(Number(f));
        }
        (i = (o = e.props).onChange) === null || i === void 0 || i.call(o, l);
      }, e.renderTimeInput = function () {
        var a = e.state.time,
          o = e.props,
          i = o.date,
          s = o.timeString,
          c = o.customTimeInput;
        return c ? /*#__PURE__*/ra(c, {
          date: i,
          value: a,
          onChange: e.onTimeChange
        }) : /*#__PURE__*/m.createElement("input", {
          type: "time",
          className: "react-datepicker-time__input",
          placeholder: "Time",
          name: "time-input",
          ref: e.inputRef,
          onClick: function onClick() {
            var l;
            (l = e.inputRef.current) === null || l === void 0 || l.focus();
          },
          required: !0,
          value: a,
          onChange: function onChange(l) {
            e.onTimeChange(l.target.value || s);
          }
        });
      }, e.state = {
        time: e.props.timeString
      }, e;
    }
    return r.getDerivedStateFromProps = function (t, e) {
      return t.timeString !== e.time ? {
        time: t.timeString
      } : null;
    }, r.prototype.render = function () {
      return /*#__PURE__*/m.createElement("div", {
        className: "react-datepicker__input-time-container"
      }, /*#__PURE__*/m.createElement("div", {
        className: "react-datepicker-time__caption"
      }, this.props.timeInputLabel), /*#__PURE__*/m.createElement("div", {
        className: "react-datepicker-time__input-container"
      }, /*#__PURE__*/m.createElement("div", {
        className: "react-datepicker-time__input"
      }, this.renderTimeInput())));
    }, r;
  }(oe),
  Su = /** @class */
  function (n) {
    ie(r, n);
    function r() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.dayEl = /*#__PURE__*/Be(), t.handleClick = function (e) {
        !t.isDisabled() && t.props.onClick && t.props.onClick(e);
      }, t.handleMouseEnter = function (e) {
        !t.isDisabled() && t.props.onMouseEnter && t.props.onMouseEnter(e);
      }, t.handleOnKeyDown = function (e) {
        var a,
          o,
          i = e.key;
        i === k.Space && (e.preventDefault(), e.key = k.Enter), (o = (a = t.props).handleOnKeyDown) === null || o === void 0 || o.call(a, e);
      }, t.isSameDay = function (e) {
        return Q(t.props.day, e);
      }, t.isKeyboardSelected = function () {
        var e;
        if (t.props.disabledKeyboardNavigation) return !1;
        var a = t.props.selectsMultiple ? (e = t.props.selectedDates) === null || e === void 0 ? void 0 : e.some(function (i) {
            return t.isSameDayOrWeek(i);
          }) : t.isSameDayOrWeek(t.props.selected),
          o = t.props.preSelection && t.isDisabled(t.props.preSelection);
        return !a && t.isSameDayOrWeek(t.props.preSelection) && !o;
      }, t.isDisabled = function (e) {
        return e === void 0 && (e = t.props.day), me(e, {
          minDate: t.props.minDate,
          maxDate: t.props.maxDate,
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals,
          includeDateIntervals: t.props.includeDateIntervals,
          includeDates: t.props.includeDates,
          filterDate: t.props.filterDate
        });
      }, t.isExcluded = function () {
        return or(t.props.day, {
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals
        });
      }, t.isStartOfWeek = function () {
        return Q(t.props.day, He(t.props.day, t.props.locale, t.props.calendarStartDay));
      }, t.isSameWeek = function (e) {
        return t.props.showWeekPicker && Q(e, He(t.props.day, t.props.locale, t.props.calendarStartDay));
      }, t.isSameDayOrWeek = function (e) {
        return t.isSameDay(e) || t.isSameWeek(e);
      }, t.getHighLightedClass = function () {
        var e = t.props,
          a = e.day,
          o = e.highlightDates;
        if (!o) return !1;
        var i = G(a, "MM.dd.yyyy");
        return o.get(i);
      }, t.getHolidaysClass = function () {
        var e,
          a = t.props,
          o = a.day,
          i = a.holidays;
        if (!i) return [void 0];
        var s = G(o, "MM.dd.yyyy");
        return i.has(s) ? [(e = i.get(s)) === null || e === void 0 ? void 0 : e.className] : [void 0];
      }, t.isInRange = function () {
        var e = t.props,
          a = e.day,
          o = e.startDate,
          i = e.endDate;
        return !o || !i ? !1 : Pt(a, o, i);
      }, t.isInSelectingRange = function () {
        var e,
          a = t.props,
          o = a.day,
          i = a.selectsStart,
          s = a.selectsEnd,
          c = a.selectsRange,
          l = a.selectsDisabledDaysInRange,
          u = a.startDate,
          d = a.endDate,
          f = (e = t.props.selectingDate) !== null && e !== void 0 ? e : t.props.preSelection;
        return !(i || s || c) || !f || !l && t.isDisabled() ? !1 : i && d && (nt(f, d) || Xe(f, d)) ? Pt(o, f, d) : s && u && (Ve(f, u) || Xe(f, u)) || c && u && !d && (Ve(f, u) || Xe(f, u)) ? Pt(o, u, f) : !1;
      }, t.isSelectingRangeStart = function () {
        var e;
        if (!t.isInSelectingRange()) return !1;
        var a = t.props,
          o = a.day,
          i = a.startDate,
          s = a.selectsStart,
          c = (e = t.props.selectingDate) !== null && e !== void 0 ? e : t.props.preSelection;
        return s ? Q(o, c) : Q(o, i);
      }, t.isSelectingRangeEnd = function () {
        var e;
        if (!t.isInSelectingRange()) return !1;
        var a = t.props,
          o = a.day,
          i = a.endDate,
          s = a.selectsEnd,
          c = a.selectsRange,
          l = (e = t.props.selectingDate) !== null && e !== void 0 ? e : t.props.preSelection;
        return s || c ? Q(o, l) : Q(o, i);
      }, t.isRangeStart = function () {
        var e = t.props,
          a = e.day,
          o = e.startDate,
          i = e.endDate;
        return !o || !i ? !1 : Q(o, a);
      }, t.isRangeEnd = function () {
        var e = t.props,
          a = e.day,
          o = e.startDate,
          i = e.endDate;
        return !o || !i ? !1 : Q(i, a);
      }, t.isWeekend = function () {
        var e = Rs(t.props.day);
        return e === 0 || e === 6;
      }, t.isAfterMonth = function () {
        return t.props.month !== void 0 && (t.props.month + 1) % 12 === ue(t.props.day);
      }, t.isBeforeMonth = function () {
        return t.props.month !== void 0 && (ue(t.props.day) + 1) % 12 === t.props.month;
      }, t.isCurrentDay = function () {
        return t.isSameDay(U());
      }, t.isSelected = function () {
        var e;
        return t.props.selectsMultiple ? (e = t.props.selectedDates) === null || e === void 0 ? void 0 : e.some(function (a) {
          return t.isSameDayOrWeek(a);
        }) : t.isSameDayOrWeek(t.props.selected);
      }, t.getClassNames = function (e) {
        var a = t.props.dayClassName ? t.props.dayClassName(e) : void 0;
        return se("react-datepicker__day", a, "react-datepicker__day--" + lu(t.props.day), {
          "react-datepicker__day--disabled": t.isDisabled(),
          "react-datepicker__day--excluded": t.isExcluded(),
          "react-datepicker__day--selected": t.isSelected(),
          "react-datepicker__day--keyboard-selected": t.isKeyboardSelected(),
          "react-datepicker__day--range-start": t.isRangeStart(),
          "react-datepicker__day--range-end": t.isRangeEnd(),
          "react-datepicker__day--in-range": t.isInRange(),
          "react-datepicker__day--in-selecting-range": t.isInSelectingRange(),
          "react-datepicker__day--selecting-range-start": t.isSelectingRangeStart(),
          "react-datepicker__day--selecting-range-end": t.isSelectingRangeEnd(),
          "react-datepicker__day--today": t.isCurrentDay(),
          "react-datepicker__day--weekend": t.isWeekend(),
          "react-datepicker__day--outside-month": t.isAfterMonth() || t.isBeforeMonth()
        }, t.getHighLightedClass(), t.getHolidaysClass());
      }, t.getAriaLabel = function () {
        var e = t.props,
          a = e.day,
          o = e.ariaLabelPrefixWhenEnabled,
          i = o === void 0 ? "Choose" : o,
          s = e.ariaLabelPrefixWhenDisabled,
          c = s === void 0 ? "Not available" : s,
          l = t.isDisabled() || t.isExcluded() ? c : i;
        return "".concat(l, " ").concat(G(a, "PPPP", t.props.locale));
      }, t.getTitle = function () {
        var e = t.props,
          a = e.day,
          o = e.holidays,
          i = o === void 0 ? /* @__PURE__ */new Map() : o,
          s = e.excludeDates,
          c = G(a, "MM.dd.yyyy"),
          l = [];
        return i.has(c) && l.push.apply(l, i.get(c).holidayNames), t.isExcluded() && l.push(s == null ? void 0 : s.filter(function (u) {
          return u instanceof Date ? Q(u, a) : Q(u == null ? void 0 : u.date, a);
        }).map(function (u) {
          if (!(u instanceof Date)) return u == null ? void 0 : u.message;
        })), l.join(", ");
      }, t.getTabIndex = function () {
        var e = t.props.selected,
          a = t.props.preSelection,
          o = !(t.props.showWeekPicker && (t.props.showWeekNumber || !t.isStartOfWeek())) && (t.isKeyboardSelected() || t.isSameDay(e) && Q(a, e)) ? 0 : -1;
        return o;
      }, t.handleFocusDay = function () {
        var e;
        t.shouldFocusDay() && ((e = t.dayEl.current) === null || e === void 0 || e.focus({
          preventScroll: !0
        }));
      }, t.renderDayContents = function () {
        return t.props.monthShowsDuplicateDaysEnd && t.isAfterMonth() || t.props.monthShowsDuplicateDaysStart && t.isBeforeMonth() ? null : t.props.renderDayContents ? t.props.renderDayContents(xr(t.props.day), t.props.day) : xr(t.props.day);
      }, t.render = function () {
        return (
          /*#__PURE__*/
          // TODO: Use <option> instead of the "option" role to ensure accessibility across all devices.
          m.createElement("div", {
            ref: t.dayEl,
            className: t.getClassNames(t.props.day),
            onKeyDown: t.handleOnKeyDown,
            onClick: t.handleClick,
            onMouseEnter: t.props.usePointerEvent ? void 0 : t.handleMouseEnter,
            onPointerEnter: t.props.usePointerEvent ? t.handleMouseEnter : void 0,
            tabIndex: t.getTabIndex(),
            "aria-label": t.getAriaLabel(),
            role: "option",
            title: t.getTitle(),
            "aria-disabled": t.isDisabled(),
            "aria-current": t.isCurrentDay() ? "date" : void 0,
            "aria-selected": t.isSelected() || t.isInRange()
          }, t.renderDayContents(), t.getTitle() !== "" && /*#__PURE__*/m.createElement("span", {
            className: "overlay"
          }, t.getTitle()))
        );
      }, t;
    }
    return r.prototype.componentDidMount = function () {
      this.handleFocusDay();
    }, r.prototype.componentDidUpdate = function () {
      this.handleFocusDay();
    }, r.prototype.shouldFocusDay = function () {
      var t = !1;
      return this.getTabIndex() === 0 && this.isSameDay(this.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (t = !0), this.props.inline && !this.props.shouldFocusDayInline && (t = !1), this.isDayActiveElement() && (t = !0), this.isDuplicateDay() && (t = !1)), t;
    }, r.prototype.isDayActiveElement = function () {
      var t, e, a;
      return ((e = (t = this.props.containerRef) === null || t === void 0 ? void 0 : t.current) === null || e === void 0 ? void 0 : e.contains(document.activeElement)) && ((a = document.activeElement) === null || a === void 0 ? void 0 : a.classList.contains("react-datepicker__day"));
    }, r.prototype.isDuplicateDay = function () {
      return (
        //day is one of the non rendered duplicate days
        this.props.monthShowsDuplicateDaysEnd && this.isAfterMonth() || this.props.monthShowsDuplicateDaysStart && this.isBeforeMonth()
      );
    }, r;
  }(oe),
  Pu = /** @class */
  function (n) {
    ie(r, n);
    function r() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.weekNumberEl = /*#__PURE__*/Be(), t.handleClick = function (e) {
        t.props.onClick && t.props.onClick(e);
      }, t.handleOnKeyDown = function (e) {
        var a,
          o,
          i = e.key;
        i === k.Space && (e.preventDefault(), e.key = k.Enter), (o = (a = t.props).handleOnKeyDown) === null || o === void 0 || o.call(a, e);
      }, t.isKeyboardSelected = function () {
        return !t.props.disabledKeyboardNavigation && !Q(t.props.date, t.props.selected) && Q(t.props.date, t.props.preSelection);
      }, t.getTabIndex = function () {
        return t.props.showWeekPicker && t.props.showWeekNumber && (t.isKeyboardSelected() || Q(t.props.date, t.props.selected) && Q(t.props.preSelection, t.props.selected)) ? 0 : -1;
      }, t.handleFocusWeekNumber = function (e) {
        var a = !1;
        t.getTabIndex() === 0 && !(e != null && e.isInputFocused) && Q(t.props.date, t.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (a = !0), t.props.inline && !t.props.shouldFocusDayInline && (a = !1), t.props.containerRef && t.props.containerRef.current && t.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (a = !0)), a && t.weekNumberEl.current && t.weekNumberEl.current.focus({
          preventScroll: !0
        });
      }, t;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function get() {
        return {
          ariaLabelPrefix: "week "
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.componentDidMount = function () {
      this.handleFocusWeekNumber();
    }, r.prototype.componentDidUpdate = function (t) {
      this.handleFocusWeekNumber(t);
    }, r.prototype.render = function () {
      var t = this.props,
        e = t.weekNumber,
        a = t.isWeekDisabled,
        o = t.ariaLabelPrefix,
        i = o === void 0 ? r.defaultProps.ariaLabelPrefix : o,
        s = t.onClick,
        c = {
          "react-datepicker__week-number": !0,
          "react-datepicker__week-number--clickable": !!s && !a,
          "react-datepicker__week-number--selected": !!s && Q(this.props.date, this.props.selected)
        };
      return /*#__PURE__*/m.createElement("div", {
        ref: this.weekNumberEl,
        className: se(c),
        "aria-label": "".concat(i, " ").concat(this.props.weekNumber),
        onClick: this.handleClick,
        onKeyDown: this.handleOnKeyDown,
        tabIndex: this.getTabIndex()
      }, e);
    }, r;
  }(oe),
  Eu = /** @class */
  function (n) {
    ie(r, n);
    function r() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.isDisabled = function (e) {
        return me(e, {
          minDate: t.props.minDate,
          maxDate: t.props.maxDate,
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals,
          includeDateIntervals: t.props.includeDateIntervals,
          includeDates: t.props.includeDates,
          filterDate: t.props.filterDate
        });
      }, t.handleDayClick = function (e, a) {
        t.props.onDayClick && t.props.onDayClick(e, a);
      }, t.handleDayMouseEnter = function (e) {
        t.props.onDayMouseEnter && t.props.onDayMouseEnter(e);
      }, t.handleWeekClick = function (e, a, o) {
        for (var i, s, c, l = new Date(e), u = 0; u < 7; u++) {
          var d = new Date(e);
          d.setDate(d.getDate() + u);
          var f = !t.isDisabled(d);
          if (f) {
            l = d;
            break;
          }
        }
        typeof t.props.onWeekSelect == "function" && t.props.onWeekSelect(l, a, o), t.props.showWeekPicker && t.handleDayClick(l, o), ((i = t.props.shouldCloseOnSelect) !== null && i !== void 0 ? i : r.defaultProps.shouldCloseOnSelect) && ((c = (s = t.props).setOpen) === null || c === void 0 || c.call(s, !1));
      }, t.formatWeekNumber = function (e) {
        return t.props.formatWeekNumber ? t.props.formatWeekNumber(e) : cu(e);
      }, t.isWeekDisabled = function () {
        for (var e = t.startOfWeek(), a = we(e, 6), o = new Date(e); o <= a;) {
          if (!t.isDisabled(o)) return !1;
          o = we(o, 1);
        }
        return !0;
      }, t.renderDays = function () {
        var e = t.startOfWeek(),
          a = [],
          o = t.formatWeekNumber(e);
        if (t.props.showWeekNumber) {
          var i = t.props.onWeekSelect || t.props.showWeekPicker ? t.handleWeekClick.bind(t, e, o) : void 0;
          a.push( /*#__PURE__*/m.createElement(Pu, _V({
            key: "W"
          }, r.defaultProps, t.props, {
            weekNumber: o,
            isWeekDisabled: t.isWeekDisabled(),
            date: e,
            onClick: i
          })));
        }
        return a.concat([0, 1, 2, 3, 4, 5, 6].map(function (s) {
          var c = we(e, s);
          return /*#__PURE__*/m.createElement(Su, _V({}, r.defaultProps, t.props, {
            ariaLabelPrefixWhenEnabled: t.props.chooseDayAriaLabelPrefix,
            ariaLabelPrefixWhenDisabled: t.props.disabledDayAriaLabelPrefix,
            key: c.valueOf(),
            day: c,
            onClick: t.handleDayClick.bind(t, c),
            onMouseEnter: t.handleDayMouseEnter.bind(t, c)
          }));
        }));
      }, t.startOfWeek = function () {
        return He(t.props.day, t.props.locale, t.props.calendarStartDay);
      }, t.isKeyboardSelected = function () {
        return !t.props.disabledKeyboardNavigation && !Q(t.startOfWeek(), t.props.selected) && Q(t.startOfWeek(), t.props.preSelection);
      }, t;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function get() {
        return {
          shouldCloseOnSelect: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.render = function () {
      var t = {
        "react-datepicker__week": !0,
        "react-datepicker__week--selected": Q(this.startOfWeek(), this.props.selected),
        "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
      };
      return /*#__PURE__*/m.createElement("div", {
        className: se(t)
      }, this.renderDays());
    }, r;
  }(oe),
  Mt,
  Ou = 6,
  dt = {
    TWO_COLUMNS: "two_columns",
    THREE_COLUMNS: "three_columns",
    FOUR_COLUMNS: "four_columns"
  },
  Yn = (Mt = {}, Mt[dt.TWO_COLUMNS] = {
    grid: [[0, 1], [2, 3], [4, 5], [6, 7], [8, 9], [10, 11]],
    verticalNavigationOffset: 2
  }, Mt[dt.THREE_COLUMNS] = {
    grid: [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]],
    verticalNavigationOffset: 3
  }, Mt[dt.FOUR_COLUMNS] = {
    grid: [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]],
    verticalNavigationOffset: 4
  }, Mt),
  Vt = 1;
function zr(n, r) {
  return n ? dt.FOUR_COLUMNS : r ? dt.TWO_COLUMNS : dt.THREE_COLUMNS;
}
var Tu = /** @class */
  function (n) {
    ie(r, n);
    function r() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.MONTH_REFS = Me([], Array(12), !0).map(function () {
        return /*#__PURE__*/Be();
      }), t.QUARTER_REFS = Me([], Array(4), !0).map(function () {
        return /*#__PURE__*/Be();
      }), t.isDisabled = function (e) {
        return me(e, {
          minDate: t.props.minDate,
          maxDate: t.props.maxDate,
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals,
          includeDateIntervals: t.props.includeDateIntervals,
          includeDates: t.props.includeDates,
          filterDate: t.props.filterDate
        });
      }, t.isExcluded = function (e) {
        return or(e, {
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals
        });
      }, t.handleDayClick = function (e, a) {
        var o, i;
        (i = (o = t.props).onDayClick) === null || i === void 0 || i.call(o, e, a, t.props.orderInDisplay);
      }, t.handleDayMouseEnter = function (e) {
        var a, o;
        (o = (a = t.props).onDayMouseEnter) === null || o === void 0 || o.call(a, e);
      }, t.handleMouseLeave = function () {
        var e, a;
        (a = (e = t.props).onMouseLeave) === null || a === void 0 || a.call(e);
      }, t.isRangeStartMonth = function (e) {
        var a = t.props,
          o = a.day,
          i = a.startDate,
          s = a.endDate;
        return !i || !s ? !1 : le(de(o, e), i);
      }, t.isRangeStartQuarter = function (e) {
        var a = t.props,
          o = a.day,
          i = a.startDate,
          s = a.endDate;
        return !i || !s ? !1 : mn(lt(o, e), i);
      }, t.isRangeEndMonth = function (e) {
        var a = t.props,
          o = a.day,
          i = a.startDate,
          s = a.endDate;
        return !i || !s ? !1 : le(de(o, e), s);
      }, t.isRangeEndQuarter = function (e) {
        var a = t.props,
          o = a.day,
          i = a.startDate,
          s = a.endDate;
        return !i || !s ? !1 : mn(lt(o, e), s);
      }, t.isInSelectingRangeMonth = function (e) {
        var a,
          o = t.props,
          i = o.day,
          s = o.selectsStart,
          c = o.selectsEnd,
          l = o.selectsRange,
          u = o.startDate,
          d = o.endDate,
          f = (a = t.props.selectingDate) !== null && a !== void 0 ? a : t.props.preSelection;
        return !(s || c || l) || !f ? !1 : s && d ? At(f, d, e, i) : c && u || l && u && !d ? At(u, f, e, i) : !1;
      }, t.isSelectingMonthRangeStart = function (e) {
        var a;
        if (!t.isInSelectingRangeMonth(e)) return !1;
        var o = t.props,
          i = o.day,
          s = o.startDate,
          c = o.selectsStart,
          l = de(i, e),
          u = (a = t.props.selectingDate) !== null && a !== void 0 ? a : t.props.preSelection;
        return c ? le(l, u) : le(l, s);
      }, t.isSelectingMonthRangeEnd = function (e) {
        var a;
        if (!t.isInSelectingRangeMonth(e)) return !1;
        var o = t.props,
          i = o.day,
          s = o.endDate,
          c = o.selectsEnd,
          l = o.selectsRange,
          u = de(i, e),
          d = (a = t.props.selectingDate) !== null && a !== void 0 ? a : t.props.preSelection;
        return c || l ? le(u, d) : le(u, s);
      }, t.isInSelectingRangeQuarter = function (e) {
        var a,
          o = t.props,
          i = o.day,
          s = o.selectsStart,
          c = o.selectsEnd,
          l = o.selectsRange,
          u = o.startDate,
          d = o.endDate,
          f = (a = t.props.selectingDate) !== null && a !== void 0 ? a : t.props.preSelection;
        return !(s || c || l) || !f ? !1 : s && d ? Qt(f, d, e, i) : c && u || l && u && !d ? Qt(u, f, e, i) : !1;
      }, t.isWeekInMonth = function (e) {
        var a = t.props.day,
          o = we(e, 6);
        return le(e, a) || le(o, a);
      }, t.isCurrentMonth = function (e, a) {
        return F(e) === F(U()) && a === ue(U());
      }, t.isCurrentQuarter = function (e, a) {
        return F(e) === F(U()) && a === Ge(U());
      }, t.isSelectedMonth = function (e, a, o) {
        return ue(o) === a && F(e) === F(o);
      }, t.isSelectMonthInList = function (e, a, o) {
        return o.some(function (i) {
          return t.isSelectedMonth(e, a, i);
        });
      }, t.isSelectedQuarter = function (e, a, o) {
        return Ge(e) === a && F(e) === F(o);
      }, t.renderWeeks = function () {
        for (var e = [], a = t.props.fixedHeight, o = 0, i = !1, s = He(Re(t.props.day), t.props.locale, t.props.calendarStartDay), c = function c(h) {
            return t.props.showWeekPicker ? He(h, t.props.locale, t.props.calendarStartDay) : t.props.preSelection;
          }, l = function l(h) {
            return t.props.showWeekPicker ? He(h, t.props.locale, t.props.calendarStartDay) : t.props.selected;
          }, u = t.props.selected ? l(t.props.selected) : void 0, d = t.props.preSelection ? c(t.props.preSelection) : void 0; e.push( /*#__PURE__*/m.createElement(Eu, _V({}, t.props, {
          ariaLabelPrefix: t.props.weekAriaLabelPrefix,
          key: o,
          day: s,
          month: ue(t.props.day),
          onDayClick: t.handleDayClick,
          onDayMouseEnter: t.handleDayMouseEnter,
          selected: u,
          preSelection: d,
          showWeekNumber: t.props.showWeekNumbers
        }))), !i;) {
          o++, s = nn(s, 1);
          var f = a && o >= Ou,
            p = !a && !t.isWeekInMonth(s);
          if (f || p) if (t.props.peekNextMonth) i = !0;else break;
        }
        return e;
      }, t.onMonthClick = function (e, a) {
        var o = t.isMonthDisabledForLabelDate(a),
          i = o.isDisabled,
          s = o.labelDate;
        i || t.handleDayClick(Re(s), e);
      }, t.onMonthMouseEnter = function (e) {
        var a = t.isMonthDisabledForLabelDate(e),
          o = a.isDisabled,
          i = a.labelDate;
        o || t.handleDayMouseEnter(Re(i));
      }, t.handleMonthNavigation = function (e, a) {
        var o, i, s, c;
        (i = (o = t.props).setPreSelection) === null || i === void 0 || i.call(o, a), (c = (s = t.MONTH_REFS[e]) === null || s === void 0 ? void 0 : s.current) === null || c === void 0 || c.focus();
      }, t.handleKeyboardNavigation = function (e, a, o) {
        var i,
          s = t.props,
          c = s.selected,
          l = s.preSelection,
          u = s.setPreSelection,
          d = s.minDate,
          f = s.maxDate,
          p = s.showFourColumnMonthYearPicker,
          h = s.showTwoColumnMonthYearPicker;
        if (l) {
          var g = zr(p, h),
            v = t.getVerticalOffset(g),
            w = (i = Yn[g]) === null || i === void 0 ? void 0 : i.grid,
            D = function D(y, x, E) {
              var B,
                L,
                N = x,
                W = E;
              switch (y) {
                case k.ArrowRight:
                  N = be(x, Vt), W = E === 11 ? 0 : E + Vt;
                  break;
                case k.ArrowLeft:
                  N = Ze(x, Vt), W = E === 0 ? 11 : E - Vt;
                  break;
                case k.ArrowUp:
                  N = Ze(x, v), W = !((B = w == null ? void 0 : w[0]) === null || B === void 0) && B.includes(E) ? E + 12 - v : E - v;
                  break;
                case k.ArrowDown:
                  N = be(x, v), W = !((L = w == null ? void 0 : w[w.length - 1]) === null || L === void 0) && L.includes(E) ? E - 12 + v : E + v;
                  break;
              }
              return {
                newCalculatedDate: N,
                newCalculatedMonth: W
              };
            },
            b = function b(y, x, E) {
              for (var B = 40, L = y, N = !1, W = 0, H = D(L, x, E), A = H.newCalculatedDate, O = H.newCalculatedMonth; !N;) {
                if (W >= B) {
                  A = x, O = E;
                  break;
                }
                if (d && A < d) {
                  L = k.ArrowRight;
                  var R = D(L, A, O);
                  A = R.newCalculatedDate, O = R.newCalculatedMonth;
                }
                if (f && A > f) {
                  L = k.ArrowLeft;
                  var R = D(L, A, O);
                  A = R.newCalculatedDate, O = R.newCalculatedMonth;
                }
                if (gu(A, t.props)) {
                  var R = D(L, A, O);
                  A = R.newCalculatedDate, O = R.newCalculatedMonth;
                } else N = !0;
                W++;
              }
              return {
                newCalculatedDate: A,
                newCalculatedMonth: O
              };
            };
          if (a === k.Enter) {
            t.isMonthDisabled(o) || (t.onMonthClick(e, o), u == null || u(c));
            return;
          }
          var P = b(a, l, o),
            S = P.newCalculatedDate,
            T = P.newCalculatedMonth;
          switch (a) {
            case k.ArrowRight:
            case k.ArrowLeft:
            case k.ArrowUp:
            case k.ArrowDown:
              t.handleMonthNavigation(T, S);
              break;
          }
        }
      }, t.getVerticalOffset = function (e) {
        var a, o;
        return (o = (a = Yn[e]) === null || a === void 0 ? void 0 : a.verticalNavigationOffset) !== null && o !== void 0 ? o : 0;
      }, t.onMonthKeyDown = function (e, a) {
        var o = t.props,
          i = o.disabledKeyboardNavigation,
          s = o.handleOnMonthKeyDown,
          c = e.key;
        c !== k.Tab && e.preventDefault(), i || t.handleKeyboardNavigation(e, c, a), s && s(e);
      }, t.onQuarterClick = function (e, a) {
        var o = lt(t.props.day, a);
        Ht(o, t.props) || t.handleDayClick(Yr(o), e);
      }, t.onQuarterMouseEnter = function (e) {
        var a = lt(t.props.day, e);
        Ht(a, t.props) || t.handleDayMouseEnter(Yr(a));
      }, t.handleQuarterNavigation = function (e, a) {
        var o, i, s, c;
        t.isDisabled(a) || t.isExcluded(a) || ((i = (o = t.props).setPreSelection) === null || i === void 0 || i.call(o, a), (c = (s = t.QUARTER_REFS[e - 1]) === null || s === void 0 ? void 0 : s.current) === null || c === void 0 || c.focus());
      }, t.onQuarterKeyDown = function (e, a) {
        var o,
          i,
          s = e.key;
        if (!t.props.disabledKeyboardNavigation) switch (s) {
          case k.Enter:
            t.onQuarterClick(e, a), (i = (o = t.props).setPreSelection) === null || i === void 0 || i.call(o, t.props.selected);
            break;
          case k.ArrowRight:
            if (!t.props.preSelection) break;
            t.handleQuarterNavigation(a === 4 ? 1 : a + 1, jn(t.props.preSelection, 1));
            break;
          case k.ArrowLeft:
            if (!t.props.preSelection) break;
            t.handleQuarterNavigation(a === 1 ? 4 : a - 1, Ea(t.props.preSelection, 1));
            break;
        }
      }, t.isMonthDisabledForLabelDate = function (e) {
        var a,
          o = t.props,
          i = o.day,
          s = o.minDate,
          c = o.maxDate,
          l = o.excludeDates,
          u = o.includeDates,
          d = de(i, e);
        return {
          isDisabled: (a = (s || c || l || u) && za(d, t.props)) !== null && a !== void 0 ? a : !1,
          labelDate: d
        };
      }, t.isMonthDisabled = function (e) {
        var a = t.isMonthDisabledForLabelDate(e).isDisabled;
        return a;
      }, t.getMonthClassNames = function (e) {
        var a = t.props,
          o = a.day,
          i = a.startDate,
          s = a.endDate,
          c = a.preSelection,
          l = a.monthClassName,
          u = l ? l(de(o, e)) : void 0,
          d = t.getSelection();
        return se("react-datepicker__month-text", "react-datepicker__month-".concat(e), u, {
          "react-datepicker__month-text--disabled": t.isMonthDisabled(e),
          "react-datepicker__month-text--selected": d ? t.isSelectMonthInList(o, e, d) : void 0,
          "react-datepicker__month-text--keyboard-selected": !t.props.disabledKeyboardNavigation && c && t.isSelectedMonth(o, e, c) && !t.isMonthDisabled(e),
          "react-datepicker__month-text--in-selecting-range": t.isInSelectingRangeMonth(e),
          "react-datepicker__month-text--in-range": i && s ? At(i, s, e, o) : void 0,
          "react-datepicker__month-text--range-start": t.isRangeStartMonth(e),
          "react-datepicker__month-text--range-end": t.isRangeEndMonth(e),
          "react-datepicker__month-text--selecting-range-start": t.isSelectingMonthRangeStart(e),
          "react-datepicker__month-text--selecting-range-end": t.isSelectingMonthRangeEnd(e),
          "react-datepicker__month-text--today": t.isCurrentMonth(o, e)
        });
      }, t.getTabIndex = function (e) {
        if (t.props.preSelection == null) return "-1";
        var a = ue(t.props.preSelection),
          o = t.isMonthDisabledForLabelDate(a).isDisabled,
          i = e === a && !(o || t.props.disabledKeyboardNavigation) ? "0" : "-1";
        return i;
      }, t.getQuarterTabIndex = function (e) {
        if (t.props.preSelection == null) return "-1";
        var a = Ge(t.props.preSelection),
          o = Ht(t.props.day, t.props),
          i = e === a && !(o || t.props.disabledKeyboardNavigation) ? "0" : "-1";
        return i;
      }, t.getAriaLabel = function (e) {
        var a = t.props,
          o = a.chooseDayAriaLabelPrefix,
          i = o === void 0 ? "Choose" : o,
          s = a.disabledDayAriaLabelPrefix,
          c = s === void 0 ? "Not available" : s,
          l = a.day,
          u = a.locale,
          d = de(l, e),
          f = t.isDisabled(d) || t.isExcluded(d) ? c : i;
        return "".concat(f, " ").concat(G(d, "MMMM yyyy", u));
      }, t.getQuarterClassNames = function (e) {
        var a = t.props,
          o = a.day,
          i = a.startDate,
          s = a.endDate,
          c = a.selected,
          l = a.minDate,
          u = a.maxDate,
          d = a.excludeDates,
          f = a.includeDates,
          p = a.filterDate,
          h = a.preSelection,
          g = a.disabledKeyboardNavigation,
          v = (l || u || d || f || p) && Ht(lt(o, e), t.props);
        return se("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(e), {
          "react-datepicker__quarter-text--disabled": v,
          "react-datepicker__quarter-text--selected": c ? t.isSelectedQuarter(o, e, c) : void 0,
          "react-datepicker__quarter-text--keyboard-selected": !g && h && t.isSelectedQuarter(o, e, h) && !v,
          "react-datepicker__quarter-text--in-selecting-range": t.isInSelectingRangeQuarter(e),
          "react-datepicker__quarter-text--in-range": i && s ? Qt(i, s, e, o) : void 0,
          "react-datepicker__quarter-text--range-start": t.isRangeStartQuarter(e),
          "react-datepicker__quarter-text--range-end": t.isRangeEndQuarter(e)
        });
      }, t.getMonthContent = function (e) {
        var a = t.props,
          o = a.showFullMonthYearPicker,
          i = a.renderMonthContent,
          s = a.locale,
          c = a.day,
          l = ja(e, s),
          u = ar(e, s);
        return i ? i(e, l, u, c) : o ? u : l;
      }, t.getQuarterContent = function (e) {
        var a,
          o = t.props,
          i = o.renderQuarterContent,
          s = o.locale,
          c = mu(e, s);
        return (a = i == null ? void 0 : i(e, c)) !== null && a !== void 0 ? a : c;
      }, t.renderMonths = function () {
        var e,
          a = t.props,
          o = a.showTwoColumnMonthYearPicker,
          i = a.showFourColumnMonthYearPicker,
          s = a.day,
          c = a.selected,
          l = (e = Yn[zr(i, o)]) === null || e === void 0 ? void 0 : e.grid;
        return l == null ? void 0 : l.map(function (u, d) {
          return /*#__PURE__*/m.createElement("div", {
            className: "react-datepicker__month-wrapper",
            key: d
          }, u.map(function (f, p) {
            return /*#__PURE__*/m.createElement("div", {
              ref: t.MONTH_REFS[f],
              key: p,
              onClick: function onClick(h) {
                t.onMonthClick(h, f);
              },
              onKeyDown: function onKeyDown(h) {
                Ga(h) && (h.preventDefault(), h.key = k.Enter), t.onMonthKeyDown(h, f);
              },
              onMouseEnter: t.props.usePointerEvent ? void 0 : function () {
                return t.onMonthMouseEnter(f);
              },
              onPointerEnter: t.props.usePointerEvent ? function () {
                return t.onMonthMouseEnter(f);
              } : void 0,
              tabIndex: Number(t.getTabIndex(f)),
              className: t.getMonthClassNames(f),
              "aria-disabled": t.isMonthDisabled(f),
              role: "option",
              "aria-label": t.getAriaLabel(f),
              "aria-current": t.isCurrentMonth(s, f) ? "date" : void 0,
              "aria-selected": c ? t.isSelectedMonth(s, f, c) : void 0
            }, t.getMonthContent(f));
          }));
        });
      }, t.renderQuarters = function () {
        var e = t.props,
          a = e.day,
          o = e.selected,
          i = [1, 2, 3, 4];
        return /*#__PURE__*/m.createElement("div", {
          className: "react-datepicker__quarter-wrapper"
        }, i.map(function (s, c) {
          return /*#__PURE__*/m.createElement("div", {
            key: c,
            ref: t.QUARTER_REFS[c],
            role: "option",
            onClick: function onClick(l) {
              t.onQuarterClick(l, s);
            },
            onKeyDown: function onKeyDown(l) {
              t.onQuarterKeyDown(l, s);
            },
            onMouseEnter: t.props.usePointerEvent ? void 0 : function () {
              return t.onQuarterMouseEnter(s);
            },
            onPointerEnter: t.props.usePointerEvent ? function () {
              return t.onQuarterMouseEnter(s);
            } : void 0,
            className: t.getQuarterClassNames(s),
            "aria-selected": o ? t.isSelectedQuarter(a, s, o) : void 0,
            tabIndex: Number(t.getQuarterTabIndex(s)),
            "aria-current": t.isCurrentQuarter(a, s) ? "date" : void 0
          }, t.getQuarterContent(s));
        }));
      }, t.getClassNames = function () {
        var e = t.props,
          a = e.selectingDate,
          o = e.selectsStart,
          i = e.selectsEnd,
          s = e.showMonthYearPicker,
          c = e.showQuarterYearPicker,
          l = e.showWeekPicker;
        return se("react-datepicker__month", {
          "react-datepicker__month--selecting-range": a && (o || i)
        }, {
          "react-datepicker__monthPicker": s
        }, {
          "react-datepicker__quarterPicker": c
        }, {
          "react-datepicker__weekPicker": l
        });
      }, t;
    }
    return r.prototype.getSelection = function () {
      var t = this.props,
        e = t.selected,
        a = t.selectedDates,
        o = t.selectsMultiple;
      if (o) return a;
      if (e) return [e];
    }, r.prototype.render = function () {
      var t = this.props,
        e = t.showMonthYearPicker,
        a = t.showQuarterYearPicker,
        o = t.day,
        i = t.ariaLabelPrefix,
        s = i === void 0 ? "Month " : i,
        c = s ? s.trim() + " " : "";
      return /*#__PURE__*/m.createElement("div", {
        className: this.getClassNames(),
        onMouseLeave: this.props.usePointerEvent ? void 0 : this.handleMouseLeave,
        onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0,
        "aria-label": "".concat(c).concat(G(o, "MMMM, yyyy", this.props.locale)),
        role: "listbox"
      }, e ? this.renderMonths() : a ? this.renderQuarters() : this.renderWeeks());
    }, r;
  }(oe),
  Nu = /** @class */
  function (n) {
    ie(r, n);
    function r() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.isSelectedMonth = function (e) {
        return t.props.month === e;
      }, t.renderOptions = function () {
        return t.props.monthNames.map(function (e, a) {
          return /*#__PURE__*/m.createElement("div", {
            className: t.isSelectedMonth(a) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
            key: e,
            onClick: t.onChange.bind(t, a),
            "aria-selected": t.isSelectedMonth(a) ? "true" : void 0
          }, t.isSelectedMonth(a) ? /*#__PURE__*/m.createElement("span", {
            className: "react-datepicker__month-option--selected"
          }, "✓") : "", e);
        });
      }, t.onChange = function (e) {
        return t.props.onChange(e);
      }, t.handleClickOutside = function () {
        return t.props.onCancel();
      }, t;
    }
    return r.prototype.render = function () {
      return /*#__PURE__*/m.createElement(xn, {
        className: "react-datepicker__month-dropdown",
        onClickOutside: this.handleClickOutside
      }, this.renderOptions());
    }, r;
  }(oe),
  Yu = /** @class */
  function (n) {
    ie(r, n);
    function r() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.state = {
        dropdownVisible: !1
      }, t.renderSelectOptions = function (e) {
        return e.map(function (a, o) {
          return /*#__PURE__*/m.createElement("option", {
            key: a,
            value: o
          }, a);
        });
      }, t.renderSelectMode = function (e) {
        return /*#__PURE__*/m.createElement("select", {
          value: t.props.month,
          className: "react-datepicker__month-select",
          onChange: function onChange(a) {
            return t.onChange(parseInt(a.target.value));
          }
        }, t.renderSelectOptions(e));
      }, t.renderReadView = function (e, a) {
        return /*#__PURE__*/m.createElement("div", {
          key: "read",
          style: {
            visibility: e ? "visible" : "hidden"
          },
          className: "react-datepicker__month-read-view",
          onClick: t.toggleDropdown
        }, /*#__PURE__*/m.createElement("span", {
          className: "react-datepicker__month-read-view--down-arrow"
        }), /*#__PURE__*/m.createElement("span", {
          className: "react-datepicker__month-read-view--selected-month"
        }, a[t.props.month]));
      }, t.renderDropdown = function (e) {
        return /*#__PURE__*/m.createElement(Nu, _V({
          key: "dropdown"
        }, t.props, {
          monthNames: e,
          onChange: t.onChange,
          onCancel: t.toggleDropdown
        }));
      }, t.renderScrollMode = function (e) {
        var a = t.state.dropdownVisible,
          o = [t.renderReadView(!a, e)];
        return a && o.unshift(t.renderDropdown(e)), o;
      }, t.onChange = function (e) {
        t.toggleDropdown(), e !== t.props.month && t.props.onChange(e);
      }, t.toggleDropdown = function () {
        return t.setState({
          dropdownVisible: !t.state.dropdownVisible
        });
      }, t;
    }
    return r.prototype.render = function () {
      var t = this,
        e = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function (o) {
          return ja(o, t.props.locale);
        } : function (o) {
          return ar(o, t.props.locale);
        }),
        a;
      switch (this.props.dropdownMode) {
        case "scroll":
          a = this.renderScrollMode(e);
          break;
        case "select":
          a = this.renderSelectMode(e);
          break;
      }
      return /*#__PURE__*/m.createElement("div", {
        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
      }, a);
    }, r;
  }(oe);
function Ru(n, r) {
  for (var t = [], e = Re(n), a = Re(r); !Ve(e, a);) {
    t.push(U(e)), e = be(e, 1);
  }
  return t;
}
var Lu = /** @class */
  function (n) {
    ie(r, n);
    function r(t) {
      var e = n.call(this, t) || this;
      return e.renderOptions = function () {
        return e.state.monthYearsList.map(function (a) {
          var o = Bn(a),
            i = ke(e.props.date, a) && le(e.props.date, a);
          return /*#__PURE__*/m.createElement("div", {
            className: i ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
            key: o,
            onClick: e.onChange.bind(e, o),
            "aria-selected": i ? "true" : void 0
          }, i ? /*#__PURE__*/m.createElement("span", {
            className: "react-datepicker__month-year-option--selected"
          }, "✓") : "", G(a, e.props.dateFormat, e.props.locale));
        });
      }, e.onChange = function (a) {
        return e.props.onChange(a);
      }, e.handleClickOutside = function () {
        e.props.onCancel();
      }, e.state = {
        monthYearsList: Ru(e.props.minDate, e.props.maxDate)
      }, e;
    }
    return r.prototype.render = function () {
      var t = se({
        "react-datepicker__month-year-dropdown": !0,
        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
      });
      return /*#__PURE__*/m.createElement(xn, {
        className: t,
        onClickOutside: this.handleClickOutside
      }, this.renderOptions());
    }, r;
  }(oe),
  Fu = /** @class */
  function (n) {
    ie(r, n);
    function r() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.state = {
        dropdownVisible: !1
      }, t.renderSelectOptions = function () {
        for (var e = Re(t.props.minDate), a = Re(t.props.maxDate), o = []; !Ve(e, a);) {
          var i = Bn(e);
          o.push( /*#__PURE__*/m.createElement("option", {
            key: i,
            value: i
          }, G(e, t.props.dateFormat, t.props.locale))), e = be(e, 1);
        }
        return o;
      }, t.onSelectChange = function (e) {
        t.onChange(parseInt(e.target.value));
      }, t.renderSelectMode = function () {
        return /*#__PURE__*/m.createElement("select", {
          value: Bn(Re(t.props.date)),
          className: "react-datepicker__month-year-select",
          onChange: t.onSelectChange
        }, t.renderSelectOptions());
      }, t.renderReadView = function (e) {
        var a = G(t.props.date, t.props.dateFormat, t.props.locale);
        return /*#__PURE__*/m.createElement("div", {
          key: "read",
          style: {
            visibility: e ? "visible" : "hidden"
          },
          className: "react-datepicker__month-year-read-view",
          onClick: t.toggleDropdown
        }, /*#__PURE__*/m.createElement("span", {
          className: "react-datepicker__month-year-read-view--down-arrow"
        }), /*#__PURE__*/m.createElement("span", {
          className: "react-datepicker__month-year-read-view--selected-month-year"
        }, a));
      }, t.renderDropdown = function () {
        return /*#__PURE__*/m.createElement(Lu, _V({
          key: "dropdown"
        }, t.props, {
          onChange: t.onChange,
          onCancel: t.toggleDropdown
        }));
      }, t.renderScrollMode = function () {
        var e = t.state.dropdownVisible,
          a = [t.renderReadView(!e)];
        return e && a.unshift(t.renderDropdown()), a;
      }, t.onChange = function (e) {
        t.toggleDropdown();
        var a = U(e);
        ke(t.props.date, a) && le(t.props.date, a) || t.props.onChange(a);
      }, t.toggleDropdown = function () {
        return t.setState({
          dropdownVisible: !t.state.dropdownVisible
        });
      }, t;
    }
    return r.prototype.render = function () {
      var t;
      switch (this.props.dropdownMode) {
        case "scroll":
          t = this.renderScrollMode();
          break;
        case "select":
          t = this.renderSelectMode();
          break;
      }
      return /*#__PURE__*/m.createElement("div", {
        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
      }, t);
    }, r;
  }(oe),
  Iu = /** @class */
  function (n) {
    ie(r, n);
    function r() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.state = {
        height: null
      }, t.scrollToTheSelectedTime = function () {
        requestAnimationFrame(function () {
          var e, a, o;
          t.list && (t.list.scrollTop = (o = t.centerLi && r.calcCenterPosition(t.props.monthRef ? t.props.monthRef.clientHeight - ((a = (e = t.header) === null || e === void 0 ? void 0 : e.clientHeight) !== null && a !== void 0 ? a : 0) : t.list.clientHeight, t.centerLi)) !== null && o !== void 0 ? o : 0);
        });
      }, t.handleClick = function (e) {
        var a, o;
        (t.props.minTime || t.props.maxTime) && $r(e, t.props) || (t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && Ir(e, t.props) || (o = (a = t.props).onChange) === null || o === void 0 || o.call(a, e);
      }, t.isSelectedTime = function (e) {
        return t.props.selected && Mu(t.props.selected, e);
      }, t.isDisabledTime = function (e) {
        return (t.props.minTime || t.props.maxTime) && $r(e, t.props) || (t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && Ir(e, t.props);
      }, t.liClasses = function (e) {
        var a,
          o = ["react-datepicker__time-list-item", t.props.timeClassName ? t.props.timeClassName(e) : void 0];
        return t.isSelectedTime(e) && o.push("react-datepicker__time-list-item--selected"), t.isDisabledTime(e) && o.push("react-datepicker__time-list-item--disabled"), t.props.injectTimes && (Ce(e) * 3600 + Se(e) * 60 + Ye(e)) % (((a = t.props.intervals) !== null && a !== void 0 ? a : r.defaultProps.intervals) * 60) !== 0 && o.push("react-datepicker__time-list-item--injected"), o.join(" ");
      }, t.handleOnKeyDown = function (e, a) {
        var o, i;
        e.key === k.Space && (e.preventDefault(), e.key = k.Enter), (e.key === k.ArrowUp || e.key === k.ArrowLeft) && e.target instanceof HTMLElement && e.target.previousSibling && (e.preventDefault(), e.target.previousSibling instanceof HTMLElement && e.target.previousSibling.focus()), (e.key === k.ArrowDown || e.key === k.ArrowRight) && e.target instanceof HTMLElement && e.target.nextSibling && (e.preventDefault(), e.target.nextSibling instanceof HTMLElement && e.target.nextSibling.focus()), e.key === k.Enter && t.handleClick(a), (i = (o = t.props).handleOnKeyDown) === null || i === void 0 || i.call(o, e);
      }, t.renderTimes = function () {
        for (var e, a = [], o = typeof t.props.format == "string" ? t.props.format : "p", i = (e = t.props.intervals) !== null && e !== void 0 ? e : r.defaultProps.intervals, s = t.props.selected || t.props.openToDate || U(), c = Xt(s), l = t.props.injectTimes && t.props.injectTimes.sort(function (v, w) {
            return v.getTime() - w.getTime();
          }), u = 60 * _u(s), d = u / i, f = 0; f < d; f++) {
          var p = Wn(c, f * i);
          if (a.push(p), l) {
            var h = xu(c, p, f, i, l);
            a = a.concat(h);
          }
        }
        var g = a.reduce(function (v, w) {
          return w.getTime() <= s.getTime() ? w : v;
        }, a[0]);
        return a.map(function (v) {
          return /*#__PURE__*/m.createElement("li", {
            key: v.valueOf(),
            onClick: t.handleClick.bind(t, v),
            className: t.liClasses(v),
            ref: function ref(w) {
              v === g && (t.centerLi = w);
            },
            onKeyDown: function onKeyDown(w) {
              t.handleOnKeyDown(w, v);
            },
            tabIndex: v === g ? 0 : -1,
            role: "option",
            "aria-selected": t.isSelectedTime(v) ? "true" : void 0,
            "aria-disabled": t.isDisabledTime(v) ? "true" : void 0
          }, G(v, o, t.props.locale));
        });
      }, t.renderTimeCaption = function () {
        return t.props.showTimeCaption === !1 ? /*#__PURE__*/m.createElement(m.Fragment, null) : /*#__PURE__*/m.createElement("div", {
          className: "react-datepicker__header react-datepicker__header--time ".concat(t.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
          ref: function ref(e) {
            t.header = e;
          }
        }, /*#__PURE__*/m.createElement("div", {
          className: "react-datepicker-time__header"
        }, t.props.timeCaption));
      }, t;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function get() {
        return {
          intervals: 30,
          todayButton: null,
          timeCaption: "Time",
          showTimeCaption: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.componentDidMount = function () {
      this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({
        height: this.props.monthRef.clientHeight - this.header.clientHeight
      });
    }, r.prototype.render = function () {
      var t = this,
        e,
        a = this.state.height;
      return /*#__PURE__*/m.createElement("div", {
        className: "react-datepicker__time-container ".concat(((e = this.props.todayButton) !== null && e !== void 0 ? e : r.defaultProps.todayButton) ? "react-datepicker__time-container--with-today-button" : "")
      }, this.renderTimeCaption(), /*#__PURE__*/m.createElement("div", {
        className: "react-datepicker__time"
      }, /*#__PURE__*/m.createElement("div", {
        className: "react-datepicker__time-box"
      }, /*#__PURE__*/m.createElement("ul", {
        className: "react-datepicker__time-list",
        ref: function ref(o) {
          t.list = o;
        },
        style: a ? {
          height: a
        } : {},
        role: "listbox",
        "aria-label": this.props.timeCaption
      }, this.renderTimes()))));
    }, r.calcCenterPosition = function (t, e) {
      return e.offsetTop - (t / 2 - e.clientHeight / 2);
    }, r;
  }(oe),
  Ur = 3,
  $u = /** @class */
  function (n) {
    ie(r, n);
    function r(t) {
      var e = n.call(this, t) || this;
      return e.YEAR_REFS = Me([], Array(e.props.yearItemNumber), !0).map(function () {
        return /*#__PURE__*/Be();
      }), e.isDisabled = function (a) {
        return me(a, {
          minDate: e.props.minDate,
          maxDate: e.props.maxDate,
          excludeDates: e.props.excludeDates,
          includeDates: e.props.includeDates,
          filterDate: e.props.filterDate
        });
      }, e.isExcluded = function (a) {
        return or(a, {
          excludeDates: e.props.excludeDates
        });
      }, e.selectingDate = function () {
        var a;
        return (a = e.props.selectingDate) !== null && a !== void 0 ? a : e.props.preSelection;
      }, e.updateFocusOnPaginate = function (a) {
        var o = function o() {
          var i, s;
          (s = (i = e.YEAR_REFS[a]) === null || i === void 0 ? void 0 : i.current) === null || s === void 0 || s.focus();
        };
        window.requestAnimationFrame(o);
      }, e.handleYearClick = function (a, o) {
        e.props.onDayClick && e.props.onDayClick(a, o);
      }, e.handleYearNavigation = function (a, o) {
        var i,
          s,
          c,
          l,
          u = e.props,
          d = u.date,
          f = u.yearItemNumber;
        if (!(d === void 0 || f === void 0)) {
          var p = Ae(d, f).startPeriod;
          e.isDisabled(o) || e.isExcluded(o) || ((s = (i = e.props).setPreSelection) === null || s === void 0 || s.call(i, o), a - p < 0 ? e.updateFocusOnPaginate(f - (p - a)) : a - p >= f ? e.updateFocusOnPaginate(Math.abs(f - (a - p))) : (l = (c = e.YEAR_REFS[a - p]) === null || c === void 0 ? void 0 : c.current) === null || l === void 0 || l.focus());
        }
      }, e.isSameDay = function (a, o) {
        return Q(a, o);
      }, e.isCurrentYear = function (a) {
        return a === F(U());
      }, e.isRangeStart = function (a) {
        return e.props.startDate && e.props.endDate && ke(De(U(), a), e.props.startDate);
      }, e.isRangeEnd = function (a) {
        return e.props.startDate && e.props.endDate && ke(De(U(), a), e.props.endDate);
      }, e.isInRange = function (a) {
        return Bt(a, e.props.startDate, e.props.endDate);
      }, e.isInSelectingRange = function (a) {
        var o = e.props,
          i = o.selectsStart,
          s = o.selectsEnd,
          c = o.selectsRange,
          l = o.startDate,
          u = o.endDate;
        return !(i || s || c) || !e.selectingDate() ? !1 : i && u ? Bt(a, e.selectingDate(), u) : s && l || c && l && !u ? Bt(a, l, e.selectingDate()) : !1;
      }, e.isSelectingRangeStart = function (a) {
        var o;
        if (!e.isInSelectingRange(a)) return !1;
        var i = e.props,
          s = i.startDate,
          c = i.selectsStart,
          l = De(U(), a);
        return c ? ke(l, (o = e.selectingDate()) !== null && o !== void 0 ? o : null) : ke(l, s !== null && s !== void 0 ? s : null);
      }, e.isSelectingRangeEnd = function (a) {
        var o;
        if (!e.isInSelectingRange(a)) return !1;
        var i = e.props,
          s = i.endDate,
          c = i.selectsEnd,
          l = i.selectsRange,
          u = De(U(), a);
        return c || l ? ke(u, (o = e.selectingDate()) !== null && o !== void 0 ? o : null) : ke(u, s !== null && s !== void 0 ? s : null);
      }, e.isKeyboardSelected = function (a) {
        if (!(e.props.date === void 0 || e.props.selected == null || e.props.preSelection == null)) {
          var o = e.props,
            i = o.minDate,
            s = o.maxDate,
            c = o.excludeDates,
            l = o.includeDates,
            u = o.filterDate,
            d = St(De(e.props.date, a)),
            f = (i || s || c || l || u) && Gt(a, e.props);
          return !e.props.disabledKeyboardNavigation && !e.props.inline && !Q(d, St(e.props.selected)) && Q(d, St(e.props.preSelection)) && !f;
        }
      }, e.onYearClick = function (a, o) {
        var i = e.props.date;
        i !== void 0 && e.handleYearClick(St(De(i, o)), a);
      }, e.onYearKeyDown = function (a, o) {
        var i,
          s,
          c = a.key,
          l = e.props,
          u = l.date,
          d = l.yearItemNumber,
          f = l.handleOnKeyDown;
        if (c !== k.Tab && a.preventDefault(), !e.props.disabledKeyboardNavigation) switch (c) {
          case k.Enter:
            if (e.props.selected == null) break;
            e.onYearClick(a, o), (s = (i = e.props).setPreSelection) === null || s === void 0 || s.call(i, e.props.selected);
            break;
          case k.ArrowRight:
            if (e.props.preSelection == null) break;
            e.handleYearNavigation(o + 1, Te(e.props.preSelection, 1));
            break;
          case k.ArrowLeft:
            if (e.props.preSelection == null) break;
            e.handleYearNavigation(o - 1, mt(e.props.preSelection, 1));
            break;
          case k.ArrowUp:
            {
              if (u === void 0 || d === void 0 || e.props.preSelection == null) break;
              var p = Ae(u, d).startPeriod,
                h = Ur,
                g = o - h;
              if (g < p) {
                var v = d % h;
                o >= p && o < p + v ? h = v : h += v, g = o - h;
              }
              e.handleYearNavigation(g, mt(e.props.preSelection, h));
              break;
            }
          case k.ArrowDown:
            {
              if (u === void 0 || d === void 0 || e.props.preSelection == null) break;
              var w = Ae(u, d).endPeriod,
                h = Ur,
                g = o + h;
              if (g > w) {
                var v = d % h;
                o <= w && o > w - v ? h = v : h += v, g = o + h;
              }
              e.handleYearNavigation(g, Te(e.props.preSelection, h));
              break;
            }
        }
        f && f(a);
      }, e.getYearClassNames = function (a) {
        var o = e.props,
          i = o.date,
          s = o.minDate,
          c = o.maxDate,
          l = o.selected,
          u = o.excludeDates,
          d = o.includeDates,
          f = o.filterDate,
          p = o.yearClassName;
        return se("react-datepicker__year-text", "react-datepicker__year-".concat(a), i ? p == null ? void 0 : p(De(i, a)) : void 0, {
          "react-datepicker__year-text--selected": l ? a === F(l) : void 0,
          "react-datepicker__year-text--disabled": (s || c || u || d || f) && Gt(a, e.props),
          "react-datepicker__year-text--keyboard-selected": e.isKeyboardSelected(a),
          "react-datepicker__year-text--range-start": e.isRangeStart(a),
          "react-datepicker__year-text--range-end": e.isRangeEnd(a),
          "react-datepicker__year-text--in-range": e.isInRange(a),
          "react-datepicker__year-text--in-selecting-range": e.isInSelectingRange(a),
          "react-datepicker__year-text--selecting-range-start": e.isSelectingRangeStart(a),
          "react-datepicker__year-text--selecting-range-end": e.isSelectingRangeEnd(a),
          "react-datepicker__year-text--today": e.isCurrentYear(a)
        });
      }, e.getYearTabIndex = function (a) {
        if (e.props.disabledKeyboardNavigation || e.props.preSelection == null) return "-1";
        var o = F(e.props.preSelection),
          i = Gt(a, e.props);
        return a === o && !i ? "0" : "-1";
      }, e.getYearContent = function (a) {
        return e.props.renderYearContent ? e.props.renderYearContent(a) : a;
      }, e;
    }
    return r.prototype.render = function () {
      var t = this,
        e = [],
        a = this.props,
        o = a.date,
        i = a.yearItemNumber,
        s = a.onYearMouseEnter,
        c = a.onYearMouseLeave;
      if (o === void 0) return null;
      for (var l = Ae(o, i), u = l.startPeriod, d = l.endPeriod, f = function f(g) {
          e.push( /*#__PURE__*/m.createElement("div", {
            ref: p.YEAR_REFS[g - u],
            onClick: function onClick(v) {
              t.onYearClick(v, g);
            },
            onKeyDown: function onKeyDown(v) {
              Ga(v) && (v.preventDefault(), v.key = k.Enter), t.onYearKeyDown(v, g);
            },
            tabIndex: Number(p.getYearTabIndex(g)),
            className: p.getYearClassNames(g),
            onMouseEnter: p.props.usePointerEvent ? void 0 : function (v) {
              return s(v, g);
            },
            onPointerEnter: p.props.usePointerEvent ? function (v) {
              return s(v, g);
            } : void 0,
            onMouseLeave: p.props.usePointerEvent ? void 0 : function (v) {
              return c(v, g);
            },
            onPointerLeave: p.props.usePointerEvent ? function (v) {
              return c(v, g);
            } : void 0,
            key: g,
            "aria-current": p.isCurrentYear(g) ? "date" : void 0
          }, p.getYearContent(g)));
        }, p = this, h = u; h <= d; h++) {
        f(h);
      }
      return /*#__PURE__*/m.createElement("div", {
        className: "react-datepicker__year"
      }, /*#__PURE__*/m.createElement("div", {
        className: "react-datepicker__year-wrapper",
        onMouseLeave: this.props.usePointerEvent ? void 0 : this.props.clearSelectingDate,
        onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : void 0
      }, e));
    }, r;
  }(oe);
function Wu(n, r, t, e) {
  for (var a = [], o = 0; o < 2 * r + 1; o++) {
    var i = n + r - o,
      s = !0;
    t && (s = F(t) <= i), e && s && (s = F(e) >= i), s && a.push(i);
  }
  return a;
}
var Au = /** @class */
  function (n) {
    ie(r, n);
    function r(t) {
      var e = n.call(this, t) || this;
      e.renderOptions = function () {
        var s = e.props.year,
          c = e.state.yearsList.map(function (d) {
            return /*#__PURE__*/m.createElement("div", {
              className: s === d ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
              key: d,
              onClick: e.onChange.bind(e, d),
              "aria-selected": s === d ? "true" : void 0
            }, s === d ? /*#__PURE__*/m.createElement("span", {
              className: "react-datepicker__year-option--selected"
            }, "✓") : "", d);
          }),
          l = e.props.minDate ? F(e.props.minDate) : null,
          u = e.props.maxDate ? F(e.props.maxDate) : null;
        return (!u || !e.state.yearsList.find(function (d) {
          return d === u;
        })) && c.unshift( /*#__PURE__*/m.createElement("div", {
          className: "react-datepicker__year-option",
          key: "upcoming",
          onClick: e.incrementYears
        }, /*#__PURE__*/m.createElement("a", {
          className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
        }))), (!l || !e.state.yearsList.find(function (d) {
          return d === l;
        })) && c.push( /*#__PURE__*/m.createElement("div", {
          className: "react-datepicker__year-option",
          key: "previous",
          onClick: e.decrementYears
        }, /*#__PURE__*/m.createElement("a", {
          className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
        }))), c;
      }, e.onChange = function (s) {
        e.props.onChange(s);
      }, e.handleClickOutside = function () {
        e.props.onCancel();
      }, e.shiftYears = function (s) {
        var c = e.state.yearsList.map(function (l) {
          return l + s;
        });
        e.setState({
          yearsList: c
        });
      }, e.incrementYears = function () {
        return e.shiftYears(1);
      }, e.decrementYears = function () {
        return e.shiftYears(-1);
      };
      var a = t.yearDropdownItemNumber,
        o = t.scrollableYearDropdown,
        i = a || (o ? 10 : 5);
      return e.state = {
        yearsList: Wu(e.props.year, i, e.props.minDate, e.props.maxDate)
      }, e.dropdownRef = /*#__PURE__*/Be(), e;
    }
    return r.prototype.componentDidMount = function () {
      var t = this.dropdownRef.current;
      if (t) {
        var e = t.children ? Array.from(t.children) : null,
          a = e ? e.find(function (o) {
            return o.ariaSelected;
          }) : null;
        t.scrollTop = a && a instanceof HTMLElement ? a.offsetTop + (a.clientHeight - t.clientHeight) / 2 : (t.scrollHeight - t.clientHeight) / 2;
      }
    }, r.prototype.render = function () {
      var t = se({
        "react-datepicker__year-dropdown": !0,
        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
      });
      return /*#__PURE__*/m.createElement(xn, {
        className: t,
        containerRef: this.dropdownRef,
        onClickOutside: this.handleClickOutside
      }, this.renderOptions());
    }, r;
  }(oe),
  Hu = /** @class */
  function (n) {
    ie(r, n);
    function r() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.state = {
        dropdownVisible: !1
      }, t.renderSelectOptions = function () {
        for (var e = t.props.minDate ? F(t.props.minDate) : 1900, a = t.props.maxDate ? F(t.props.maxDate) : 2100, o = [], i = e; i <= a; i++) {
          o.push( /*#__PURE__*/m.createElement("option", {
            key: i,
            value: i
          }, i));
        }
        return o;
      }, t.onSelectChange = function (e) {
        t.onChange(parseInt(e.target.value));
      }, t.renderSelectMode = function () {
        return /*#__PURE__*/m.createElement("select", {
          value: t.props.year,
          className: "react-datepicker__year-select",
          onChange: t.onSelectChange
        }, t.renderSelectOptions());
      }, t.renderReadView = function (e) {
        return /*#__PURE__*/m.createElement("div", {
          key: "read",
          style: {
            visibility: e ? "visible" : "hidden"
          },
          className: "react-datepicker__year-read-view",
          onClick: function onClick(a) {
            return t.toggleDropdown(a);
          }
        }, /*#__PURE__*/m.createElement("span", {
          className: "react-datepicker__year-read-view--down-arrow"
        }), /*#__PURE__*/m.createElement("span", {
          className: "react-datepicker__year-read-view--selected-year"
        }, t.props.year));
      }, t.renderDropdown = function () {
        return /*#__PURE__*/m.createElement(Au, _V({
          key: "dropdown"
        }, t.props, {
          onChange: t.onChange,
          onCancel: t.toggleDropdown
        }));
      }, t.renderScrollMode = function () {
        var e = t.state.dropdownVisible,
          a = [t.renderReadView(!e)];
        return e && a.unshift(t.renderDropdown()), a;
      }, t.onChange = function (e) {
        t.toggleDropdown(), e !== t.props.year && t.props.onChange(e);
      }, t.toggleDropdown = function (e) {
        t.setState({
          dropdownVisible: !t.state.dropdownVisible
        }, function () {
          t.props.adjustDateOnChange && t.handleYearChange(t.props.date, e);
        });
      }, t.handleYearChange = function (e, a) {
        var o;
        (o = t.onSelect) === null || o === void 0 || o.call(t, e, a), t.setOpen();
      }, t.onSelect = function (e, a) {
        var o, i;
        (i = (o = t.props).onSelect) === null || i === void 0 || i.call(o, e, a);
      }, t.setOpen = function () {
        var e, a;
        (a = (e = t.props).setOpen) === null || a === void 0 || a.call(e, !0);
      }, t;
    }
    return r.prototype.render = function () {
      var t;
      switch (this.props.dropdownMode) {
        case "scroll":
          t = this.renderScrollMode();
          break;
        case "select":
          t = this.renderSelectMode();
          break;
      }
      return /*#__PURE__*/m.createElement("div", {
        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
      }, t);
    }, r;
  }(oe),
  Bu = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"],
  Qu = function Qu(n) {
    var r = (n.className || "").split(/\s+/);
    return Bu.some(function (t) {
      return r.indexOf(t) >= 0;
    });
  },
  Vu = /** @class */
  function (n) {
    ie(r, n);
    function r(t) {
      var e = n.call(this, t) || this;
      return e.monthContainer = void 0, e.handleClickOutside = function (a) {
        e.props.onClickOutside(a);
      }, e.setClickOutsideRef = function () {
        return e.containerRef.current;
      }, e.handleDropdownFocus = function (a) {
        var o, i;
        Qu(a.target) && ((i = (o = e.props).onDropdownFocus) === null || i === void 0 || i.call(o, a));
      }, e.getDateInView = function () {
        var a = e.props,
          o = a.preSelection,
          i = a.selected,
          s = a.openToDate,
          c = Ua(e.props),
          l = Xa(e.props),
          u = U(),
          d = s || i || o;
        return d || (c && nt(u, c) ? c : l && Ve(u, l) ? l : u);
      }, e.increaseMonth = function () {
        e.setState(function (a) {
          var o = a.date;
          return {
            date: be(o, 1)
          };
        }, function () {
          return e.handleMonthChange(e.state.date);
        });
      }, e.decreaseMonth = function () {
        e.setState(function (a) {
          var o = a.date;
          return {
            date: Ze(o, 1)
          };
        }, function () {
          return e.handleMonthChange(e.state.date);
        });
      }, e.handleDayClick = function (a, o, i) {
        e.props.onSelect(a, o, i), e.props.setPreSelection && e.props.setPreSelection(a);
      }, e.handleDayMouseEnter = function (a) {
        e.setState({
          selectingDate: a
        }), e.props.onDayMouseEnter && e.props.onDayMouseEnter(a);
      }, e.handleMonthMouseLeave = function () {
        e.setState({
          selectingDate: void 0
        }), e.props.onMonthMouseLeave && e.props.onMonthMouseLeave();
      }, e.handleYearMouseEnter = function (a, o) {
        e.setState({
          selectingDate: De(U(), o)
        }), e.props.onYearMouseEnter && e.props.onYearMouseEnter(a, o);
      }, e.handleYearMouseLeave = function (a, o) {
        e.props.onYearMouseLeave && e.props.onYearMouseLeave(a, o);
      }, e.handleYearChange = function (a) {
        var o, i, s, c;
        (i = (o = e.props).onYearChange) === null || i === void 0 || i.call(o, a), e.setState({
          isRenderAriaLiveMessage: !0
        }), e.props.adjustDateOnChange && (e.props.onSelect(a), (c = (s = e.props).setOpen) === null || c === void 0 || c.call(s, !0)), e.props.setPreSelection && e.props.setPreSelection(a);
      }, e.getEnabledPreSelectionDateForMonth = function (a) {
        if (!me(a, e.props)) return a;
        for (var o = Re(a), i = du(a), s = Hi(i, o), c = null, l = 0; l <= s; l++) {
          var u = we(o, l);
          if (!me(u, e.props)) {
            c = u;
            break;
          }
        }
        return c;
      }, e.handleMonthChange = function (a) {
        var o,
          i,
          s,
          c = (o = e.getEnabledPreSelectionDateForMonth(a)) !== null && o !== void 0 ? o : a;
        e.handleCustomMonthChange(c), e.props.adjustDateOnChange && (e.props.onSelect(c), (s = (i = e.props).setOpen) === null || s === void 0 || s.call(i, !0)), e.props.setPreSelection && e.props.setPreSelection(c);
      }, e.handleCustomMonthChange = function (a) {
        var o, i;
        (i = (o = e.props).onMonthChange) === null || i === void 0 || i.call(o, a), e.setState({
          isRenderAriaLiveMessage: !0
        });
      }, e.handleMonthYearChange = function (a) {
        e.handleYearChange(a), e.handleMonthChange(a);
      }, e.changeYear = function (a) {
        e.setState(function (o) {
          var i = o.date;
          return {
            date: De(i, Number(a))
          };
        }, function () {
          return e.handleYearChange(e.state.date);
        });
      }, e.changeMonth = function (a) {
        e.setState(function (o) {
          var i = o.date;
          return {
            date: de(i, Number(a))
          };
        }, function () {
          return e.handleMonthChange(e.state.date);
        });
      }, e.changeMonthYear = function (a) {
        e.setState(function (o) {
          var i = o.date;
          return {
            date: De(de(i, ue(a)), F(a))
          };
        }, function () {
          return e.handleMonthYearChange(e.state.date);
        });
      }, e.header = function (a) {
        a === void 0 && (a = e.state.date);
        var o = He(a, e.props.locale, e.props.calendarStartDay),
          i = [];
        return e.props.showWeekNumbers && i.push( /*#__PURE__*/m.createElement("div", {
          key: "W",
          className: "react-datepicker__day-name"
        }, e.props.weekLabel || "#")), i.concat([0, 1, 2, 3, 4, 5, 6].map(function (s) {
          var c = we(o, s),
            l = e.formatWeekday(c, e.props.locale),
            u = e.props.weekDayClassName ? e.props.weekDayClassName(c) : void 0;
          return /*#__PURE__*/m.createElement("div", {
            key: s,
            "aria-label": G(c, "EEEE", e.props.locale),
            className: se("react-datepicker__day-name", u)
          }, l);
        }));
      }, e.formatWeekday = function (a, o) {
        return e.props.formatWeekDay ? fu(a, e.props.formatWeekDay, o) : e.props.useWeekdaysShort ? hu(a, o) : pu(a, o);
      }, e.decreaseYear = function () {
        e.setState(function (a) {
          var o,
            i = a.date;
          return {
            date: mt(i, e.props.showYearPicker ? (o = e.props.yearItemNumber) !== null && o !== void 0 ? o : r.defaultProps.yearItemNumber : 1)
          };
        }, function () {
          return e.handleYearChange(e.state.date);
        });
      }, e.clearSelectingDate = function () {
        e.setState({
          selectingDate: void 0
        });
      }, e.renderPreviousButton = function () {
        var a, o, i;
        if (!e.props.renderCustomHeader) {
          var s = (a = e.props.monthsShown) !== null && a !== void 0 ? a : r.defaultProps.monthsShown,
            c = e.props.showPreviousMonths ? s - 1 : 0,
            l = (o = e.props.monthSelectedIn) !== null && o !== void 0 ? o : c,
            u = Ze(e.state.date, l),
            d;
          switch (!0) {
            case e.props.showMonthYearPicker:
              d = Hr(e.state.date, e.props);
              break;
            case e.props.showYearPicker:
              d = bu(e.state.date, e.props);
              break;
            case e.props.showQuarterYearPicker:
              d = vu(e.state.date, e.props);
              break;
            default:
              d = Wr(u, e.props);
              break;
          }
          if (!(!((i = e.props.forceShowMonthNavigation) !== null && i !== void 0 ? i : r.defaultProps.forceShowMonthNavigation) && !e.props.showDisabledMonthNavigation && d || e.props.showTimeSelectOnly)) {
            var f = ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--previous"],
              p = ["react-datepicker__navigation", "react-datepicker__navigation--previous"],
              h = e.decreaseMonth;
            (e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker) && (h = e.decreaseYear), d && e.props.showDisabledMonthNavigation && (p.push("react-datepicker__navigation--previous--disabled"), h = void 0);
            var g = e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker,
              v = e.props,
              w = v.previousMonthButtonLabel,
              D = w === void 0 ? r.defaultProps.previousMonthButtonLabel : w,
              b = v.previousYearButtonLabel,
              P = b === void 0 ? r.defaultProps.previousYearButtonLabel : b,
              S = e.props,
              T = S.previousMonthAriaLabel,
              y = T === void 0 ? typeof D == "string" ? D : "Previous Month" : T,
              x = S.previousYearAriaLabel,
              E = x === void 0 ? typeof P == "string" ? P : "Previous Year" : x;
            return /*#__PURE__*/m.createElement("button", {
              type: "button",
              className: p.join(" "),
              onClick: h,
              onKeyDown: e.props.handleOnKeyDown,
              "aria-label": g ? E : y
            }, /*#__PURE__*/m.createElement("span", {
              className: f.join(" ")
            }, g ? P : D));
          }
        }
      }, e.increaseYear = function () {
        e.setState(function (a) {
          var o,
            i = a.date;
          return {
            date: Te(i, e.props.showYearPicker ? (o = e.props.yearItemNumber) !== null && o !== void 0 ? o : r.defaultProps.yearItemNumber : 1)
          };
        }, function () {
          return e.handleYearChange(e.state.date);
        });
      }, e.renderNextButton = function () {
        var a;
        if (!e.props.renderCustomHeader) {
          var o;
          switch (!0) {
            case e.props.showMonthYearPicker:
              o = Br(e.state.date, e.props);
              break;
            case e.props.showYearPicker:
              o = yu(e.state.date, e.props);
              break;
            case e.props.showQuarterYearPicker:
              o = wu(e.state.date, e.props);
              break;
            default:
              o = Ar(e.state.date, e.props);
              break;
          }
          if (!(!((a = e.props.forceShowMonthNavigation) !== null && a !== void 0 ? a : r.defaultProps.forceShowMonthNavigation) && !e.props.showDisabledMonthNavigation && o || e.props.showTimeSelectOnly)) {
            var i = ["react-datepicker__navigation", "react-datepicker__navigation--next"],
              s = ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--next"];
            e.props.showTimeSelect && i.push("react-datepicker__navigation--next--with-time"), e.props.todayButton && i.push("react-datepicker__navigation--next--with-today-button");
            var c = e.increaseMonth;
            (e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker) && (c = e.increaseYear), o && e.props.showDisabledMonthNavigation && (i.push("react-datepicker__navigation--next--disabled"), c = void 0);
            var l = e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker,
              u = e.props,
              d = u.nextMonthButtonLabel,
              f = d === void 0 ? r.defaultProps.nextMonthButtonLabel : d,
              p = u.nextYearButtonLabel,
              h = p === void 0 ? r.defaultProps.nextYearButtonLabel : p,
              g = e.props,
              v = g.nextMonthAriaLabel,
              w = v === void 0 ? typeof f == "string" ? f : "Next Month" : v,
              D = g.nextYearAriaLabel,
              b = D === void 0 ? typeof h == "string" ? h : "Next Year" : D;
            return /*#__PURE__*/m.createElement("button", {
              type: "button",
              className: i.join(" "),
              onClick: c,
              onKeyDown: e.props.handleOnKeyDown,
              "aria-label": l ? b : w
            }, /*#__PURE__*/m.createElement("span", {
              className: s.join(" ")
            }, l ? h : f));
          }
        }
      }, e.renderCurrentMonth = function (a) {
        a === void 0 && (a = e.state.date);
        var o = ["react-datepicker__current-month"];
        return e.props.showYearDropdown && o.push("react-datepicker__current-month--hasYearDropdown"), e.props.showMonthDropdown && o.push("react-datepicker__current-month--hasMonthDropdown"), e.props.showMonthYearDropdown && o.push("react-datepicker__current-month--hasMonthYearDropdown"), /*#__PURE__*/m.createElement("h2", {
          className: o.join(" ")
        }, G(a, e.props.dateFormat, e.props.locale));
      }, e.renderYearDropdown = function (a) {
        if (a === void 0 && (a = !1), !(!e.props.showYearDropdown || a)) return /*#__PURE__*/m.createElement(Hu, _V({}, r.defaultProps, e.props, {
          date: e.state.date,
          onChange: e.changeYear,
          year: F(e.state.date)
        }));
      }, e.renderMonthDropdown = function (a) {
        if (a === void 0 && (a = !1), !(!e.props.showMonthDropdown || a)) return /*#__PURE__*/m.createElement(Yu, _V({}, r.defaultProps, e.props, {
          month: ue(e.state.date),
          onChange: e.changeMonth
        }));
      }, e.renderMonthYearDropdown = function (a) {
        if (a === void 0 && (a = !1), !(!e.props.showMonthYearDropdown || a)) return /*#__PURE__*/m.createElement(Fu, _V({}, r.defaultProps, e.props, {
          date: e.state.date,
          onChange: e.changeMonthYear
        }));
      }, e.handleTodayButtonClick = function (a) {
        e.props.onSelect(Rr(), a), e.props.setPreSelection && e.props.setPreSelection(Rr());
      }, e.renderTodayButton = function () {
        if (!(!e.props.todayButton || e.props.showTimeSelectOnly)) return /*#__PURE__*/m.createElement("div", {
          className: "react-datepicker__today-button",
          onClick: e.handleTodayButtonClick
        }, e.props.todayButton);
      }, e.renderDefaultHeader = function (a) {
        var o = a.monthDate,
          i = a.i;
        return /*#__PURE__*/m.createElement("div", {
          className: "react-datepicker__header ".concat(e.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
        }, e.renderCurrentMonth(o), /*#__PURE__*/m.createElement("div", {
          className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(e.props.dropdownMode),
          onFocus: e.handleDropdownFocus
        }, e.renderMonthDropdown(i !== 0), e.renderMonthYearDropdown(i !== 0), e.renderYearDropdown(i !== 0)), /*#__PURE__*/m.createElement("div", {
          className: "react-datepicker__day-names"
        }, e.header(o)));
      }, e.renderCustomHeader = function (a) {
        var o,
          i,
          s = a.monthDate,
          c = a.i;
        if (e.props.showTimeSelect && !e.state.monthContainer || e.props.showTimeSelectOnly) return null;
        var l = Wr(e.state.date, e.props),
          u = Ar(e.state.date, e.props),
          d = Hr(e.state.date, e.props),
          f = Br(e.state.date, e.props),
          p = !e.props.showMonthYearPicker && !e.props.showQuarterYearPicker && !e.props.showYearPicker;
        return /*#__PURE__*/m.createElement("div", {
          className: "react-datepicker__header react-datepicker__header--custom",
          onFocus: e.props.onDropdownFocus
        }, (i = (o = e.props).renderCustomHeader) === null || i === void 0 ? void 0 : i.call(o, _V(_V({}, e.state), {
          customHeaderCount: c,
          monthDate: s,
          changeMonth: e.changeMonth,
          changeYear: e.changeYear,
          decreaseMonth: e.decreaseMonth,
          increaseMonth: e.increaseMonth,
          decreaseYear: e.decreaseYear,
          increaseYear: e.increaseYear,
          prevMonthButtonDisabled: l,
          nextMonthButtonDisabled: u,
          prevYearButtonDisabled: d,
          nextYearButtonDisabled: f
        })), p && /*#__PURE__*/m.createElement("div", {
          className: "react-datepicker__day-names"
        }, e.header(s)));
      }, e.renderYearHeader = function (a) {
        var o = a.monthDate,
          i = e.props,
          s = i.showYearPicker,
          c = i.yearItemNumber,
          l = c === void 0 ? r.defaultProps.yearItemNumber : c,
          u = Ae(o, l),
          d = u.startPeriod,
          f = u.endPeriod;
        return /*#__PURE__*/m.createElement("div", {
          className: "react-datepicker__header react-datepicker-year-header"
        }, s ? "".concat(d, " - ").concat(f) : F(o));
      }, e.renderHeader = function (a) {
        var o = a.monthDate,
          i = a.i,
          s = i === void 0 ? 0 : i,
          c = {
            monthDate: o,
            i: s
          };
        switch (!0) {
          case e.props.renderCustomHeader !== void 0:
            return e.renderCustomHeader(c);
          case e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker:
            return e.renderYearHeader(c);
          default:
            return e.renderDefaultHeader(c);
        }
      }, e.renderMonths = function () {
        var a, o;
        if (!(e.props.showTimeSelectOnly || e.props.showYearPicker)) {
          for (var i = [], s = (a = e.props.monthsShown) !== null && a !== void 0 ? a : r.defaultProps.monthsShown, c = e.props.showPreviousMonths ? s - 1 : 0, l = e.props.showMonthYearPicker || e.props.showQuarterYearPicker ? Te(e.state.date, c) : Ze(e.state.date, c), u = (o = e.props.monthSelectedIn) !== null && o !== void 0 ? o : c, d = 0; d < s; ++d) {
            var f = d - u + c,
              p = e.props.showMonthYearPicker || e.props.showQuarterYearPicker ? Te(l, f) : be(l, f),
              h = "month-".concat(d),
              g = d < s - 1,
              v = d > 0;
            i.push( /*#__PURE__*/m.createElement("div", {
              key: h,
              ref: function ref(w) {
                e.monthContainer = w !== null && w !== void 0 ? w : void 0;
              },
              className: "react-datepicker__month-container"
            }, e.renderHeader({
              monthDate: p,
              i: d
            }), /*#__PURE__*/m.createElement(Tu, _V({}, r.defaultProps, e.props, {
              ariaLabelPrefix: e.props.monthAriaLabelPrefix,
              day: p,
              onDayClick: e.handleDayClick,
              handleOnKeyDown: e.props.handleOnDayKeyDown,
              handleOnMonthKeyDown: e.props.handleOnKeyDown,
              onDayMouseEnter: e.handleDayMouseEnter,
              onMouseLeave: e.handleMonthMouseLeave,
              orderInDisplay: d,
              selectingDate: e.state.selectingDate,
              monthShowsDuplicateDaysEnd: g,
              monthShowsDuplicateDaysStart: v
            }))));
          }
          return i;
        }
      }, e.renderYears = function () {
        if (!e.props.showTimeSelectOnly && e.props.showYearPicker) return /*#__PURE__*/m.createElement("div", {
          className: "react-datepicker__year--container"
        }, e.renderHeader({
          monthDate: e.state.date
        }), /*#__PURE__*/m.createElement($u, _V({}, r.defaultProps, e.props, {
          selectingDate: e.state.selectingDate,
          date: e.state.date,
          onDayClick: e.handleDayClick,
          clearSelectingDate: e.clearSelectingDate,
          onYearMouseEnter: e.handleYearMouseEnter,
          onYearMouseLeave: e.handleYearMouseLeave
        })));
      }, e.renderTimeSection = function () {
        if (e.props.showTimeSelect && (e.state.monthContainer || e.props.showTimeSelectOnly)) return /*#__PURE__*/m.createElement(Iu, _V({}, r.defaultProps, e.props, {
          onChange: e.props.onTimeChange,
          format: e.props.timeFormat,
          intervals: e.props.timeIntervals,
          monthRef: e.state.monthContainer
        }));
      }, e.renderInputTimeSection = function () {
        var a = e.props.selected ? new Date(e.props.selected) : void 0,
          o = a && Oe(a) && !!e.props.selected,
          i = o ? "".concat(Vr(a.getHours()), ":").concat(Vr(a.getMinutes())) : "";
        if (e.props.showTimeInput) return /*#__PURE__*/m.createElement(Cu, _V({}, r.defaultProps, e.props, {
          date: a,
          timeString: i,
          onChange: e.props.onTimeChange
        }));
      }, e.renderAriaLiveRegion = function () {
        var a,
          o = Ae(e.state.date, (a = e.props.yearItemNumber) !== null && a !== void 0 ? a : r.defaultProps.yearItemNumber),
          i = o.startPeriod,
          s = o.endPeriod,
          c;
        return e.props.showYearPicker ? c = "".concat(i, " - ").concat(s) : e.props.showMonthYearPicker || e.props.showQuarterYearPicker ? c = F(e.state.date) : c = "".concat(ar(ue(e.state.date), e.props.locale), " ").concat(F(e.state.date)), /*#__PURE__*/m.createElement("span", {
          role: "alert",
          "aria-live": "polite",
          className: "react-datepicker__aria-live"
        }, e.state.isRenderAriaLiveMessage && c);
      }, e.renderChildren = function () {
        if (e.props.children) return /*#__PURE__*/m.createElement("div", {
          className: "react-datepicker__children-container"
        }, e.props.children);
      }, e.containerRef = /*#__PURE__*/Be(), e.state = {
        date: e.getDateInView(),
        selectingDate: void 0,
        monthContainer: void 0,
        isRenderAriaLiveMessage: !1
      }, e;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function get() {
        return {
          monthsShown: 1,
          forceShowMonthNavigation: !1,
          timeCaption: "Time",
          previousYearButtonLabel: "Previous Year",
          nextYearButtonLabel: "Next Year",
          previousMonthButtonLabel: "Previous Month",
          nextMonthButtonLabel: "Next Month",
          yearItemNumber: Ft
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.componentDidMount = function () {
      var t = this;
      this.props.showTimeSelect && (this.assignMonthContainer = function () {
        t.setState({
          monthContainer: t.monthContainer
        });
      }());
    }, r.prototype.componentDidUpdate = function (t) {
      var e = this;
      if (this.props.preSelection && (!Q(this.props.preSelection, t.preSelection) || this.props.monthSelectedIn !== t.monthSelectedIn)) {
        var a = !le(this.state.date, this.props.preSelection);
        this.setState({
          date: this.props.preSelection
        }, function () {
          return a && e.handleCustomMonthChange(e.state.date);
        });
      } else this.props.openToDate && !Q(this.props.openToDate, t.openToDate) && this.setState({
        date: this.props.openToDate
      });
    }, r.prototype.render = function () {
      var t = this.props.container || ru;
      return /*#__PURE__*/m.createElement(xn, {
        onClickOutside: this.handleClickOutside,
        style: {
          display: "contents"
        },
        containerRef: this.containerRef,
        ignoreClass: this.props.outsideClickIgnoreClass
      }, /*#__PURE__*/m.createElement(t, {
        className: se("react-datepicker", this.props.className, {
          "react-datepicker--time-only": this.props.showTimeSelectOnly
        }),
        showTime: this.props.showTimeSelect || this.props.showTimeInput,
        showTimeSelectOnly: this.props.showTimeSelectOnly
      }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
    }, r;
  }(oe),
  qu = function qu(n) {
    var r = n.icon,
      t = n.className,
      e = t === void 0 ? "" : t,
      a = n.onClick,
      o = "react-datepicker__calendar-icon";
    return typeof r == "string" ? /*#__PURE__*/m.createElement("i", {
      className: "".concat(o, " ").concat(r, " ").concat(e),
      "aria-hidden": "true",
      onClick: a
    }) : /*#__PURE__*/m.isValidElement(r) ? /*#__PURE__*/m.cloneElement(r, {
      className: "".concat(r.props.className || "", " ").concat(o, " ").concat(e),
      onClick: function onClick(i) {
        typeof r.props.onClick == "function" && r.props.onClick(i), typeof a == "function" && a(i);
      }
    }) : /*#__PURE__*/m.createElement("svg", {
      className: "".concat(o, " ").concat(e),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      onClick: a
    }, /*#__PURE__*/m.createElement("path", {
      d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
    }));
  },
  Za = /** @class */
  function (n) {
    ie(r, n);
    function r(t) {
      var e = n.call(this, t) || this;
      return e.portalRoot = null, e.el = document.createElement("div"), e;
    }
    return r.prototype.componentDidMount = function () {
      this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
    }, r.prototype.componentWillUnmount = function () {
      this.portalRoot && this.portalRoot.removeChild(this.el);
    }, r.prototype.render = function () {
      return /*#__PURE__*/So.createPortal(this.props.children, this.el);
    }, r;
  }(oe),
  Ku = "[tabindex], a, button, input, select, textarea",
  ju = function ju(n) {
    return (n instanceof HTMLAnchorElement || !n.disabled) && n.tabIndex !== -1;
  },
  Ja = /** @class */
  function (n) {
    ie(r, n);
    function r(t) {
      var e = n.call(this, t) || this;
      return e.getTabChildren = function () {
        var a;
        return Array.prototype.slice.call((a = e.tabLoopRef.current) === null || a === void 0 ? void 0 : a.querySelectorAll(Ku), 1, -1).filter(ju);
      }, e.handleFocusStart = function () {
        var a = e.getTabChildren();
        a && a.length > 1 && a[a.length - 1].focus();
      }, e.handleFocusEnd = function () {
        var a = e.getTabChildren();
        a && a.length > 1 && a[0].focus();
      }, e.tabLoopRef = /*#__PURE__*/Be(), e;
    }
    return r.prototype.render = function () {
      var t;
      return ((t = this.props.enableTabLoop) !== null && t !== void 0 ? t : r.defaultProps.enableTabLoop) ? /*#__PURE__*/m.createElement("div", {
        className: "react-datepicker__tab-loop",
        ref: this.tabLoopRef
      }, /*#__PURE__*/m.createElement("div", {
        className: "react-datepicker__tab-loop__start",
        tabIndex: 0,
        onFocus: this.handleFocusStart
      }), this.props.children, /*#__PURE__*/m.createElement("div", {
        className: "react-datepicker__tab-loop__end",
        tabIndex: 0,
        onFocus: this.handleFocusEnd
      })) : this.props.children;
    }, r.defaultProps = {
      enableTabLoop: !0
    }, r;
  }(oe);
function zu(n) {
  var r = function r(t) {
    var e,
      a = typeof t.hidePopper == "boolean" ? t.hidePopper : !0,
      o = Fn(null),
      i = nu(_V({
        open: !a,
        whileElementsMounted: Yl,
        placement: t.popperPlacement,
        middleware: Me([Wl({
          padding: 15
        }), $l(10), Al({
          element: o
        })], (e = t.popperModifiers) !== null && e !== void 0 ? e : [], !0)
      }, t.popperProps)),
      s = _V(_V({}, t), {
        hidePopper: a,
        popperProps: _V(_V({}, i), {
          arrowRef: o
        })
      });
    return /*#__PURE__*/m.createElement(n, _V({}, s));
  };
  return r;
}
var Uu = /** @class */
  function (n) {
    ie(r, n);
    function r() {
      return n !== null && n.apply(this, arguments) || this;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function get() {
        return {
          hidePopper: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.render = function () {
      var t = this.props,
        e = t.className,
        a = t.wrapperClassName,
        o = t.hidePopper,
        i = o === void 0 ? r.defaultProps.hidePopper : o,
        s = t.popperComponent,
        c = t.targetComponent,
        l = t.enableTabLoop,
        u = t.popperOnKeyDown,
        d = t.portalId,
        f = t.portalHost,
        p = t.popperProps,
        h = t.showArrow,
        g = void 0;
      if (!i) {
        var v = se("react-datepicker-popper", e);
        g = /*#__PURE__*/m.createElement(Ja, {
          enableTabLoop: l
        }, /*#__PURE__*/m.createElement("div", {
          ref: p.refs.setFloating,
          style: p.floatingStyles,
          className: v,
          "data-placement": p.placement,
          onKeyDown: u
        }, s, h && /*#__PURE__*/m.createElement(Ul, {
          ref: p.arrowRef,
          context: p.context,
          fill: "currentColor",
          strokeWidth: 1,
          height: 8,
          width: 16,
          style: {
            transform: "translateY(-1px)"
          },
          className: "react-datepicker__triangle"
        })));
      }
      this.props.popperContainer && (g = /*#__PURE__*/Mo(this.props.popperContainer, {}, g)), d && !i && (g = /*#__PURE__*/m.createElement(Za, {
        portalId: d,
        portalHost: f
      }, g));
      var w = se("react-datepicker-wrapper", a);
      return /*#__PURE__*/m.createElement(m.Fragment, null, /*#__PURE__*/m.createElement("div", {
        ref: p.refs.setReference,
        className: w
      }, c), g);
    }, r;
  }(oe),
  Xu = zu(Uu),
  Xr = "react-datepicker-ignore-onclickoutside";
function Gu(n, r) {
  return n && r ? ue(n) !== ue(r) || F(n) !== F(r) : n !== r;
}
var Rn = "Date input not valid.",
  Gr = /** @class */
  function (n) {
    ie(r, n);
    function r(t) {
      var e = n.call(this, t) || this;
      return e.calendar = null, e.input = null, e.getPreSelection = function () {
        return e.props.openToDate ? e.props.openToDate : e.props.selectsEnd && e.props.startDate ? e.props.startDate : e.props.selectsStart && e.props.endDate ? e.props.endDate : U();
      }, e.modifyHolidays = function () {
        var a;
        return (a = e.props.holidays) === null || a === void 0 ? void 0 : a.reduce(function (o, i) {
          var s = new Date(i.date);
          return Oe(s) ? Me(Me([], o, !0), [_V(_V({}, i), {
            date: s
          })], !1) : o;
        }, []);
      }, e.calcInitialState = function () {
        var a,
          o = e.getPreSelection(),
          i = Ua(e.props),
          s = Xa(e.props),
          c = i && nt(o, Xt(i)) ? i : s && Ve(o, Lr(s)) ? s : o;
        return {
          open: e.props.startOpen || !1,
          preventFocus: !1,
          inputValue: null,
          preSelection: (a = e.props.selectsRange ? e.props.startDate : e.props.selected) !== null && a !== void 0 ? a : c,
          // transforming highlighted days (perhaps nested array)
          // to flat Map for faster access in day.jsx
          highlightDates: Qr(e.props.highlightDates),
          focused: !1,
          // used to focus day in inline version after month has changed, but not on
          // initial render
          shouldFocusDayInline: !1,
          isRenderAriaLiveMessage: !1,
          wasHidden: !1
        };
      }, e.resetHiddenStatus = function () {
        e.setState(_V(_V({}, e.state), {
          wasHidden: !1
        }));
      }, e.setHiddenStatus = function () {
        e.setState(_V(_V({}, e.state), {
          wasHidden: !0
        }));
      }, e.setHiddenStateOnVisibilityHidden = function () {
        document.visibilityState === "hidden" && e.setHiddenStatus();
      }, e.clearPreventFocusTimeout = function () {
        e.preventFocusTimeout && clearTimeout(e.preventFocusTimeout);
      }, e.safeFocus = function () {
        setTimeout(function () {
          var a, o;
          (o = (a = e.input) === null || a === void 0 ? void 0 : a.focus) === null || o === void 0 || o.call(a, {
            preventScroll: !0
          });
        }, 0);
      }, e.safeBlur = function () {
        setTimeout(function () {
          var a, o;
          (o = (a = e.input) === null || a === void 0 ? void 0 : a.blur) === null || o === void 0 || o.call(a);
        }, 0);
      }, e.setFocus = function () {
        e.safeFocus();
      }, e.setBlur = function () {
        e.safeBlur(), e.cancelFocusInput();
      }, e.setOpen = function (a, o) {
        o === void 0 && (o = !1), e.setState({
          open: a,
          preSelection: a && e.state.open ? e.state.preSelection : e.calcInitialState().preSelection,
          lastPreSelectChange: Ln
        }, function () {
          a || e.setState(function (i) {
            return {
              focused: o ? i.focused : !1
            };
          }, function () {
            !o && e.setBlur(), e.setState({
              inputValue: null
            });
          });
        });
      }, e.inputOk = function () {
        return Ne(e.state.preSelection);
      }, e.isCalendarOpen = function () {
        return e.props.open === void 0 ? e.state.open && !e.props.disabled && !e.props.readOnly : e.props.open;
      }, e.handleFocus = function (a) {
        var o,
          i,
          s = e.state.wasHidden,
          c = s ? e.state.open : !0;
        s && e.resetHiddenStatus(), !e.state.preventFocus && c && ((i = (o = e.props).onFocus) === null || i === void 0 || i.call(o, a), !e.props.preventOpenOnFocus && !e.props.readOnly && e.setOpen(!0)), e.setState({
          focused: !0
        });
      }, e.sendFocusBackToInput = function () {
        e.preventFocusTimeout && e.clearPreventFocusTimeout(), e.setState({
          preventFocus: !0
        }, function () {
          e.preventFocusTimeout = setTimeout(function () {
            e.setFocus(), e.setState({
              preventFocus: !1
            });
          });
        });
      }, e.cancelFocusInput = function () {
        clearTimeout(e.inputFocusTimeout), e.inputFocusTimeout = void 0;
      }, e.deferFocusInput = function () {
        e.cancelFocusInput(), e.inputFocusTimeout = setTimeout(function () {
          return e.setFocus();
        }, 1);
      }, e.handleDropdownFocus = function () {
        e.cancelFocusInput();
      }, e.handleBlur = function (a) {
        var o, i;
        (!e.state.open || e.props.withPortal || e.props.showTimeInput) && ((i = (o = e.props).onBlur) === null || i === void 0 || i.call(o, a)), e.setState({
          focused: !1
        });
      }, e.handleCalendarClickOutside = function (a) {
        var o, i;
        e.props.inline || e.setOpen(!1), (i = (o = e.props).onClickOutside) === null || i === void 0 || i.call(o, a), e.props.withPortal && a.preventDefault();
      }, e.handleChange = function () {
        for (var a, o, i = [], s = 0; s < arguments.length; s++) {
          i[s] = arguments[s];
        }
        var c = i[0];
        if (!(e.props.onChangeRaw && (e.props.onChangeRaw.apply(e, i), !c || typeof c.isDefaultPrevented != "function" || c.isDefaultPrevented()))) {
          e.setState({
            inputValue: (c == null ? void 0 : c.target) instanceof HTMLInputElement ? c.target.value : null,
            lastPreSelectChange: Zu
          });
          var l = e.props,
            u = l.dateFormat,
            d = u === void 0 ? r.defaultProps.dateFormat : u,
            f = l.strictParsing,
            p = f === void 0 ? r.defaultProps.strictParsing : f,
            h = l.selectsRange,
            g = l.startDate,
            v = l.endDate,
            w = (c == null ? void 0 : c.target) instanceof HTMLInputElement ? c.target.value : "";
          if (h) {
            var D = w.split("-", 2).map(function (B) {
                return B.trim();
              }),
              b = D[0],
              P = D[1],
              S = Tn(b !== null && b !== void 0 ? b : "", d, e.props.locale, p),
              T = Tn(P !== null && P !== void 0 ? P : "", d, e.props.locale, p),
              y = (g == null ? void 0 : g.getTime()) !== (S == null ? void 0 : S.getTime()),
              x = (v == null ? void 0 : v.getTime()) !== (T == null ? void 0 : T.getTime());
            if (!y && !x || S && me(S, e.props) || T && me(T, e.props)) return;
            (o = (a = e.props).onChange) === null || o === void 0 || o.call(a, [S, T], c);
          } else {
            var E = Tn(w, d, e.props.locale, p, e.props.minDate);
            e.props.showTimeSelectOnly && e.props.selected && E && !Q(E, e.props.selected) && (E = Jc(e.props.selected, {
              hours: Ce(E),
              minutes: Se(E),
              seconds: Ye(E)
            })), (E || !w) && e.setSelected(E, c, !0);
          }
        }
      }, e.handleSelect = function (a, o, i) {
        if (e.props.shouldCloseOnSelect && !e.props.showTimeSelect && e.sendFocusBackToInput(), e.props.onChangeRaw && e.props.onChangeRaw(o), e.setSelected(a, o, !1, i), e.props.showDateSelect && e.setState({
          isRenderAriaLiveMessage: !0
        }), !e.props.shouldCloseOnSelect || e.props.showTimeSelect) e.setPreSelection(a);else if (!e.props.inline) {
          e.props.selectsRange || e.setOpen(!1);
          var s = e.props,
            c = s.startDate,
            l = s.endDate;
          c && !l && (e.props.swapRange || !jr(a, c)) && e.setOpen(!1);
        }
      }, e.setSelected = function (a, o, i, s) {
        var c,
          l,
          u = a;
        if (e.props.showYearPicker) {
          if (u !== null && Gt(F(u), e.props)) return;
        } else if (e.props.showMonthYearPicker) {
          if (u !== null && za(u, e.props)) return;
        } else if (u !== null && me(u, e.props)) return;
        var d = e.props,
          f = d.onChange,
          p = d.selectsRange,
          h = d.startDate,
          g = d.endDate,
          v = d.selectsMultiple,
          w = d.selectedDates,
          D = d.minTime,
          b = d.swapRange;
        if (!Xe(e.props.selected, u) || e.props.allowSameDay || p || v) if (u !== null && (e.props.selected && (!i || !e.props.showTimeSelect && !e.props.showTimeSelectOnly && !e.props.showTimeInput) && (u = Nn(u, {
          hour: Ce(e.props.selected),
          minute: Se(e.props.selected),
          second: Ye(e.props.selected)
        })), !i && (e.props.showTimeSelect || e.props.showTimeSelectOnly) && D && (u = Nn(u, {
          hour: D.getHours(),
          minute: D.getMinutes(),
          second: D.getSeconds()
        })), e.props.inline || e.setState({
          preSelection: u
        }), e.props.focusSelectedMonth || e.setState({
          monthSelectedIn: s
        })), p) {
          var P = !h && !g,
            S = h && !g,
            T = h && g;
          P ? f == null || f([u, null], o) : S && (u === null ? f == null || f([null, null], o) : jr(u, h) ? b ? f == null || f([u, h], o) : f == null || f([u, null], o) : f == null || f([h, u], o)), T && (f == null || f([u, null], o));
        } else if (v) {
          if (u !== null) if (!(w != null && w.length)) f == null || f([u], o);else {
            var y = w.some(function (E) {
              return Q(E, u);
            });
            if (y) {
              var x = w.filter(function (E) {
                return !Q(E, u);
              });
              f == null || f(x, o);
            } else f == null || f(Me(Me([], w, !0), [u], !1), o);
          }
        } else f == null || f(u, o);
        i || ((l = (c = e.props).onSelect) === null || l === void 0 || l.call(c, u, o), e.setState({
          inputValue: null
        }));
      }, e.setPreSelection = function (a) {
        var o = Ne(e.props.minDate),
          i = Ne(e.props.maxDate),
          s = !0;
        if (a) {
          var c = Xt(a);
          if (o && i) s = Pt(a, e.props.minDate, e.props.maxDate);else if (o) {
            var l = Xt(e.props.minDate);
            s = Ve(a, l) || Xe(c, l);
          } else if (i) {
            var u = Lr(e.props.maxDate);
            s = nt(a, u) || Xe(c, u);
          }
        }
        s && e.setState({
          preSelection: a
        });
      }, e.toggleCalendar = function () {
        e.setOpen(!e.state.open);
      }, e.handleTimeChange = function (a) {
        var o, i;
        if (!(e.props.selectsRange || e.props.selectsMultiple)) {
          var s = e.props.selected ? e.props.selected : e.getPreSelection(),
            c = e.props.selected ? a : Nn(s, {
              hour: Ce(a),
              minute: Se(a)
            });
          e.setState({
            preSelection: c
          }), (i = (o = e.props).onChange) === null || i === void 0 || i.call(o, c), e.props.shouldCloseOnSelect && !e.props.showTimeInput && (e.sendFocusBackToInput(), e.setOpen(!1)), e.props.showTimeInput && e.setOpen(!0), (e.props.showTimeSelectOnly || e.props.showTimeSelect) && e.setState({
            isRenderAriaLiveMessage: !0
          }), e.setState({
            inputValue: null
          });
        }
      }, e.onInputClick = function () {
        var a, o;
        !e.props.disabled && !e.props.readOnly && e.setOpen(!0), (o = (a = e.props).onInputClick) === null || o === void 0 || o.call(a);
      }, e.onInputKeyDown = function (a) {
        var o, i, s, c, l, u;
        (i = (o = e.props).onKeyDown) === null || i === void 0 || i.call(o, a);
        var d = a.key;
        if (!e.state.open && !e.props.inline && !e.props.preventOpenOnFocus) {
          (d === k.ArrowDown || d === k.ArrowUp || d === k.Enter) && ((s = e.onInputClick) === null || s === void 0 || s.call(e));
          return;
        }
        if (e.state.open) {
          if (d === k.ArrowDown || d === k.ArrowUp) {
            a.preventDefault();
            var f = e.props.showTimeSelectOnly ? ".react-datepicker__time-list-item[tabindex='0']" : e.props.showWeekPicker && e.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : e.props.showFullMonthYearPicker || e.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]',
              p = ((c = e.calendar) === null || c === void 0 ? void 0 : c.containerRef.current) instanceof Element && e.calendar.containerRef.current.querySelector(f);
            p instanceof HTMLElement && p.focus({
              preventScroll: !0
            });
            return;
          }
          var h = U(e.state.preSelection);
          d === k.Enter ? (a.preventDefault(), a.target.blur(), e.inputOk() && e.state.lastPreSelectChange === Ln ? (e.handleSelect(h, a), !e.props.shouldCloseOnSelect && e.setPreSelection(h)) : e.setOpen(!1)) : d === k.Escape ? (a.preventDefault(), a.target.blur(), e.sendFocusBackToInput(), e.setOpen(!1)) : d === k.Tab && e.setOpen(!1), e.inputOk() || (u = (l = e.props).onInputError) === null || u === void 0 || u.call(l, {
            code: 1,
            msg: Rn
          });
        }
      }, e.onPortalKeyDown = function (a) {
        var o = a.key;
        o === k.Escape && (a.preventDefault(), e.setState({
          preventFocus: !0
        }, function () {
          e.setOpen(!1), setTimeout(function () {
            e.setFocus(), e.setState({
              preventFocus: !1
            });
          });
        }));
      }, e.onDayKeyDown = function (a) {
        var o,
          i,
          s,
          c,
          l,
          u,
          d = e.props,
          f = d.minDate,
          p = d.maxDate,
          h = d.disabledKeyboardNavigation,
          g = d.showWeekPicker,
          v = d.shouldCloseOnSelect,
          w = d.locale,
          D = d.calendarStartDay,
          b = d.adjustDateOnChange,
          P = d.inline;
        if ((i = (o = e.props).onKeyDown) === null || i === void 0 || i.call(o, a), !h) {
          var S = a.key,
            T = a.shiftKey,
            y = U(e.state.preSelection),
            x = function x(A, O) {
              var R = O;
              switch (A) {
                case k.ArrowRight:
                  R = g ? nn(O, 1) : we(O, 1);
                  break;
                case k.ArrowLeft:
                  R = g ? _r(O, 1) : Fc(O, 1);
                  break;
                case k.ArrowUp:
                  R = _r(O, 1);
                  break;
                case k.ArrowDown:
                  R = nn(O, 1);
                  break;
                case k.PageUp:
                  R = T ? mt(O, 1) : Ze(O, 1);
                  break;
                case k.PageDown:
                  R = T ? Te(O, 1) : be(O, 1);
                  break;
                case k.Home:
                  R = He(O, w, D);
                  break;
                case k.End:
                  R = uu(O);
                  break;
              }
              return R;
            },
            E = function E(A, O) {
              for (var R = 40, $ = A, X = !1, ve = 0, re = x(A, O); !X;) {
                if (ve >= R) {
                  re = O;
                  break;
                }
                f && re < f && ($ = k.ArrowRight, re = me(f, e.props) ? x($, re) : f), p && re > p && ($ = k.ArrowLeft, re = me(p, e.props) ? x($, re) : p), me(re, e.props) ? (($ === k.PageUp || $ === k.Home) && ($ = k.ArrowRight), ($ === k.PageDown || $ === k.End) && ($ = k.ArrowLeft), re = x($, re)) : X = !0, ve++;
              }
              return re;
            };
          if (S === k.Enter) {
            a.preventDefault(), e.handleSelect(y, a), !v && e.setPreSelection(y);
            return;
          } else if (S === k.Escape) {
            a.preventDefault(), e.setOpen(!1), e.inputOk() || (c = (s = e.props).onInputError) === null || c === void 0 || c.call(s, {
              code: 1,
              msg: Rn
            });
            return;
          }
          var B = null;
          switch (S) {
            case k.ArrowLeft:
            case k.ArrowRight:
            case k.ArrowUp:
            case k.ArrowDown:
            case k.PageUp:
            case k.PageDown:
            case k.Home:
            case k.End:
              B = E(S, y);
              break;
          }
          if (!B) {
            (u = (l = e.props).onInputError) === null || u === void 0 || u.call(l, {
              code: 1,
              msg: Rn
            });
            return;
          }
          if (a.preventDefault(), e.setState({
            lastPreSelectChange: Ln
          }), b && e.setSelected(B), e.setPreSelection(B), P) {
            var L = ue(y),
              N = ue(B),
              W = F(y),
              H = F(B);
            L !== N || W !== H ? e.setState({
              shouldFocusDayInline: !0
            }) : e.setState({
              shouldFocusDayInline: !1
            });
          }
        }
      }, e.onPopperKeyDown = function (a) {
        var o = a.key;
        o === k.Escape && (a.preventDefault(), e.sendFocusBackToInput());
      }, e.onClearClick = function (a) {
        a && a.preventDefault && a.preventDefault(), e.sendFocusBackToInput();
        var o = e.props,
          i = o.selectsRange,
          s = o.onChange;
        i ? s == null || s([null, null], a) : s == null || s(null, a), e.setState({
          inputValue: null
        });
      }, e.clear = function () {
        e.onClearClick();
      }, e.onScroll = function (a) {
        typeof e.props.closeOnScroll == "boolean" && e.props.closeOnScroll ? (a.target === document || a.target === document.documentElement || a.target === document.body) && e.setOpen(!1) : typeof e.props.closeOnScroll == "function" && e.props.closeOnScroll(a) && e.setOpen(!1);
      }, e.renderCalendar = function () {
        var a, o;
        return !e.props.inline && !e.isCalendarOpen() ? null : /*#__PURE__*/m.createElement(Vu, _V({
          showMonthYearDropdown: void 0,
          ref: function ref(i) {
            e.calendar = i;
          }
        }, e.props, e.state, {
          setOpen: e.setOpen,
          dateFormat: (a = e.props.dateFormatCalendar) !== null && a !== void 0 ? a : r.defaultProps.dateFormatCalendar,
          onSelect: e.handleSelect,
          onClickOutside: e.handleCalendarClickOutside,
          holidays: ku(e.modifyHolidays()),
          outsideClickIgnoreClass: Xr,
          onDropdownFocus: e.handleDropdownFocus,
          onTimeChange: e.handleTimeChange,
          className: e.props.calendarClassName,
          container: e.props.calendarContainer,
          handleOnKeyDown: e.props.onKeyDown,
          handleOnDayKeyDown: e.onDayKeyDown,
          setPreSelection: e.setPreSelection,
          dropdownMode: (o = e.props.dropdownMode) !== null && o !== void 0 ? o : r.defaultProps.dropdownMode
        }), e.props.children);
      }, e.renderAriaLiveRegion = function () {
        var a = e.props,
          o = a.dateFormat,
          i = o === void 0 ? r.defaultProps.dateFormat : o,
          s = a.locale,
          c = e.props.showTimeInput || e.props.showTimeSelect,
          l = c ? "PPPPp" : "PPPP",
          u;
        return e.props.selectsRange ? u = "Selected start date: ".concat(he(e.props.startDate, {
          dateFormat: l,
          locale: s
        }), ". ").concat(e.props.endDate ? "End date: " + he(e.props.endDate, {
          dateFormat: l,
          locale: s
        }) : "") : e.props.showTimeSelectOnly ? u = "Selected time: ".concat(he(e.props.selected, {
          dateFormat: i,
          locale: s
        })) : e.props.showYearPicker ? u = "Selected year: ".concat(he(e.props.selected, {
          dateFormat: "yyyy",
          locale: s
        })) : e.props.showMonthYearPicker ? u = "Selected month: ".concat(he(e.props.selected, {
          dateFormat: "MMMM yyyy",
          locale: s
        })) : e.props.showQuarterYearPicker ? u = "Selected quarter: ".concat(he(e.props.selected, {
          dateFormat: "yyyy, QQQ",
          locale: s
        })) : u = "Selected date: ".concat(he(e.props.selected, {
          dateFormat: l,
          locale: s
        })), /*#__PURE__*/m.createElement("span", {
          role: "alert",
          "aria-live": "polite",
          className: "react-datepicker__aria-live"
        }, u);
      }, e.renderDateInput = function () {
        var a,
          o,
          i,
          s = se(e.props.className, (a = {}, a[Xr] = e.state.open, a)),
          c = e.props.customInput || /*#__PURE__*/m.createElement("input", {
            type: "text"
          }),
          l = e.props.customInputRef || "ref",
          u = e.props,
          d = u.dateFormat,
          f = d === void 0 ? r.defaultProps.dateFormat : d,
          p = u.locale,
          h = typeof e.props.value == "string" ? e.props.value : typeof e.state.inputValue == "string" ? e.state.inputValue : e.props.selectsRange ? iu(e.props.startDate, e.props.endDate, {
            dateFormat: f,
            locale: p
          }) : e.props.selectsMultiple ? su((i = e.props.selectedDates) !== null && i !== void 0 ? i : [], {
            dateFormat: f,
            locale: p
          }) : he(e.props.selected, {
            dateFormat: f,
            locale: p
          });
        return /*#__PURE__*/ra(c, (o = {}, o[l] = function (g) {
          e.input = g;
        }, o.value = h, o.onBlur = e.handleBlur, o.onChange = e.handleChange, o.onClick = e.onInputClick, o.onFocus = e.handleFocus, o.onKeyDown = e.onInputKeyDown, o.id = e.props.id, o.name = e.props.name, o.form = e.props.form, o.autoFocus = e.props.autoFocus, o.placeholder = e.props.placeholderText, o.disabled = e.props.disabled, o.autoComplete = e.props.autoComplete, o.className = se(c.props.className, s), o.title = e.props.title, o.readOnly = e.props.readOnly, o.required = e.props.required, o.tabIndex = e.props.tabIndex, o["aria-describedby"] = e.props.ariaDescribedBy, o["aria-invalid"] = e.props.ariaInvalid, o["aria-labelledby"] = e.props.ariaLabelledBy, o["aria-required"] = e.props.ariaRequired, o));
      }, e.renderClearButton = function () {
        var a = e.props,
          o = a.isClearable,
          i = a.disabled,
          s = a.selected,
          c = a.startDate,
          l = a.endDate,
          u = a.clearButtonTitle,
          d = a.clearButtonClassName,
          f = d === void 0 ? "" : d,
          p = a.ariaLabelClose,
          h = p === void 0 ? "Close" : p,
          g = a.selectedDates;
        return o && (s != null || c != null || l != null || g != null && g.length) ? /*#__PURE__*/m.createElement("button", {
          type: "button",
          className: se("react-datepicker__close-icon", f, {
            "react-datepicker__close-icon--disabled": i
          }),
          disabled: i,
          "aria-label": h,
          onClick: e.onClearClick,
          title: u,
          tabIndex: -1
        }) : null;
      }, e.state = e.calcInitialState(), e.preventFocusTimeout = void 0, e;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function get() {
        return {
          allowSameDay: !1,
          dateFormat: "MM/dd/yyyy",
          dateFormatCalendar: "LLLL yyyy",
          disabled: !1,
          disabledKeyboardNavigation: !1,
          dropdownMode: "scroll",
          preventOpenOnFocus: !1,
          monthsShown: 1,
          readOnly: !1,
          withPortal: !1,
          selectsDisabledDaysInRange: !1,
          shouldCloseOnSelect: !0,
          showTimeSelect: !1,
          showTimeInput: !1,
          showPreviousMonths: !1,
          showMonthYearPicker: !1,
          showFullMonthYearPicker: !1,
          showTwoColumnMonthYearPicker: !1,
          showFourColumnMonthYearPicker: !1,
          showYearPicker: !1,
          showQuarterYearPicker: !1,
          showWeekPicker: !1,
          strictParsing: !1,
          swapRange: !1,
          timeIntervals: 30,
          timeCaption: "Time",
          previousMonthAriaLabel: "Previous Month",
          previousMonthButtonLabel: "Previous Month",
          nextMonthAriaLabel: "Next Month",
          nextMonthButtonLabel: "Next Month",
          previousYearAriaLabel: "Previous Year",
          previousYearButtonLabel: "Previous Year",
          nextYearAriaLabel: "Next Year",
          nextYearButtonLabel: "Next Year",
          timeInputLabel: "Time",
          enableTabLoop: !0,
          yearItemNumber: Ft,
          focusSelectedMonth: !1,
          showPopperArrow: !0,
          excludeScrollbar: !0,
          customTimeInput: null,
          calendarStartDay: void 0,
          toggleCalendarOnIconClick: !1,
          usePointerEvent: !1
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.componentDidMount = function () {
      window.addEventListener("scroll", this.onScroll, !0), document.addEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    }, r.prototype.componentDidUpdate = function (t, e) {
      var a, o, i, s;
      t.inline && Gu(t.selected, this.props.selected) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && t.monthsShown !== this.props.monthsShown && this.setState({
        monthSelectedIn: 0
      }), t.highlightDates !== this.props.highlightDates && this.setState({
        highlightDates: Qr(this.props.highlightDates)
      }), !e.focused && !Xe(t.selected, this.props.selected) && this.setState({
        inputValue: null
      }), e.open !== this.state.open && (e.open === !1 && this.state.open === !0 && ((o = (a = this.props).onCalendarOpen) === null || o === void 0 || o.call(a)), e.open === !0 && this.state.open === !1 && ((s = (i = this.props).onCalendarClose) === null || s === void 0 || s.call(i)));
    }, r.prototype.componentWillUnmount = function () {
      this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0), document.removeEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    }, r.prototype.renderInputContainer = function () {
      var t = this.props,
        e = t.showIcon,
        a = t.icon,
        o = t.calendarIconClassname,
        i = t.calendarIconClassName,
        s = t.toggleCalendarOnIconClick,
        c = this.state.open;
      return o && console.warn("calendarIconClassname props is deprecated. should use calendarIconClassName props."), /*#__PURE__*/m.createElement("div", {
        className: "react-datepicker__input-container".concat(e ? " react-datepicker__view-calendar-icon" : "")
      }, e && /*#__PURE__*/m.createElement(qu, _V({
        icon: a,
        className: se(i, !i && o, c && "react-datepicker-ignore-onclickoutside")
      }, s ? {
        onClick: this.toggleCalendar
      } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
    }, r.prototype.render = function () {
      var t = this.renderCalendar();
      if (this.props.inline) return t;
      if (this.props.withPortal) {
        var e = this.state.open ? /*#__PURE__*/m.createElement(Ja, {
          enableTabLoop: this.props.enableTabLoop
        }, /*#__PURE__*/m.createElement("div", {
          className: "react-datepicker__portal",
          tabIndex: -1,
          onKeyDown: this.onPortalKeyDown
        }, t)) : null;
        return this.state.open && this.props.portalId && (e = /*#__PURE__*/m.createElement(Za, _V({
          portalId: this.props.portalId
        }, this.props), e)), /*#__PURE__*/m.createElement("div", null, this.renderInputContainer(), e);
      }
      return /*#__PURE__*/m.createElement(Xu, _V({}, this.props, {
        className: this.props.popperClassName,
        hidePopper: !this.isCalendarOpen(),
        targetComponent: this.renderInputContainer(),
        popperComponent: t,
        popperOnKeyDown: this.onPopperKeyDown,
        showArrow: this.props.showPopperArrow
      }));
    }, r;
  }(oe),
  Zu = "input",
  Ln = "navigate";
var Ju = function Ju(n, r) {
    return r in n.colors;
  },
  ed = {
    desktop: "1440px",
    tablet: "1080px",
    tabletMd: "1024px",
    tabletSm: "768px",
    phone: "640px",
    phoneSm: "320px"
  },
  td = "/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}main{display:block}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button}button::-moz-focus-inner,[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner{border-style:none;padding:0}button:-moz-focusring,[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}template{display:none}[hidden]{display:none}";
oa(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n\n  img {\n    max-width: 100%;\n    height: auto;\n    object-fit: contain;\n  }\n\n  body {\n    min-width: ", ";\n  }\n\n  body,\n  button,\n  input {\n    font-family: ", ";\n    color: ", ";\n  }\n  p,\n  a,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  input,\n  hr,\n  button,\n  section,\n  menu {\n    margin: 0;\n    padding: 0;\n  }\n  div,\n  section,\n  input,\n  button {\n    box-sizing: border-box;\n  }\n  input {\n    outline: none;\n  }\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus,\n  textarea:-webkit-autofill,\n  textarea:-webkit-autofill:hover,\n  textarea:-webkit-autofill:focus,\n  select:-webkit-autofill,\n  select:-webkit-autofill:hover,\n  select:-webkit-autofill:focus {\n    transition: background-color 100s ease-in-out 0s;\n  }\n  button {\n    border: none;\n  }\n"])), td, ed.phoneSm, function (_ref58) {
  var n = _ref58.theme;
  return n.fontFamily;
}, function (_ref59) {
  var n = _ref59.theme;
  return n.colors.black10;
});
var nd = function nd(n) {
    return !!n && !!n && /^[\w\-+.]+@([\w-]+\.)+[\w-]{2,3}$/.test(n);
  },
  rd = function rd(n) {
    if (n == null || n === "") return !1;
    var r = Number(n);
    return typeof n == "string" && r >= 0 && Number.isInteger(r);
  },
  ir = I.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  min-height: 16px;\n  font-size: 13px;\n"]))),
  eo = I.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n"]))),
  to = I.p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 1;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  white-space: nowrap;\n  margin: 0;\n"]))),
  no = I.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n"]))),
  ad = I(ir)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-bottom: 0;\n  margin-top: 8px;\n  min-height: 1em;\n  font-size: 16px;\n"]))),
  od = I.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"]))),
  id = I.p(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  line-height: 1;\n  letter-spacing: 0.1px;\n  color: ", ";\n"])), function (_ref60) {
    var n = _ref60.theme;
    return n.colors.red50;
  }),
  ro = 8,
  ao = J(["font-family:inherit;font-weight:400;font-size:16px;line-height:22px;", "{font-size:14px;}"], function (_ref61) {
    var n = _ref61.theme.down;
    return n("tablet");
  }),
  oo = "0px 1px 8px rgba(0, 0, 0, 0.17)",
  io = "0px 4px 20px rgba(0, 0, 0, 0.07)",
  so = "0px 4px 28px rgba(0, 0, 0, 0.14)";
J(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], oo);
var sd = J(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], io);
J(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], so);
J(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], oo);
J(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], io);
J(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], so);
var cd = J(["", ";g{fill:inherit;stroke:inherit;}*:not([stroke]){&[fill='none']{stroke-width:0;}}*[stroke*='#'],*[STROKE*='#']{stroke:inherit;fill:none;}*[fill-rule],*[FILL-RULE],*[fill*='#'],*[FILL*='#']{stroke:none;}*[fill-rule],*[FILL-RULE],*[fill*='#']:not([fill='#FFF']),*[FILL*='#']:not([FILL='#FFF']){fill:inherit;}"], function (_ref62) {
    var _r$colors$t;
    var n = _ref62.color,
      r = _ref62.theme,
      t = _ref62.disabled;
    var e;
    return t ? e = typeof t == "string" ? (_r$colors$t = r.colors[t]) !== null && _r$colors$t !== void 0 ? _r$colors$t : t : r.colors.black80 : n && Ju(r, n) ? e = r.colors[n] : e = n || r.colors.icon, J(["fill:", ";stroke:", ";"], e, e);
  }),
  Zt = 24,
  ld = function ld(n) {
    var r = n.match(/\d+(\.\d+)?/);
    return r ? parseFloat(r[0]) : Zt;
  },
  ud = I.svg(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: inline-block;\n  flex: 0 0 auto;\n  ", "\n  ", ";\n"])), function (_ref63) {
    var _ref63$size = _ref63.size,
      n = _ref63$size === void 0 ? Zt : _ref63$size,
      r = _ref63.theme,
      t = _ref63.viewBox;
    var _split = (t || "0 0 ".concat(Zt, " ").concat(Zt)).split(" "),
      _split2 = _slicedToArray(_split, 4),
      e = _split2[2],
      a = _split2[3],
      o = +e / +a,
      i = ld(r.icons.size[n] || "".concat(n, "px"));
    return e < a ? "\n      width: ".concat(i, "px;\n      height: ").concat(i / o, "px;\n    ") : a < e ? "\n      width: ".concat(i * o, "px;\n      height: ").concat(i, "px;\n    ") : "\n      width: ".concat(i, "px;\n      height: ").concat(i, "px;\n    ");
  }, function (_ref64) {
    var n = _ref64.$hasOwnColorPattern;
    return n ? void 0 : cd;
  }),
  bt = function bt(_ref65) {
    var n = _ref65.a11yTitle,
      r = _objectWithoutProperties(_ref65, _excluded5);
    return /* @__PURE__ */_(ud, _objectSpread(_objectSpread({}, r), {}, {
      name: n
    }));
  },
  co = function co(n) {
    return /* @__PURE__ */_(bt, _objectSpread(_objectSpread({
      viewBox: "0 0 24 24",
      a11yTitle: "Back"
    }, n), {}, {
      children: /* @__PURE__ */_("path", {
        d: "M19 11.5H7.82998L12.71 6.62C13.1 6.23 13.1 5.59 12.71 5.2C12.32 4.81 11.69 4.81 11.3 5.2L4.70998 11.79C4.31998 12.18 4.31998 12.81 4.70998 13.2L11.3 19.79C11.69 20.18 12.32 20.18 12.71 19.79C13.1 19.4 13.1 18.77 12.71 18.38L7.82998 13.5H19C19.55 13.5 20 13.05 20 12.5C20 11.95 19.55 11.5 19 11.5Z",
        fill: "#0091DF"
      })
    }));
  };
co.displayName = "Back";
var lo = function lo(n) {
  return /* @__PURE__ */pe(bt, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    a11yTitle: "Calendar"
  }, n), {}, {
    children: [/* @__PURE__ */_("path", {
      d: "M2 9.5C2 7.61438 2 6.67157 2.58579 6.08579C3.17157 5.5 4.11438 5.5 6 5.5H18C19.8856 5.5 20.8284 5.5 21.4142 6.08579C22 6.67157 22 7.61438 22 9.5C22 9.9714 22 10.2071 21.8536 10.3536C21.7071 10.5 21.4714 10.5 21 10.5H3C2.5286 10.5 2.29289 10.5 2.14645 10.3536C2 10.2071 2 9.9714 2 9.5Z",
      fill: "#0091DF"
    }), /* @__PURE__ */_("path", {
      d: "M2 18.5C2 20.3856 2 21.3284 2.58579 21.9142C3.17157 22.5 4.11438 22.5 6 22.5H18C19.8856 22.5 20.8284 22.5 21.4142 21.9142C22 21.3284 22 20.3856 22 18.5V13.5C22 13.0286 22 12.7929 21.8536 12.6464C21.7071 12.5 21.4714 12.5 21 12.5H3C2.5286 12.5 2.29289 12.5 2.14645 12.6464C2 12.7929 2 13.0286 2 13.5V18.5Z",
      fill: "#0091DF"
    }), /* @__PURE__ */_("path", {
      d: "M7 3.5L7 6.5",
      stroke: "#0091DF",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /* @__PURE__ */_("path", {
      d: "M17 3.5L17 6.5",
      stroke: "#0091DF",
      strokeWidth: "2",
      strokeLinecap: "round"
    })]
  }));
};
lo.displayName = "Calendar";
var uo = function uo(n) {
  return /* @__PURE__ */_(bt, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    a11yTitle: "Forward"
  }, n), {}, {
    children: /* @__PURE__ */_("path", {
      d: "M5 13.5H16.17L11.29 18.38C10.9 18.77 10.9 19.41 11.29 19.8C11.68 20.19 12.31 20.19 12.7 19.8L19.29 13.21C19.68 12.82 19.68 12.19 19.29 11.8L12.71 5.2C12.32 4.81 11.69 4.81 11.3 5.2C10.91 5.59 10.91 6.22 11.3 6.61L16.17 11.5H5C4.45 11.5 4 11.95 4 12.5C4 13.05 4.45 13.5 5 13.5Z",
      fill: "#0091DF"
    })
  }));
};
uo.displayName = "Forward";
var fo = function fo(n) {
  return /* @__PURE__ */_(bt, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    a11yTitle: "VisibilityOff"
  }, n), {}, {
    children: /* @__PURE__ */_("path", {
      d: "M12 6.5C14.76 6.5 17 8.74 17 11.5C17 12.01 16.9 12.5 16.76 12.96L19.82 16.02C21.21 14.79 22.31 13.25 23 11.49C21.27 7.11 17 4 12 4C10.73 4 9.51 4.2 8.36 4.57L10.53 6.74C11 6.6 11.49 6.5 12 6.5ZM2.71 3.16C2.32 3.55 2.32 4.18 2.71 4.57L4.68 6.54C3.06 7.83 1.77 9.53 1 11.5C2.73 15.89 7 19 12 19C13.52 19 14.97 18.7 16.31 18.18L19.03 20.9C19.42 21.29 20.05 21.29 20.44 20.9C20.83 20.51 20.83 19.88 20.44 19.49L4.13 3.16C3.74 2.77 3.1 2.77 2.71 3.16ZM12 16.5C9.24 16.5 7 14.26 7 11.5C7 10.73 7.18 10 7.49 9.36L9.06 10.93C9.03 11.11 9 11.3 9 11.5C9 13.16 10.34 14.5 12 14.5C12.2 14.5 12.38 14.47 12.57 14.43L14.14 16C13.49 16.32 12.77 16.5 12 16.5ZM14.97 11.17C14.82 9.77 13.72 8.68 12.33 8.53L14.97 11.17Z",
      fill: "#0091DF"
    })
  }));
};
fo.displayName = "VisibilityOff";
var po = function po(n) {
  return /* @__PURE__ */_(bt, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    a11yTitle: "VisibilityOn"
  }, n), {}, {
    children: /* @__PURE__ */_("path", {
      d: "M12 4C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 11.5C21.27 7.11 17 4 12 4ZM12 16.5C9.24 16.5 7 14.26 7 11.5C7 8.74 9.24 6.5 12 6.5C14.76 6.5 17 8.74 17 11.5C17 14.26 14.76 16.5 12 16.5ZM12 8.5C10.34 8.5 9 9.84 9 11.5C9 13.16 10.34 14.5 12 14.5C13.66 14.5 15 13.16 15 11.5C15 9.84 13.66 8.5 12 8.5Z",
      fill: "#0091DF"
    })
  }));
};
po.displayName = "VisibilityOn";
var ho = function ho(n) {
  return /* @__PURE__ */_(bt, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    a11yTitle: "Warning"
  }, n), {}, {
    children: /* @__PURE__ */_("path", {
      d: "M3.49492 22.105H20.5052C22.2446 22.105 23.3289 20.2187 22.4592 18.7165L13.9541 4.0217C13.0844 2.51947 10.9157 2.51947 10.046 4.0217L1.54089 18.7165C0.671174 20.2187 1.75549 22.105 3.49492 22.105ZM12.0001 15.1985C11.3788 15.1985 10.8706 14.6902 10.8706 14.069V9.81C10.8706 9.18877 11.3788 8.6805 12.0001 8.6805C12.6213 8.6805 13.1296 9.18877 13.1296 9.81V14.069C13.1296 14.6902 12.6213 15.1985 12.0001 15.1985ZM13.1296 17.587C13.1296 18.2108 12.6239 18.7165 12.0001 18.7165C11.3763 18.7165 10.8706 18.2108 10.8706 17.587C10.8706 16.9632 11.3763 16.4575 12.0001 16.4575C12.6239 16.4575 13.1296 16.9632 13.1296 17.587Z",
      fill: "#0091DF"
    })
  }));
};
ho.displayName = "Warning";
function mo(n) {
  return (n == null ? void 0 : n.text) !== void 0;
}
var Zr = {
    xLarge: "\n    padding: 16px 40px;\n    font-size: 20px;\n    line-height: 32px;\n  ",
    large: "\n    padding: 16px 30px;\n    font-size: 18px;\n    line-height: 24px;\n  ",
    medium: "\n    padding: 12px 22px;\n    font-size: 16px;\n    line-height: 24px;\n  ",
    small: "\n    padding: 8px 20px;\n    font-size: 14px;\n    line-height: 24px;\n  ",
    xSmall: "\n    padding: 8px 16px;\n    font-size: 12px;\n    line-height: 16px;\n  "
  },
  dd = J(["&&{background:", ";cursor:default;@media (hover:hover) and (pointer:fine){&:hover{background:", ";text-decoration:none;}}}"], function (_ref66) {
    var n = _ref66.theme;
    return n.colors.black80;
  }, function (_ref67) {
    var n = _ref67.theme;
    return n.colors.black80;
  }),
  fd = I.button(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-width: fit-content;\n  border-radius: 8px;\n  border: none;\n  font-weight: 700;\n  outline: none;\n  cursor: pointer;\n  white-space: nowrap;\n  user-select: none;\n  height: fit-content;\n  font-family: inherit;\n  text-decoration: none;\n  -webkit-tap-highlight-color: transparent;\n  color: ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), function (_ref68) {
    var n = _ref68.theme;
    return n.colors.black100;
  }, function (_ref69) {
    var _Zr$n;
    var n = _ref69.size;
    return (_Zr$n = Zr[n]) !== null && _Zr$n !== void 0 ? _Zr$n : Zr.small;
  }, function (_ref70) {
    var n = _ref70.disabled;
    return n && dd;
  }, function (_ref71) {
    var n = _ref71.$fit;
    return n && J(["width:fit-content;height:fit-content;"]);
  }),
  pd = I.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  & > svg {\n    margin-left: ", ";\n    margin-right: ", ";\n  }\n"])), function (_ref72) {
    var n = _ref72.$margin,
      r = _ref72.$position;
    return r === "left" ? 0 : "".concat(n, "px");
  }, function (_ref73) {
    var n = _ref73.$margin,
      r = _ref73.$position;
    return r === "right" ? 0 : "".concat(n, "px");
  }),
  Jr = function Jr(_ref74) {
    var n = _ref74.position,
      r = _ref74.Icon,
      t = _ref74.size;
    var e = hd[t],
      a = ["small", "xSmall"].includes(t) ? 4 : 8;
    return r ? /* @__PURE__ */_(pd, {
      $position: n,
      $margin: a,
      children: /* @__PURE__ */_(r, {
        size: e
      })
    }) : null;
  },
  Ie = /*#__PURE__*/ce(function (_ref75, p) {
    var _ref75$size = _ref75.size,
      n = _ref75$size === void 0 ? "medium" : _ref75$size,
      _ref75$disabled = _ref75.disabled,
      r = _ref75$disabled === void 0 ? !1 : _ref75$disabled,
      t = _ref75.onClick,
      e = _ref75.children,
      a = _ref75.LeftIcon,
      o = _ref75.RightIcon,
      i = _ref75.tabIndex,
      _ref75$fit = _ref75.fit,
      s = _ref75$fit === void 0 ? !1 : _ref75$fit,
      c = _ref75.name,
      l = _ref75.value,
      u = _ref75.className,
      _ref75$type = _ref75.type,
      d = _ref75$type === void 0 ? "button" : _ref75$type,
      f = _objectWithoutProperties(_ref75, _excluded6);
    return /* @__PURE__ */pe(fd, _objectSpread(_objectSpread({
      size: n,
      disabled: r,
      onClick: t,
      tabIndex: i,
      $fit: s,
      name: c,
      value: l,
      className: u,
      type: d,
      ref: p
    }, f), {}, {
      children: [/* @__PURE__ */_(Jr, {
        Icon: a,
        size: n,
        position: "left"
      }), e, /* @__PURE__ */_(Jr, {
        Icon: o,
        size: n,
        position: "right"
      })]
    }));
  }),
  hd = {
    xLarge: 32,
    large: 32,
    medium: 24,
    small: 16,
    xSmall: 16
  },
  md = I(Ie)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  background: ", ";\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: ", ";\n    }\n  }\n"])), function (_ref76) {
    var n = _ref76.theme;
    return n.colors.blue60;
  }, function (_ref77) {
    var n = _ref77.theme;
    return n.colors.blue50;
  });
/*#__PURE__*/ce(function (_ref78, t) {
  var n = _ref78.as,
    r = _objectWithoutProperties(_ref78, _excluded7);
  return /* @__PURE__ */_(md, _objectSpread({
    ref: t,
    forwardedAs: n
  }, r));
});
var gd = I(Ie)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  background: ", ";\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: ", ";\n    }\n  }\n"])), function (_ref79) {
  var n = _ref79.theme;
  return n.colors.darkBlue40;
}, function (_ref80) {
  var n = _ref80.theme;
  return n.colors.darkBlue30;
});
/*#__PURE__*/ce(function (n, r) {
  return /* @__PURE__ */_(gd, _objectSpread({
    ref: r
  }, n));
});
var vd = I(Ie)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  background: ", ";\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: ", ";\n    }\n  }\n"])), function (_ref81) {
  var n = _ref81.theme;
  return n.colors.purple40;
}, function (_ref82) {
  var n = _ref82.theme;
  return n.colors.purple30;
});
/*#__PURE__*/ce(function (n, r) {
  return /* @__PURE__ */_(vd, _objectSpread({
    ref: r
  }, n));
});
var wd = J(["&&{pointer-events:none;background:transparent;color:", ";cursor:default;@media (hover:hover) and (pointer:fine){&:hover{background:transparent;}}& > svg{fill:", ";}}"], function (_ref83) {
    var n = _ref83.theme;
    return n.colors.black80;
  }, function (_ref84) {
    var n = _ref84.theme;
    return n.colors.black80;
  }),
  bd = I(Ie)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  color: ", ";\n  background: transparent;\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      color: ", ";\n\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n  ", ";\n"])), function (_ref85) {
    var n = _ref85.theme;
    return n.colors.blue50;
  }, function (_ref86) {
    var n = _ref86.theme;
    return n.colors.blue30;
  }, function (_ref87) {
    var n = _ref87.theme;
    return n.colors.blue30;
  }, function (_ref88) {
    var n = _ref88.disabled;
    return n && wd;
  }),
  yd = /*#__PURE__*/ce(function (n, r) {
    return /* @__PURE__ */_(bd, _objectSpread({
      ref: r
    }, n));
  }),
  Dd = I(yd)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  padding: 0;\n"]))),
  kd = /*#__PURE__*/ce(function (n, r) {
    return /* @__PURE__ */_(Dd, _objectSpread({
      ref: r
    }, n));
  }),
  xd = J(["&&{background:transparent;&:hover{background:transparent;}& > svg{fill:", ";}}"], function (_ref89) {
    var n = _ref89.theme;
    return n.colors.black80;
  }),
  _d = I(Ie)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  background: transparent;\n  width: fit-content;\n  padding: 0;\n\n  & > svg {\n    fill: ", ";\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: transparent;\n\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n\n  ", ";\n"])), function (_ref90) {
    var n = _ref90.theme;
    return n.colors.blue60;
  }, function (_ref91) {
    var n = _ref91.theme;
    return n.colors.blue50;
  }, function (_ref92) {
    var n = _ref92.disabled;
    return n && xd;
  }),
  Md = /*#__PURE__*/ce(function (_ref93, t) {
    var n = _ref93.children,
      r = _objectWithoutProperties(_ref93, _excluded8);
    return /* @__PURE__ */_(_d, _objectSpread(_objectSpread({
      ref: t,
      "aria-label": "icon-button"
    }, r), {}, {
      children: n
    }));
  }),
  Cd = J(["&&{background:transparent;&:hover{background:transparent;}& > svg{fill:", ";}}"], function (_ref94) {
    var n = _ref94.theme;
    return n.colors.black80;
  }),
  Sd = I(Ie)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  background: transparent;\n  width: fit-content;\n  padding: 0;\n\n  & > svg {\n    fill: ", ";\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: transparent;\n\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n\n  ", ";\n"])), function (_ref95) {
    var n = _ref95.theme;
    return n.colors.darkBlue40;
  }, function (_ref96) {
    var n = _ref96.theme;
    return n.colors.darkBlue30;
  }, function (_ref97) {
    var n = _ref97.disabled;
    return n && Cd;
  });
/*#__PURE__*/ce(function (_ref98, t) {
  var n = _ref98.children,
    r = _objectWithoutProperties(_ref98, _excluded9);
  return /* @__PURE__ */_(Sd, _objectSpread(_objectSpread({
    ref: t
  }, r), {}, {
    children: n
  }));
});
var Pd = J(["&&{background:transparent;&:hover{background:transparent;}& > svg{fill:", ";}}"], function (_ref99) {
    var n = _ref99.theme;
    return n.colors.black80;
  }),
  Ed = I(Ie)(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  background: transparent;\n  width: fit-content;\n  padding: 0;\n\n  & > svg {\n    fill: ", ";\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: transparent;\n\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n\n  ", ";\n"])), function (_ref100) {
    var n = _ref100.theme;
    return n.colors.purple40;
  }, function (_ref101) {
    var n = _ref101.theme;
    return n.colors.purple30;
  }, function (_ref102) {
    var n = _ref102.disabled;
    return n && Pd;
  });
/*#__PURE__*/ce(function (_ref103, t) {
  var n = _ref103.children,
    r = _objectWithoutProperties(_ref103, _excluded10);
  return /* @__PURE__ */_(Ed, _objectSpread(_objectSpread({
    ref: t
  }, r), {}, {
    children: n
  }));
});
var Od = J(["&&{color:", ";&:hover{color:", ";}}"], function (_ref104) {
    var n = _ref104.theme;
    return n.colors.black100;
  }, function (_ref105) {
    var n = _ref105.theme;
    return n.colors.black100;
  }),
  Td = I(Ie)(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  color: ", ";\n  background: ", ";\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      color: ", ";\n      background: ", ";\n    }\n  }\n\n  ", ";\n"])), function (_ref106) {
    var n = _ref106.theme;
    return n.colors.blue50;
  }, function (_ref107) {
    var n = _ref107.theme;
    return n.colors.blue95;
  }, function (_ref108) {
    var n = _ref108.theme;
    return n.colors.blue30;
  }, function (_ref109) {
    var n = _ref109.theme;
    return n.colors.blue90;
  }, function (_ref110) {
    var n = _ref110.disabled;
    return n && Od;
  });
/*#__PURE__*/ce(function (n, r) {
  return /* @__PURE__ */_(Td, _objectSpread({
    ref: r
  }, n));
});
var Nd = J(["&&{background:transparent;&:hover{background:transparent;}& > svg{fill:", ";}}"], function (_ref111) {
    var n = _ref111.theme;
    return n.colors.black80;
  }),
  Yd = I(Ie)(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  background: transparent;\n  width: fit-content;\n  padding: 0;\n\n  & > svg {\n    fill: ", ";\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: transparent;\n\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n\n  ", ";\n"])), function (_ref112) {
    var n = _ref112.theme;
    return n.colors.blue95;
  }, function (_ref113) {
    var n = _ref113.theme;
    return n.colors.blue90;
  }, function (_ref114) {
    var n = _ref114.disabled;
    return n && Nd;
  });
/*#__PURE__*/ce(function (_ref115, t) {
  var n = _ref115.children,
    r = _objectWithoutProperties(_ref115, _excluded11);
  return /* @__PURE__ */_(Yd, _objectSpread(_objectSpread({
    ref: t
  }, r), {}, {
    children: n
  }));
});
var go = I(kd)(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 1;\n  ", ";\n"])), function (_ref116) {
    var n = _ref116.theme,
      r = _ref116.$danger;
    return r && J(["color:", ";&:hover{color:", ";}@media (hover:none){&:hover{color:", ";}}"], n.colors.red60, n.colors.red40, function (_ref117) {
      var t = _ref117.theme;
      return t.colors.red60;
    });
  }),
  vo = J(["&,&:focus{border-color:", ";}&:focus-visible{border-color:", ";}"], function (_ref118) {
    var n = _ref118.theme;
    return n.colors.red60;
  }, function (_ref119) {
    var n = _ref119.theme;
    return n.colors.red60;
  }),
  wo = I.input(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: ", "px;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 8px;\n  outline: none;\n  ", "\n\n  ::placeholder {\n    color: ", ";\n  }\n\n  &:focus {\n    border: 1px solid ", ";\n  }\n\n  &:focus-visible {\n    border: 1px solid ", ";\n  }\n\n  &:disabled {\n    background: ", ";\n    border: 1px solid ", ";\n    user-select: none;\n  }\n\n  &[aria-invalid='true'] {\n    ", "\n  }\n\n  box-sizing: border-box;\n"])), ro, function (_ref120) {
    var n = _ref120.theme;
    return n.colors.black100;
  }, function (_ref121) {
    var n = _ref121.theme;
    return n.colors.black60;
  }, ao, function (_ref122) {
    var n = _ref122.theme;
    return n.colors.black60;
  }, function (_ref123) {
    var n = _ref123.theme;
    return n.colors.blue60;
  }, function (_ref124) {
    var n = _ref124.theme;
    return n.colors.blue60;
  }, function (_ref125) {
    var n = _ref125.theme;
    return n.colors.black95;
  }, function (_ref126) {
    var n = _ref126.theme;
    return n.colors.black60;
  }, vo),
  Rd = I.textarea(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: ", "px;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 8px;\n  resize: ", ";\n  ", "\n\n  ::placeholder {\n    color: ", ";\n  }\n\n  &:focus {\n    border-color: ", ";\n    outline: 0px;\n  }\n\n  &:focus-visible {\n    border-color: ", ";\n    outline: 0px;\n  }\n\n  &:disabled {\n    background: ", ";\n    border-color: ", ";\n    user-select: none;\n  }\n\n  &[aria-invalid='true'] {\n    ", "\n  }\n\n  box-sizing: border-box;\n"])), ro, function (_ref127) {
    var n = _ref127.theme;
    return n.colors.black100;
  }, function (_ref128) {
    var n = _ref128.theme;
    return n.colors.black60;
  }, function (_ref129) {
    var n = _ref129.$resizable;
    return n ? "both" : "none";
  }, ao, function (_ref130) {
    var n = _ref130.theme;
    return n.colors.black60;
  }, function (_ref131) {
    var n = _ref131.theme;
    return n.colors.blue60;
  }, function (_ref132) {
    var n = _ref132.theme;
    return n.colors.blue60;
  }, function (_ref133) {
    var n = _ref133.theme;
    return n.colors.black95;
  }, function (_ref134) {
    var n = _ref134.theme;
    return n.colors.black60;
  }, vo),
  Ld = I.div(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  width: 100%;\n"]))),
  Fd = I(ho).attrs({
    color: "red50"
  })(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  width: 16px;\n  height: 16px;\n  margin-right: 8px;\n"]))),
  _n = /*#__PURE__*/ce(function (_ref135, B) {
    var _ref136;
    var n = _ref135.value,
      r = _ref135.placeholder,
      t = _ref135.label,
      e = _ref135.option,
      a = _ref135.render,
      o = _ref135.compact,
      i = _ref135.onChange,
      s = _ref135.onKeyUp,
      c = _ref135.onError,
      l = _ref135.onValid,
      u = _ref135.onValidation,
      d = _ref135.autofocus,
      f = _ref135.alt,
      p = _ref135.disabled,
      h = _ref135.validation,
      g = _ref135.type,
      v = _ref135.readOnly,
      w = _ref135.minLength,
      D = _ref135.maxLength,
      b = _ref135.max,
      P = _ref135.min,
      S = _ref135.step,
      _ref135$validateOnMou = _ref135.validateOnMount,
      T = _ref135$validateOnMou === void 0 ? !0 : _ref135$validateOnMou,
      y = _ref135.name,
      x = _ref135.autocomplete,
      E = _objectWithoutProperties(_ref135, _excluded12);
    var _In = In(null),
      _In2 = _slicedToArray(_In, 2),
      L = _In2[0],
      N = _In2[1],
      _In3 = In(!1),
      _In4 = _slicedToArray(_In3, 2),
      W = _In4[0],
      H = _In4[1],
      A = aa(function (X) {
        i == null || i(X), W || H(!0);
      }, [W, i]);
    Ue(function () {
      (T || n) && (!T && n && console.warn("TextField: validation on mount is enabled, because value is defined"), H(!0));
    }, []), Ue(function () {
      W && N(Ad({
        value: n,
        validation: h
      }));
    }, [W, h, n]);
    var O = (L == null ? void 0 : L.isError) || !1;
    Ue(function () {
      O ? c == null || c() : l == null || l();
    }, [O, l, c]), Ue(function () {
      u == null || u(n, !O);
    }, [O, n, u]);
    var $ = {
      placeholder: r,
      value: n,
      onChange: A,
      onKeyUp: s,
      autoFocus: d,
      disabled: p,
      alt: f,
      "aria-invalid": O,
      "aria-label": typeof t == "string" ? t : void 0,
      type: g,
      readOnly: v,
      minLength: w,
      maxLength: D,
      min: P,
      max: b,
      step: S,
      name: y,
      autoComplete: x
    };
    return /* @__PURE__ */pe(Ld, _objectSpread(_objectSpread({}, E), {}, {
      children: [/* @__PURE__ */_(Wd, {
        label: t,
        option: e,
        compact: o
      }), (_ref136 = a == null ? void 0 : a($)) !== null && _ref136 !== void 0 ? _ref136 : /* @__PURE__ */_(wo, _objectSpread({
        ref: B
      }, $)), /* @__PURE__ */_(Id, {
        isError: O,
        errorText: L == null ? void 0 : L.errorText,
        compact: o
      })]
    }));
  });
_n.displayName = "TextFieldBase";
var Id = function Id(_ref137) {
    var n = _ref137.errorText,
      r = _ref137.compact,
      t = _ref137.isError;
    return t && !!n || !r ? /* @__PURE__ */_(ad, {
      children: t && /* @__PURE__ */pe(od, {
        children: [/* @__PURE__ */_(Fd, {}), /* @__PURE__ */_(id, {
          children: n
        })]
      })
    }) : null;
  },
  $d = function $d(n) {
    return mo(n) ? {
      optionText: n.text,
      onOptionClick: n.onClick,
      optionDanger: n.danger
    } : {
      optionText: n
    };
  },
  Wd = function Wd(_ref138) {
    var n = _ref138.label,
      r = _ref138.option,
      t = _ref138.compact;
    if (!(n || r || !t)) return null;
    var _$d = $d(r),
      a = _$d.optionText,
      o = _$d.onOptionClick,
      i = _$d.optionDanger;
    return /* @__PURE__ */pe(ir, {
      children: [/* @__PURE__ */_(eo, {
        children: n && /* @__PURE__ */_(to, {
          "data-testid": "label",
          "data-id": "label",
          children: n
        })
      }), /* @__PURE__ */_(no, {
        children: r && /* @__PURE__ */_(go, {
          onClick: o,
          "data-testid": "option",
          "data-id": "option",
          $danger: i,
          children: a
        })
      })]
    });
  },
  Ad = function Ad(_ref139) {
    var n = _ref139.value,
      r = _ref139.validation;
    if (!r || typeof n != "string" && n !== void 0) return;
    var t = Array.isArray(r) ? _toConsumableArray(r) : [r];
    for (var e = 0; e < t.length; e++) {
      var _t$e = t[e],
        a = _t$e.errorText,
        o = _t$e.validate;
      var i = !1;
      if (typeof o == "string" ? i = !Hd[o](n) : typeof o == "boolean" ? i = !o : i = !o(n), i) return {
        isError: i,
        errorText: a
      };
    }
  },
  Hd = {
    email: nd,
    positiveIntegerOrZero: rd
  },
  Bd = /*#__PURE__*/ce(function (n, r) {
    return /* @__PURE__ */_(_n, _objectSpread({
      ref: r
    }, n));
  });
Bd.displayName = "TextField";
var bo = /*#__PURE__*/ce(function (n, r) {
  return /* @__PURE__ */_(_n, _objectSpread(_objectSpread({}, n), {}, {
    ref: r,
    compact: !0
  }));
});
bo.displayName = "TextFieldCompact";
var Qd = I(Md)(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  transform: translate(0, -50%);\n  right: 10px;\n"]))),
  Vd = I.div(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n"]))),
  qd = I(_n)(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  & input {\n    padding-right: 40px;\n  }\n"]))),
  yo = /*#__PURE__*/ce(function (_ref140, a) {
    var n = _ref140.isPasswordVisible,
      r = _ref140.onClick,
      t = _ref140.autocomplete,
      e = _objectWithoutProperties(_ref140, _excluded13);
    return /* @__PURE__ */pe(Vd, {
      children: [/* @__PURE__ */_(wo, _objectSpread({
        ref: a,
        autoComplete: t
      }, e)), /* @__PURE__ */_(Qd, {
        "data-testid": "toggler",
        onClick: function onClick() {
          return r(!n);
        },
        children: n ? /* @__PURE__ */_(po, {
          size: 16
        }) : /* @__PURE__ */_(fo, {
          size: 16
        })
      })]
    });
  });
yo.displayName = "InputWithToggler";
var Kd = /*#__PURE__*/ce(function (n, r) {
  var _In5 = In(!1),
    _In6 = _slicedToArray(_In5, 2),
    t = _In6[0],
    e = _In6[1];
  return /* @__PURE__ */_(qd, _objectSpread(_objectSpread({}, n), {}, {
    "data-testid": "textbox-password",
    type: t ? "text" : "password",
    render: function render(a) {
      return /* @__PURE__ */_(yo, _objectSpread({
        ref: r,
        isPasswordVisible: t,
        onClick: e
      }, a));
    }
  }));
});
Kd.displayName = "PasswordTextField";
var jd = I.div(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  width: 100%;\n"]))),
  zd = /*#__PURE__*/ce(function (_ref141, c) {
    var _ref141$value = _ref141.value,
      n = _ref141$value === void 0 ? "" : _ref141$value,
      r = _ref141.label,
      t = _ref141.option,
      e = _ref141.compact,
      a = _ref141.autofocus,
      o = _ref141.className,
      i = _ref141.resizable,
      s = _objectWithoutProperties(_ref141, _excluded14);
    return /* @__PURE__ */pe(jd, {
      className: o,
      children: [/* @__PURE__ */_(Xd, {
        label: r,
        option: t,
        compact: e
      }), /* @__PURE__ */_(Rd, _objectSpread({
        value: n,
        autoFocus: a,
        "aria-label": typeof r == "string" ? r : void 0,
        $resizable: i,
        ref: c
      }, s))]
    });
  });
zd.displayName = "TextAreaField";
var Ud = function Ud(n) {
    return mo(n) ? {
      optionText: n.text,
      onOptionClick: n.onClick,
      optionDanger: n.danger
    } : {
      optionText: n
    };
  },
  Xd = function Xd(_ref142) {
    var n = _ref142.label,
      r = _ref142.option,
      t = _ref142.compact;
    if (!(n || r || !t)) return null;
    var _Ud = Ud(r),
      a = _Ud.optionText,
      o = _Ud.onOptionClick,
      i = _Ud.optionDanger;
    return /* @__PURE__ */pe(ir, {
      children: [/* @__PURE__ */_(eo, {
        children: n && /* @__PURE__ */_(to, {
          "data-testid": "label",
          "data-id": "label",
          children: n
        })
      }), /* @__PURE__ */_(no, {
        children: r && /* @__PURE__ */_(go, {
          onClick: o,
          "data-testid": "option",
          "data-id": "option",
          $danger: i,
          children: a
        })
      })]
    });
  },
  Gd = I.label(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  position: relative;\n\n  input {\n    cursor: pointer;\n    padding: 8px 24px 8px 8px;\n    width: 256px;\n  }\n\n  input:not(:disabled) {\n    ", ";\n  }\n\n  svg {\n    position: absolute;\n    bottom: 12px;\n    right: 8px;\n    pointer-events: none;\n  }\n\n  &:hover {\n    input {\n      border-color: ", ";\n    }\n\n    svg {\n      fill: ", ";\n      stroke: ", ";\n    }\n  }\n\n  ", "\n"])), function (_ref143) {
    var n = _ref143.theme,
      r = _ref143.$active;
    return r && "border-color: ".concat(n.colors.blue50);
  }, function (_ref144) {
    var n = _ref144.theme;
    return n.colors.blue50;
  }, function (_ref145) {
    var n = _ref145.theme,
      r = _ref145.$active;
    return r ? n.colors.blue50 : n.colors.blue30;
  }, function (_ref146) {
    var n = _ref146.theme,
      r = _ref146.$active;
    return r ? n.colors.blue50 : n.colors.blue30;
  }, function (_ref147) {
    var n = _ref147.disabled;
    return n && "pointer-events: none;";
  }),
  Do = /*#__PURE__*/m.forwardRef(function (_ref148, i) {
    var n = _ref148.formattedValue,
      r = _ref148.disabled,
      t = _ref148.dateSelected,
      e = _ref148.active,
      a = _ref148.placeholderText,
      o = _objectWithoutProperties(_ref148, _excluded15);
    return /* @__PURE__ */pe(Gd, {
      $active: e,
      $dateSelected: t,
      disabled: r,
      children: [/* @__PURE__ */_(bo, _objectSpread(_objectSpread({}, o), {}, {
        disabled: r,
        value: n,
        placeholder: a,
        ref: i,
        readOnly: !0
      })), /* @__PURE__ */_(lo, {
        size: 16,
        disabled: r
      })]
    });
  });
Do.displayName = "DatePickerInput";
var Zd = I.div(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  position: relative;\n  margin-bottom: 16px;\n"]))),
  Jd = I.span(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, 0);\n  font-size: 16px;\n  line-height: 24px;\n  color: ", ";\n  white-space: nowrap;\n"])), function (_ref149) {
    var n = _ref149.theme;
    return n.colors.black10;
  }),
  ef = I.div(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"]))),
  ea = I.button(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n"]))),
  tf = function tf(_ref150) {
    var n = _ref150.date,
      r = _ref150.decreaseMonth,
      t = _ref150.increaseMonth,
      e = _ref150.prevMonthButtonDisabled,
      a = _ref150.nextMonthButtonDisabled;
    var o = ct(n, "MMMM yyyy");
    return /* @__PURE__ */pe(Zd, {
      children: [/* @__PURE__ */_(Jd, {
        children: o
      }), /* @__PURE__ */pe(ef, {
        children: [/* @__PURE__ */_(ea, {
          onClick: r,
          disabled: e,
          "data-testid": "datepicker-prev-month-btn",
          children: /* @__PURE__ */_(co, {
            size: 24,
            disabled: e
          })
        }), /* @__PURE__ */_(ea, {
          onClick: t,
          disabled: a,
          "data-testid": "datepicker-next-month-btn",
          children: /* @__PURE__ */_(uo, {
            size: 24,
            disabled: a
          })
        })]
      })]
    });
  },
  ae = 16,
  sr = I.div(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n  &.react-datepicker {\n    width: 256px;\n    padding: 24px 16px;\n    border: none;\n    border-radius: 8px;\n    ", "\n\n    .react-datepicker__header {\n      padding-top: 0;\n      border: 0;\n      background: none;\n    }\n\n    .react-datepicker__month-container {\n      float: none;\n    }\n\n    .react-datepicker__month {\n      margin: 0;\n    }\n\n    .react-datepicker__day,\n    .react-datepicker__day-name {\n      width: 31px;\n      font-size: 13px;\n      line-height: 28px;\n      user-select: none;\n    }\n\n    .react-datepicker__day {\n      color: ", ";\n      margin: 4px 0;\n      vertical-align: middle;\n\n      &--outside-month,\n      &--disabled {\n        color: ", ";\n      }\n\n      &--disabled {\n        pointer-events: none;\n        cursor: not-allowed;\n      }\n\n      &--keyboard-selected {\n        background-color: transparent;\n      }\n\n      &--selected {\n        border-radius: ", "px;\n        background-color: ", ";\n      }\n\n      &:focus {\n        outline: none;\n      }\n\n      &:hover:not(.react-datepicker__day--disabled) {\n        border-radius: ", "px;\n        background-color: ", ";\n      }\n    }\n\n    .react-datepicker__day-name {\n      margin: 0;\n      color: ", ";\n    }\n  }\n"])), sd, function (_ref151) {
    var n = _ref151.theme;
    return n.colors.black10;
  }, function (_ref152) {
    var n = _ref152.theme;
    return n.colors.black70;
  }, ae, function (_ref153) {
    var n = _ref153.theme;
    return n.colors.black95;
  }, ae, function (_ref154) {
    var n = _ref154.theme;
    return n.colors.blue90;
  }, function (_ref155) {
    var n = _ref155.theme;
    return n.colors.black70;
  }),
  nf = I(sr)(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral([""]))),
  rf = I(sr)(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n  &.react-datepicker {\n    .react-datepicker__day {\n      &--in-range {\n        background-color: ", ";\n        border-radius: 0;\n\n        &:first-child,\n        &.react-datepicker__day--range-start {\n          border-top-left-radius: ", "px;\n          border-bottom-left-radius: ", "px;\n        }\n\n        &:last-child,\n        &.react-datepicker__day--range-end {\n          border-top-right-radius: ", "px;\n          border-bottom-right-radius: ", "px;\n        }\n\n        ", "\n      }\n\n      &--in-selecting-range {\n        border-radius: 0;\n        background-color: ", ";\n\n        &:first-child,\n        &.react-datepicker__day--selecting-range-start {\n          border-top-left-radius: ", "px;\n          border-bottom-left-radius: ", "px;\n        }\n\n        &:last-child,\n        &.react-datepicker__day--selecting-range-end {\n          border-top-right-radius: ", "px;\n          border-bottom-right-radius: ", "px;\n        }\n\n        &:hover:not(:first-child) {\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0;\n        }\n\n        ", "\n      }\n    }\n  }\n"])), function (_ref156) {
    var n = _ref156.theme;
    return n.colors.black95;
  }, ae, ae, ae, ae, function (_ref157) {
    var n = _ref157.$freezeStartDate,
      r = _ref157.$hovered;
    return n && r && J(["background-color:unset;&:not(.react-datepicker__day--in-selecting-range){background-color:transparent;}&.react-datepicker__day--range-end{border-radius:0;}"]);
  }, function (_ref158) {
    var n = _ref158.theme,
      r = _ref158.$freezeStartDate,
      t = _ref158.$hovered;
    return r && !t ? n.colors.black95 : n.colors.blue90;
  }, ae, ae, ae, ae, function (_ref159) {
    var n = _ref159.theme,
      r = _ref159.$freezeStartDate,
      t = _ref159.$hovered;
    return r && !t && J(["background-color:", ";"], n.colors.black95);
  }),
  af = I(sr)(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n  &.react-datepicker {\n    .react-datepicker__day--in-range {\n      border-radius: 0;\n      background-color: ", ";\n\n      &:first-child,\n      &.react-datepicker__day--range-start {\n        border-top-left-radius: ", "px;\n        border-bottom-left-radius: ", "px;\n      }\n\n      &:last-child,\n      &.react-datepicker__day--range-end {\n        border-top-right-radius: ", "px;\n        border-bottom-right-radius: ", "px;\n      }\n    }\n\n    .react-datepicker__week:hover {\n      .react-datepicker__day {\n        &:not(.react-datepicker__day--disabled) {\n          background-color: ", ";\n          border-radius: 0;\n        }\n\n        &:first-child,\n        &.react-datepicker__day--min-available {\n          border-top-left-radius: ", "px;\n          border-bottom-left-radius: ", "px;\n        }\n\n        &:last-child,\n        &.react-datepicker__day--max-available {\n          border-top-right-radius: ", "px;\n          border-bottom-right-radius: ", "px;\n        }\n      }\n    }\n  }\n"])), function (_ref160) {
    var n = _ref160.theme;
    return n.colors.black95;
  }, ae, ae, ae, ae, function (_ref161) {
    var n = _ref161.theme;
    return n.colors.blue90;
  }, ae, ae, ae, ae),
  of = {
    plain: nf,
    range: rf,
    week: af
  },
  sf = function sf(_ref162) {
    var n = _ref162.type,
      r = _objectWithoutProperties(_ref162, _excluded16);
    if (!n) return null;
    var t = of[n];
    return /* @__PURE__ */_(t, _objectSpread({}, r));
  },
  cf = "Select date",
  lf = "Select dates",
  uf = "Select week",
  qt = "MMM dd",
  df = "dd",
  ff = "datepicker-portal",
  ta = function ta(_ref163) {
    var n = _ref163.startDate,
      r = _ref163.endDate,
      t = _ref163.type;
    if (t === "range" || t === "week") return n && r ? $n(n, r) ? ct(n, qt) : "".concat(ct(n, qt), " \u2013 ").concat(Yi(n, r) ? ct(r, df) : ct(r, qt)) : void 0;
    if (n) return ct(n, qt);
  },
  pf = function pf(n, r) {
    var t = ft(n, {
      weekStartsOn: 1
    });
    return r && la(t, r) < 0 ? r : t;
  },
  hf = function hf(n, r) {
    var t = Ro(n, {
      weekStartsOn: 1
    });
    return r && la(r, t) < 0 ? r : t;
  },
  mf = function mf(n, r, t) {
    var e = n ? pf(n, r) : null,
      a = e ? hf(e, t) : null;
    return [e, a];
  },
  gf = (_Gr$default = Gr.default) !== null && _Gr$default !== void 0 ? _Gr$default : Gr,
  vf = "plain",
  wf = oa(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n  .react-datepicker {\n    font-family: inherit;\n\n    .react-datepicker__header {\n      padding-bottom: 4px;\n    }\n\n    .react-datepicker__day-names {\n      margin-bottom: 0;\n    }\n  }\n\n  ", "\n"])), function (_ref164) {
    var n = _ref164.theme,
      r = _ref164.portalId;
    return r && J(["#", " .react-datepicker-popper{z-index:", ";}"], r, n.zIndex.datePicker);
  }),
  bf = /*#__PURE__*/m.forwardRef(function (_ref165, D) {
    var _ref165$type = _ref165.type,
      n = _ref165$type === void 0 ? vf : _ref165$type,
      r = _ref165.disabled,
      t = _ref165.minDate,
      e = _ref165.maxDate,
      a = _ref165.onChange,
      _ref165$flip = _ref165.flip,
      o = _ref165$flip === void 0 ? !1 : _ref165$flip,
      _ref165$preventOverfl = _ref165.preventOverflow,
      i = _ref165$preventOverfl === void 0 ? !1 : _ref165$preventOverfl,
      s = _ref165.placeholderText,
      _ref165$portalId = _ref165.portalId,
      c = _ref165$portalId === void 0 ? ff : _ref165$portalId,
      l = _ref165.onCalendarVisibilityChange,
      u = _ref165.freezeStartDate,
      d = _ref165.label,
      f = _ref165.startDate,
      p = _ref165.endDate,
      h = _ref165.customInput,
      _ref165$popperPlaceme = _ref165.popperPlacement,
      g = _ref165$popperPlaceme === void 0 ? "bottom-start" : _ref165$popperPlaceme,
      _ref165$popperOffset = _ref165.popperOffset,
      v = _ref165$popperOffset === void 0 ? [0, -10] : _ref165$popperOffset,
      w = _objectWithoutProperties(_ref165, _excluded17);
    var _m$useState = m.useState(!1),
      _m$useState2 = _slicedToArray(_m$useState, 2),
      b = _m$useState2[0],
      P = _m$useState2[1],
      _m$useState3 = m.useState(f),
      _m$useState4 = _slicedToArray(_m$useState3, 2),
      S = _m$useState4[0],
      T = _m$useState4[1],
      _m$useState5 = m.useState(p),
      _m$useState6 = _slicedToArray(_m$useState5, 2),
      y = _m$useState6[0],
      x = _m$useState6[1],
      _m$useState7 = m.useState(ta({
        startDate: S,
        endDate: y,
        type: n
      })),
      _m$useState8 = _slicedToArray(_m$useState7, 2),
      E = _m$useState8[0],
      B = _m$useState8[1],
      L = m.useMemo(function () {
        return s || (n === "range" ? lf : n === "week" ? uf : cf);
      }, [s, n]),
      _m$useState9 = m.useState(!1),
      _m$useState10 = _slicedToArray(_m$useState9, 2),
      N = _m$useState10[0],
      W = _m$useState10[1],
      H = n === "range" && u,
      A = m.useCallback(function (X, ve) {
        var _re$, _re$2, _re, _re2;
        var re = X;
        n === "week" && (re = mf(X, t, e)), Array.isArray(re) ? (T((_re$ = re[0]) !== null && _re$ !== void 0 ? _re$ : void 0), x((_re$2 = re[1]) !== null && _re$2 !== void 0 ? _re$2 : void 0)) : H ? x((_re = re) !== null && _re !== void 0 ? _re : void 0) : T((_re2 = re) !== null && _re2 !== void 0 ? _re2 : void 0), a(re, ve);
      }, [e, t, a, H, n]),
      O = m.useMemo(function () {
        var X = [Ha({
          mainAxis: v[1],
          crossAxis: v[0]
        })];
        return o && X.push(Ba()), i && X.push(Rl()), X;
      }, [o, v, i]),
      R = m.useCallback(function (X) {
        if (["range", "week"].includes(n) && (t || e)) {
          if (t && $n(X, t)) return "react-datepicker__day--min-available";
          if (e && $n(X, e)) return "react-datepicker__day--max-available";
        }
        return "";
      }, [e, t, n]);
    m.useEffect(function () {
      l == null || l(b);
    }, [l, b]), m.useEffect(function () {
      B(ta({
        startDate: S,
        endDate: y,
        type: n
      }));
    }, [S, y, n]), m.useEffect(function () {
      T(f);
    }, [f]), m.useEffect(function () {
      x(p);
    }, [p]), m.useEffect(function () {
      n === "plain" && x(void 0);
    }, [n]);
    var $ = m.useRef(null);
    return m.useImperativeHandle(D, function () {
      return $.current;
    }), /* @__PURE__ */pe(_o, {
      children: [/* @__PURE__ */_(gf, _objectSpread(_objectSpread({}, w), {}, {
        customInput: h || /* @__PURE__ */_(Do, {
          formattedValue: E,
          placeholderText: L,
          active: b,
          disabled: r,
          dateSelected: !!S,
          label: d
        }),
        renderCustomHeader: function renderCustomHeader(X) {
          return /* @__PURE__ */_(tf, _objectSpread({
            startDate: S
          }, X));
        },
        formatWeekDay: function formatWeekDay(X) {
          return X.substring(0, 1);
        },
        calendarStartDay: 1,
        calendarContainer: function calendarContainer(_ref166) {
          var X = _extends({}, (_objectDestructuringEmpty(_ref166), _ref166));
          return /* @__PURE__ */_(sf, _objectSpread(_objectSpread({}, X), {}, {
            type: n,
            $freezeStartDate: u,
            $hovered: N
          }));
        },
        startDate: S,
        endDate: y,
        minDate: H ? S !== null && S !== void 0 ? S : void 0 : t,
        maxDate: e,
        selected: H ? y : S,
        onCalendarOpen: function onCalendarOpen() {
          return P(!0);
        },
        onCalendarClose: function onCalendarClose() {
          P(!1), W(!1);
        },
        popperPlacement: g,
        popperModifiers: O,
        selectsRange: n === "range" && !H,
        selectsEnd: H,
        focusSelectedMonth: !0,
        disabled: r,
        disabledKeyboardNavigation: !0,
        ref: $,
        onChange: A,
        dayClassName: R,
        portalId: c !== null && c !== void 0 ? c : void 0,
        shouldCloseOnSelect: !0,
        onDayMouseEnter: function onDayMouseEnter() {
          N || W(!0);
        },
        onMonthMouseLeave: function onMonthMouseLeave() {
          return W(!1);
        },
        preventOpenOnFocus: !0,
        showPopperArrow: !1
      })), /* @__PURE__ */_(wf, {
        portalId: c
      })]
    });
  });
bf.displayName = "DatePicker";
export { bf as DatePicker };